import React, { Component } from 'react'
import ExplanationGallery from '../../../ui/takeQuiz/ExplanationGallery'
import FreeChoiceCategorySelectionPage from '../../../ui/takeQuiz/FreeChoiceCategorySelectionPage'
//Custom Components
import SplashScreen from '../../../ui/takeQuiz/SplashScreen'
import TakeQuizContainer from '../../../ui/takeQuiz/TakeQuizContainer'
import ScoreWheel from '../../../ui/takeQuiz/ScoreWheel'
import MobileScoreWheel from '../../../ui/takeQuiz/MobileScoreWheel'
import QuestionWithImage from '../../../ui/takeQuiz/QuestionWithImage'
import NavigationButton from '../../../ui/takeQuiz/NavigationButton'
import questionImage from '../../../images/png/dummyQuestion1.png'
import LoadingSpinner from '../../../components/LoadingSpinner';
import { BeatLoader } from 'react-spinners';
import MomentTz from 'moment-timezone'
import FeedbackPopup from '../../../ui/takeQuiz/FeedbackPopup'
import TextEditor from '../../../components/TextEditor'
import { convertFromRaw, EditorState } from 'draft-js';
import QuizProgressBar from '../../../ui/takeQuiz/QuizProgressBar'
import { isMobile, isBrowser } from 'react-device-detect';
import '../../../css/TakeQuiz.css';
import LiveAnalytics from '../../../ui/takeQuiz/liveAnalytics'
import MathParserUtil from '../../../lib/math-parser'
import { MQTOptions } from '../../../lib/mqt';
import VectorParser, { VectorVariableMap } from '../../../lib/vector-math-parser';
import { NotificationManager } from 'react-notifications';
import VectorParserUtil from '../../../lib/vector-math-parser'
import { AppSetting, AppProperties, createVideoLinkIframe } from '../../../common/functions';
import { GlobalContext } from '../../../GlobalContext'

import { Button, Card, CardContent, CardHeader, LinearProgress, Typography, Grid, Snackbar, Alert, IconButton, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions, Tooltip } from '@mui/material'
import SFCategoryProgressCard from './components/SFCategoryProgressCard'
import "./style.css"
import { FaRegClock } from "react-icons/fa6";
import { TbTargetArrow } from "react-icons/tb";
import SFAssignmentCompletion from '../SFAssignmentCompletion/SFAssignmentCompletion';
import VerticalProgress from './components/VerticalProgress';
import MathJax from '../../../components/react-mathjax-preview';
import SFMCRadioTypeAnswers from './components/answers/SFMCRadioTypeAnswers'
import SFFeedbackPopup from './components/SFFeedbackPopup'
import SFMCChecboxTypeAnswers from './components/answers/SFMCChecboxTypeAnswers'
import SFTextboxTypeAnswer from './components/answers/SFTextboxTypeAnswer'
import AnswerTypeRPTextBox from '../../../ui/takeQuiz/AnswerTypeRPTextBox'
import MQTQuestion from '../../../ui/takeQuiz/mqt/MQTQuestion'
import { VectorAnswers, VectorQuestion } from '../../../ui/takeQuiz/vectors'
import SFVectorTypeAnswer from './components/answers/SFVectorTypeAnswer'
import SFQuestionAndAnswer from './components/SFQuestionAndAnswer'
import { Cell, DialogContainer } from 'react-md'
import SFTakequizNavbar from './components/SFTakequizNavbar'
import KeyBoardInstruction from '../../../components/KeyBoardInstruction'
import { FaRegCircleCheck } from "react-icons/fa6";
import { CgCloseO } from "react-icons/cg";
import SFExplanation from './components/SFExplanation'
import SFSplashScreen from './components/SFSplashScreen'
import { FiTarget } from "react-icons/fi";
import { FaCaretUp, FaCaretDown, FaCheckCircle } from "react-icons/fa";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { confirmAlert } from 'react-confirm-alert';
import { IoCheckmark } from "react-icons/io5";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import { FaBookmark, FaRegBookmark } from "react-icons/fa6";
import Bookmark from './components/Bookmark'
import SFOnePageTest from './components/SFOnePageTest'
import { VariableMap } from '../../../lib/types'
import moment from 'moment-timezone'
import math, { simplify } from "mathjs";
import { TbClockHour5 } from "react-icons/tb";


import {
  checkIsDecimalOnly, checkIsENotationOnly, countSignificantFiguresForScifi,
  countSignificantFigures
} from "../../../../src/components/vectors/commonHelpers"
import SFDotsProgress from './components/SFDotsProgress'
import SFPauseCategory from './components/SFPauseCategory'
import SFInfoIcon from './components/SFInfoIcon'
import SFSingleQuestionAnswerView from './SFSingleQuestionAnswerView'
import { AutomationType, CheckDateValidation, CheckEmailValidation, CheckNumberValidation } from '../../../common/constants'
import SFTakeTutorials from './components/SFTakeTutorials'
import ExplanationAndTutorials from './components/ExplanationsAndTutorials'
import { FaBookOpen } from "react-icons/fa";



const quizBundleDummy = {
  'splashScreen': 'During this unit, you will be presented with a variety of math or physics questions, which will help in the design and improvement of Essential Skills units. You may not  know how to answer some of these questions, and this is ok. We want to gauge how  much you already know about these topics to help us construct future instructional modules.  If you are unsure of how to approach a question, make the best guess you can without consulting  outside materials. Your grade will be changed to show full credit (after this unit closes) for giving  an honest effort on every problem.',
  'quizName': 'Demo Quiz'

};



var submitClickInProgress = false; // Semaphore to prevent double click
var remainingCatSubcatMap = {}; //CategoryID - Array(SubcategorieIDs)
var totalSCCount = 0;
var remaningSubCatCount = 0;
var remainingCategorySet = [];
var currentCategoryCounter = 0;
const breakCheck = 50;
// const isDebug = true;


//var totalSCCountegoriesSet = new Set();

export default class SFTakeQuiz extends Component {
  AppSetting = AppSetting();
  appProperties = AppProperties();
  timeZone = this.appProperties.currentUserData.timeZone || 'America/New_York'
  static contextType = GlobalContext
  constructor(props) {
    super(props)
    this.params = new URLSearchParams(this.props.location.search)
    this.state = this.resetState();

    this.questionStartTimeStamp = "";
    this.state.gnbCount = -1;


    this.saveElapsedTimeForExplanations = this.saveElapsedTimeForExplanations.bind(this);
    this.onExplanationClick = this.onExplanationClick.bind(this);
    this.onStartClick = this.onStartClick.bind(this);
    this.onSubmitClick = this.onSubmitClick.bind(this);
    this.onPrevClick = this.onPrevClick.bind(this);
    this.onNextClick = this.onNextClick.bind(this);
    this.onAnswerEntered = this.onAnswerEntered.bind(this);
    this.createCategoryValue = this.createCategoryValue.bind(this);
    this.getRandomQuestion = this.getRandomQuestion.bind(this);
    this.nextCategory = this.nextCategory.bind(this);
    this.onAnswerClick = this.onAnswerClick.bind(this);
    this.checkAnswerIsCorrect = this.checkAnswerIsCorrect.bind(this);
    this.removeElementFromArray = this.removeElementFromArray.bind(this);
    this.saveProgress = this.saveProgress.bind(this);
    this.showCorrectAnswer = this.showCorrectAnswer.bind(this);
    this.onSaveAndExit = this.onSaveAndExit.bind(this);
    this.appendExplanations = this.appendExplanations.bind(this);
    this.createTempCategorySubcategoryMap = this.createTempCategorySubcategoryMap.bind(this);


    this.saveSurvey = this.saveSurvey.bind(this);
    this.displaySurveyQuestion = this.displaySurveyQuestion.bind(this);
    this.fetchSurveyQuestions = this.fetchSurveyQuestions.bind(this);
    this.updateQuizAttemptInDB = this.updateQuizAttemptInDB.bind(this);
    this.handleGetNextBatch = this.handleGetNextBatch.bind(this);
    this.surveyBtnClick = this.surveyBtnClick.bind(this);
    this.getExplanationData = this.getExplanationData.bind(this);
    this.onFeedbackClick = this.onFeedbackClick.bind(this);
    this.onFeedbackCloseClick = this.onFeedbackCloseClick.bind(this);
    this.findFeedbackText = this.findFeedbackText.bind(this);
    this.getLiveAnalytics = this.getLiveAnalytics.bind(this);
    this.liveAnalyticsClick = this.liveAnalyticsClick.bind(this);
    this.onliveAnalyticsCloseClick = this.onliveAnalyticsCloseClick.bind(this);
    this.onShowCategorySelection = this.onShowCategorySelection.bind(this);
    this.onStartQuiz = this.onStartQuiz.bind(this);
    this.GetSelectedCategories = this.GetSelectedCategories.bind(this);
    this.onResetToPreviousGNB = this.onResetToPreviousGNB.bind(this);
    this.loadStateFromLocalStorage = this.loadStateFromLocalStorage.bind(this);
    this.dummyClientLogApiCall = this.dummyClientLogApiCall.bind(this);

    window.localStorage.setItem("gnbArr", JSON.stringify([]))
  }

  quizTimerTimeOut = null;

  resetState = () => {
    return ({
      parentQuizID: parseInt(this.params.get("parent_quiz_id") ?? "0", 10),
      isDebug: false,
      quizId: parseInt(this.params.get("quiz_id"), 10),
      userId: window.localStorage.getItem(this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + "USER_NAME"),//"test144",//this.props.match.params.quiz_name,
      quizName: decodeURIComponent(this.params.get("quiz_name")),
      courseName: decodeURIComponent(this.params.get("course_name")),
      courseID: parseInt(this.params.get("course_id")),
      quizBundle: quizBundleDummy,
      subSectionID: 0,
      showSplashScreen: true,
      showAnswerResponse: false,
      answerCorrect: true,
      hideNext: true,
      hidePrev: true,
      hideSubmit: false,
      subcategoriesArr: null,
      questionArr: null,
      elapsedTime: 0,
      categoriesMap: {},// categoryID - category name,score
      subTopcatSubcatMap: {},
      subCategoryCategoryMap: {}, // subcategoryID - categoryId,category name
      NOCQCMap: {},//categoryID - categoryFlag
      catNOCQCMap: {},
      SCQCMap: {},
      subCQCMap: {},
      CatRI: {},
      SubCatRI: {},
      SQCBackup: {},
      categoryQuestionsMap: {},//categoryId - question array
      categorySubcategoryMap: {}, //CategoryID - Array(SubcategorieIDs)
      subCategoryQuestionMap: {}, // SubCategoryID - Array(QuestionsIDs)
      questionMap: {}, //QuestionID - QuestionValue and answer array
      CSAPMap: {},// categoryID - index of the Cat's Subcat array
      IsCatChoosenFTGNB: {},//
      categoryAvailableQuestion: {},
      subcategoryAvailableQuestion: {},
      subCategoryQuestionsCount: {},
      correctAnswerMap: {},// subjectID_TopicID_categoryID_subcategoryID_QuestionID - AnswerID
      subcategoriesMap: {},// subcategoryID - subcatArr
      surveyQuestionMap: {}, // subjectID_TopicID_categoryID_subcategoryID_QuestionID - Question values
      surveyQuestionAnswerMap: {},// subjectID_TopicID_categoryID_subcategoryID_QuestionID - answer array
      surveyQuestionIdArr: [], //question_id array
      surveyQPointer: 0,
      surveyPreviousQuestionId: 0,
      correctAnswerArr: [],
      categoryArray: [],
      categorySet: [],
      categoryForWheel: [],
      isFirstQuestion: true,
      isCategoryRandom: true,
      hasMasteredQuiz: false,
      getNextBatch: false,
      categoryArrayIndex: 0,
      randomCategory: 0,
      NOCQC: 1,
      questionLength: 0,
      isLockedOut: false,
      QSS: new Set(),
      surveyQuestion: false,
      randomQuestionID: 0,
      randomQuestion: 0,
      randomSubCategory: 0,
      RandomSubcategoryOrder: new Set(),
      currentQuestionType: 0,
      currentVariableMap: undefined,
      displayQuestionText: "",
      displayAnswerArr: [],
      answerType: 0,
      forCheckBoxQuestion: 1,
      selectedAnswer: [],
      masteryCount: 0,
      maxWrong: 0,
      skillsMasterd: 0,
      numberOfCategories: 0,
      skillTotal: 0,
      completedCategoryArray: [],
      questionsCorrect: 0,
      questionsAttended: 0,
      checkedAnswerIs: [],
      quizAttempt: 0,
      allQOver: true,
      submitButtonDisplay: true,
      tryAgainButtonDisplay: false,
      masteredCategories: [],
      tryAgainCount: 1,
      forceUpdateHandler: false,
      displayCorrectAnswer: false,
      splashScreen: "",
      endSplashScreen: "",
      isTest: parseInt(this.params.get("quiz_type")),
      tutorialReadOnly: this.params.get("tutorialReadOnly") === "true",
      isTimerEnabled: false,
      pageLoading: true,
      gnbLoading: false,
      surveyQuestionsRetrieved: false,
      isSurveyOn: 0,
      showSkip: false,
      submitClicked: false,
      showSubmitLoader: false,
      categoryMasteryCount: {},//key : sub_topc_cate value categoryMastery count\
      explanationGalleryVisible: false,
      explanations: null,
      explanationButtonDisplay: false,
      subcategoryExplanationMap: {},
      categoryExplanationMap: {},
      topicExplanationMap: {},
      subcategoryTutorialMap: {},
      feedbackPopupVisible: false,
      feedbackButtonVisible: false,
      feedbackCurrentQuestion: null,
      feedbackAnswer: null,
      feedbackOn: true,
      liveAnalyticsButtonVisible: false,
      liveAnalyticsPopup: false,
      liveAnalytics: null,
      mqt_options: {},
      isAbsoluteTimerOn: 0,
      selectedAnswerDetails: {},
      showFreeChoice: false,
      categoryIsRequired: null,
      showCategorySelectionPage: false,
      freeChoiceCount: 0,
      questionStartTime: new Date(),
      question_attempt: 1,
      currentVectorVariable: {},
      freeFormVectorOptions: {},
      vectorBelowQuestionText: '',
      isGNBCallFirstQuestion: {},
      categoryRandomizedKeys: [],
      CRQMap: {},
      SCRQMap: {},
      isResetSubCatWeight: {},
      CategoryNoOfQuestions: {},
      NumberOfAttendedQuestions: {},
      practiceCount: 0,
      allowPractice: true,
      isCurrentQuestionNonGraded: false,
      reasoningElements: [],
      connectingWords: [],
      conclusionSentences: [],
      isConclusionSentenceRequired: false,
      reasoningChainAnswerFormat: "",
      showReasoningElementCategoryInfo: false,

      currentAccuracyGoal: 0,
      currentTimeGoal: 0,
      splashScreenCategories: [],
      categoriesData: [],
      categoryAccuracyGoal: 0,
      categoryTimeGoal: 0,
      count: 0, // this is for simple local question count check
      hideNavAndCat: false,
      hideQuestion: false,
      showSaveAndExit: false,
      invalidQuiz: false, // to check whether student attended the LTI assignment from canvas and not directlty logging to SF
      //   catRoundCompleted:[]
      carmenAssignmentLink: "",
      mainQAArray: [], // for one page test mode
      answersMap: {},
      scientificAnswerEvalMap: {},
      bookmarkQuestionIDMap: {},
      isAllQuestionsAnswered: true,
      onePageTestSaving: false,
      onePageTestLoading: false,

      categoryPositionMap: null,
      showTutorials: false,
    })
  }


  resetUI = () => {
    this.setState({
      questionStartTime: new Date(),
      feedbackPopupVisible: false,
      feedbackOn: true,
      feedbackAnswer: null,
      liveAnalytics: null,
      liveAnalyticsButtonVisible: false,
      liveAnalyticsPopup: false,
      showMQTAnswers: false, //Disable Show Correct Answer for MQT
      question_attempt: 1,
    })
    console.debug("resetUI");
    this.setState({ feedbackButtonVisible: false });

    this.setState({
      showSkip: false,
      hideNext: true
    });
    //this.setState({hideNext:true});

    this.setState({
      displayCorrectAnswer: false,
      submitButtonDisplay: true,
      tryAgainButtonDisplay: false,
      tryAgainCount: 1,
      selectedAnswer: [],
      explanationButtonDisplay: false,
      showRPAnswer: false,
      showVectorAnswer: false,
      //displayAnswerArr:[],
    }, () => {
      let tempQuestionID = `${this.state.randomSubCategory}_${this.state.randomQuestionID}`;
      if (tempQuestionID) {
        console.debug("tempQuestionID>>", tempQuestionID)
        this.getQuestionAnswerState(tempQuestionID, true);
      }
    })
  }

  getDateTime = () => {
    this.startTime = new Date();
    return this.startTime;
  }


  async componentDidUpdate(prevProps, prevState) {
    if (this.state !== prevState) {
      const myAppState = this.state;
      const { updateAppState } = this.context;
      updateAppState(myAppState);
    }
    if (this.state.randomCategory !== prevState.randomCategory) {
      this.setCategoryGoals();
    }

    if (this.state.selectedAnswer !== prevState.selectedAnswer) {
      console.debug("SOMETHING HAPPENED", this.state.selectedAnswer, prevState.selectedAnswer)
    }

    if (
      ((prevState.submitClicked !== this.state.submitClicked) && this.state.submitClicked)
      || this.state.showPausedCategoryAlert
    ) {
      if (this.state.pausedCategoriesMap && Object.keys(this.state.pausedCategoriesMap).length) {
        let totalCategoryCount = this.state.categoryForWheel ? this.state.categoryForWheel.length : 0;
        let pausedCategorCount = this.state.pausedCategoriesMap ? Object.keys(this.state.pausedCategoriesMap).length : 0;
        let completedCategoryCount = this.getCompletedCategoryCount();
        let unpausedCategoryCount = totalCategoryCount - pausedCategorCount;
        if (completedCategoryCount === unpausedCategoryCount) {
          let msg = <div>
            You've completed all active categories, but some are still paused.
            <br />
            <br />
            Please click "Resume" to unpause all categories.
            {/* If you submit, you cannot come back to this assignment. */}
          </div>
          const result = await this.showAlert("Paused Categories!", msg, "Resume", "Submit");
          this.setState({
            showPausedCategoryAlert: false,
          })
          if (result) { // Resume
            this.addPausedCategories("{}")
            this.setState({
              pausedCategoriesMap: {},
              questionAnswerStates: null,
              selectedAnswer: [],
              selectedAnswers: [],
              alreadyPickedAnswer: false,
              showWelcomeBackMsg: false,
              showSubmitLoader: false,
            }, () => {
              this.getRandomQuestion();
              this.resetUI();
            })
          } else { // Submit
            this.submitAssignment();
            /* const result2 = await this.showAlert("Are you sure you want to submit?", "If you submit, you cannot come back to this assignment", "Resume", "Submit");
            if (result2) { // Resume
              this.addPausedCategories("{}")
              this.setState({
                pausedCategoriesMap: {},
                questionAnswerStates: null,
                selectedAnswer: [],
                selectedAnswers: [],
                alreadyPickedAnswer: false,
                showWelcomeBackMsg: false,
                showSubmitLoader: false,
              }, () => {
                this.getRandomQuestion();
                this.resetUI();
              })
            } else {
              this.submitAssignment();
            } */
          }

        }
      }
    }
  }

  componentDidMount() {
    const { pathname, search } = this.props.location;


    if (this.props.updateQuizURL && pathname && search) {

      this.props.updateQuizURL(pathname + search);
    }

    if (this.appProperties?.currentUserData?.isAnonymous && JSON.parse(this.appProperties?.currentUserData?.isAnonymous)) {
      this.setState({
        isAnonymous: true,
      })
      window.localStorage.setItem("anonymous_assignment_url", window.location.href)
    } else {
      this.setState({
        isAnonymous: false
      })
    }

    this.props.subscribeToZoomEvent(() => {
      console.log("Zoomed");
      this.forceUpdate();

    });


    var tempSplashScreen, tempAltSplashScreen
    //Get SPlash Screen bug-tracker#228
    if (this.props.apiService !== undefined) {
      let payload = {
        'quiz_id': this.state.quizId,
        'section_id': parseInt(this.params.get("section_id")),
        'parent_quiz_id': this.state.parentQuizID,
      };


      let responsePromise = this.props.apiService({
        method: 'POST',
        url: '/getSplashScreen',
        data: payload
      });

      responsePromise.then(res => {
        if (res.data.status === 1 && res.data.message) {
          if (res.data.message === 'not from canvas') {
            let finalURL = "";
            if (res.data.data) {
              let domain = (new URL(res.data.data)).hostname;
              let courseIDMatch = res.data.data.match(/\/courses\/(\d+)\//);
              let courseID = courseIDMatch ? courseIDMatch[1] : null;
              if (courseID) {
                finalURL = `https://${domain}/courses/${courseID}`
              }
            }
            console.debug("finalURL", finalURL)

            this.setState({
              pageLoading: false,
              showSplashScreen: true,
              quizWindowEnded: false,
              invalidQuiz: true,
              carmenAssignmentLink: finalURL,
            })
            /* NotificationManager.error('You have attended an invalid quiz. Please attend this assignment in Carmen.', 'Invalid Quiz Attempted', 8000); */
            return;
          }
          if (res.data.message === 'quiz not published') {
            this.setState({
              pageLoading: false,
              showSplashScreen: true,
              quizWindowEnded: false,
              quizNotPublished: true,
              invalidQuiz: false,
            })
          }
          if (res.data.message === 'lti assignments are not practicable') {
            this.setState({
              pageLoading: false,
              allowPractice: false,
              ltiPracticeMessage: "You have already completed this assignment."
            })
          }
          if (res.data.message === 'quiz time over') {
            if (this.state.isTest === 1) {
              this.setState({
                testWindowEnded: true, pageLoading: false,
                showSplashScreen: true
              });
              return;
            } else {
              this.setState({
                quizWindowEnded: true, pageLoading: false,
                showSplashScreen: true
              });
              return;
            }
          }
        }
        if (res.data.data !== undefined && res.data.data !== null) {
          this.setState({ practiceCount: res.data.data.practice_count, timeZone: res.data.data.timezone, isTutorial: res.data.data.is_tutorial })
          if (this.state.isTest === 1) {
            if (res.data.data.is_timer_expired !== undefined &&
              res.data.data.is_timer_expired !== null &&
              res.data.data.is_timer_expired !== '' &&
              res.data.data.is_timer_expired === 1) {
              this.setState(
                {
                  timerExpired: true,
                  pageLoading: false,
                  showSplashScreen: true
                }
              );
              return;
            } else if (res.data.data.has_completed !== undefined &&
              res.data.data.has_completed !== null &&
              res.data.data.has_completed !== '' &&
              res.data.data.has_completed === 1) {
              this.setState({
                hasCompleted: true, pageLoading: false,
                showSplashScreen: true
              });
              return;
            }
          } else if (res.data.data.has_completed !== undefined &&
            res.data.data.has_completed !== null &&
            res.data.data.has_completed !== '' &&
            res.data.data.has_completed === 1) {
            this.setState({
              hasCompleted: true, pageLoading: false,
              showSplashScreen: true
            });
            return;
          }
        }
        if (res.data.data !== undefined && res.data.data !== null) {
          if (res.data.data.splashScreen !== undefined &&
            res.data.data.splashScreen !== null &&
            res.data.data.splashScreen !== '') {
            this.setState({
              splashScreen: res.data.data.splashScreen,
              endSplashScreen: res.data.data.end_splash_screen,
              isLockedOut: res.data.data.is_locked_out,
              pageLoading: false,
              showSplashScreen: true,
              startDate: res.data.data.start_date,
              dueDate: res.data.data.due_date,
              onePageMode: res.data.data.one_page_mode,
              allowPauseCategory: res.data.data.allow_pause_category,
              showCalculator: res.data.data.show_calculator
            });
            console.debug("res.data.data.show_calculator>>??", res.data.data.show_calculator)
            tempSplashScreen = res.data.data.splashScreen
            tempAltSplashScreen = res.data.data.alt_splash_screen
            //Alt splashscreen text
            if (tempSplashScreen !== undefined && tempSplashScreen !== null &&
              tempSplashScreen !== "") {
              try {
                var altSplashText = tempAltSplashScreen
                altSplashText = altSplashText.replace(/\n/ig, ' ')
                //finding number of time image present
                var altSplashTextCount = altSplashText.split(';').length
                var imgTagCount = tempSplashScreen.split('<img').length - 1
                //console.debug((altSplashTextCount/2),"==",imgTagCount,"    ",altSplashText.split(';').length,tempSplashScreen.split('<img').length)
                if ((altSplashTextCount / 2) == imgTagCount) {
                  if (imgTagCount >= 1) {
                    console.debug("greater than 1")
                    var altSplashTextArr = altSplashText.split(';');
                    var lastPosOfImg = 0
                    console.debug(altSplashTextArr.length)
                    for (var i = 0; i <= altSplashTextArr.length - 1; i = i + 2) {
                      lastPosOfImg = tempSplashScreen.indexOf("<img", lastPosOfImg)
                      lastPosOfImg = lastPosOfImg + 4
                      var b = "  title =\"" + altSplashTextArr[i] + "\"  alt =\"" + altSplashTextArr[i + 1] + "\" "
                      var output = [tempSplashScreen.slice(0, lastPosOfImg), b, tempSplashScreen.slice(lastPosOfImg)].join('');
                      tempSplashScreen = output
                      // console.debug("test ", tempSplashScreen)
                      this.setState({
                        splashScreen: tempSplashScreen
                      })
                    }
                  }
                }
                // console.debug(imgTagCount, "position of image    ", tempSplashScreen, " ")
              } catch (e) {
                console.debug("ERROR in splash screen Alt Text  ", e)
              }
            }
            //Alt splashscreen Text
          } else {
            //Show Default Splash Screen
            this.setState({
              pageLoading: false,
              showSplashScreen: true
            });
          }
          if (res.data.data.category_is_required !== undefined &&
            res.data.data.category_is_required !== null &&
            res.data.data.category_is_required !== '' && res.data.data.is_test == 0) {
            let numberOfFreeChoice = 0;
            let catIsRequired = JSON.parse(res.data.data.category_is_required)
            Object.keys(catIsRequired).forEach(element => {
              console.debug("element", element)
              if (catIsRequired[element] === 2)
                numberOfFreeChoice++
            });
            console.debug("numberOfFreeChoice", numberOfFreeChoice)
            if (numberOfFreeChoice > 0) {
              this.setState({
                showFreeChoice: true,
                categoryIsRequired: res.data.data.category_is_required,
                freeChoiceCount: res.data.data.free_choice_count,
              });
            }
          }
        }
        if (res.data.data === null && res.data.message === "" && res.data.status === 0) {
          this.setState({ allowPractice: false, pageLoading: false });
        }
      }).finally(() => {

      }).catch(error => {
        console.error("Error when getting Quiz SplashScreen", error)

      }).finally(() => {
        this.getQuestionAnswerStates();
        this.getDotProgressData();
        this.getPausedCategories();
      });
    }
    else {
      //TODO Show Error saying makeAjaxRequest is undefined
    }
  }

  //SendElapsedTime to Server
  sendElapsedTime() {
    if (this.props.apiService !== undefined) {
      let payload = {
        'quiz_id': this.state.quizId,
        'parent_quiz_id': this.state.parentQuizID,
      };

      let responsePromise = this.props.apiService({
        method: 'POST',
        url: '/quizTestHeartBeat',
        data: payload
      });

      responsePromise.then(res => {
        if (res.data.message === "Timer Expired") {
          console.log("Timer expired!!")
          this.setState({
            testWindowEnded: true, pageLoading: false,
          });
        }
        if (res.data.data !== undefined && res.data.data !== null) {
          console.log("response from quizHeartBeat", res.data.data)
        }
      }).catch(error => {
        console.error("Error while sending QuizTestHeartBeat", error)

      });
    }
    else {
      //TODO Show Error saying makeAjaxRequest is undefined
    }
  }

  startQuizTimer() {
    this.quizTimerTimeOut = setInterval(() => {
      let newElapsedTime = this.state.elapsedTime + 1;
      this.setState({ elapsedTime: newElapsedTime })
      if (newElapsedTime % 10 === 0) {
        if (this.state.isAbsoluteTimerOn === 0) {
          this.sendElapsedTime();
        }
        if (this.state.totalTime <= (newElapsedTime / 60)) {
          this.HandleTestTimeExpired();
        }
      }
    }, 1000);
  }

  HandleTestTimeExpired() {
    this.props.handleRoute('/testTimerExpired');
  }

  stopQuizTimer() {
    if (this.state.isTest === 1 && this.state.isTimerEnabled) {
      //Send a last HeartBeat before Unmounting
      this.sendElapsedTime();

    }

    //Stop Timer if unmounted for somereason
    if (this.quizTimerTimeOut !== undefined && this.quizTimerTimeOut !== null)
      clearInterval(this.quizTimerTimeOut);

  }


  componentWillUnmount() {
    document.querySelector("#react-confirm-alert")?.remove();
    document.querySelector(".react-confirm-alert-svg")?.remove();
    this.stopQuizTimer();
  }

  createCategoryValue() {

    var tempCategoriesArr = {};
    tempCategoriesArr["categoryName"] = "";
    tempCategoriesArr["score"] = 0;
    tempCategoriesArr["questionFlag"] = 0;
    tempCategoriesArr["randomizeQuestions"] = 0;
    tempCategoriesArr["evaluateCategory"] = 0;

    return tempCategoriesArr;
  }

  onShowCategorySelection = () => {
    this.setState({
      showSplashScreen: false,
      pageLoading: true
    })
    console.debug("onShowCategorySelection")
    this.GetSelectedCategories()
  }

  onStartQuiz = (categories, clearQuestionAnswerState) => {
    this.setState({ pageLoading: true });
    console.debug("onStartQuiz")
    this.props.apiService({
      method: 'post',
      url: '/updateStudentFreeChoiceSelection',
      data: categories.map(cat =>{
        return  {
          ...cat,
          parent_quiz_id: this.state.parentQuizID,
        }
      })
    }).then(res => {
      if (res.data.status === 0) {
        if (clearQuestionAnswerState) {
          this.setState({
            questionAnswerStates: null,
            showWelcomeBackMsg: false,
          }, () => {
            this.setState({
              showSplashScreen: false,
              showCategorySelectionPage: false,
              pageLoading: true
            });
            this.onStartClick(true)
          })
        } else {
            this.setState({
              showSplashScreen: false,
              showCategorySelectionPage: false,
              pageLoading: true
            });
            this.onStartClick(true)
        }
        //this.resetUI()
      }
    }).catch(err => console.debug(err));
  }

  GetSelectedCategories = () => {
    if (this.state.showFreeChoice) {
      console.debug("GetSelectedCategories")
      this.props.apiService({
        method: 'post',
        url: '/getSelectedCategoriesForStudent',
        data: {
          quiz_id: this.state.quizId,
          parent_quiz_id: this.state.parentQuizID,
          is_tutorial: this.state.isTutorial,
        }
      }).then(res => {
        if (res.data.status === 0) {
          console.log(res)
          if (res.data.data !== null && res.data.data !== undefined) {
            this.setState({
              showSplashScreen: false,
              showCategorySelectionPage: true,
              categoryIsRequired: res.data.data.category_is_required,
              freeChoiceCount: res.data.data.free_choice_count,
              pageLoading: false
            });
          }
        }
      }).catch(err => console.debug(err));
    } else {
      this.onStartClick(true)
    }
  }

  onStartClick(isFinalscore) {
    let categoryIsRequired = this.state.freeChoiceCount
    let freeChoiceCount = this.state.freeChoiceCount
    let showFreeChoice = this.state.showFreeChoice
    let practiceCount = this.state.practiceCount
    this.setState(this.resetState(), () => {
      this.setState({
        freeChoiceCount: freeChoiceCount,
        categoryIsRequired: categoryIsRequired,
        showFreeChoice: showFreeChoice,
        showSplashScreen: false,
        practiceCount: practiceCount,
        pausedCategoriesMap: this.state.pausedCategoriesMap ? { ...this.state.pausedCategoriesMap } : {},
      });

      var isUpdatedFinalscore = false;
      const ltiUserID = this.params.get("ltiUserID");
      const payload = {

        quiz_id: this.state.quizId,
        user_id: this.state.userId,//"test123",
        quiz_name: this.state.quizName, //"test 123"
        quiz_attempt: this.state.quizAttempt,
        course_id: parseInt(this.params.get("course_id")),
        section_id: parseInt(this.params.get("section_id")),
        ltiUserID: ltiUserID ? ltiUserID : "",
        parent_quiz_id: this.state.parentQuizID,
      }

      console.log("payload", payload);
      if (isFinalscore) {
        this.props.apiService({
          method: 'post',
          //url: 'http://localhost:8095/getAllQuiz',
          url: '/saveFinalScoreUpdate',
          data: payload,
        })
          .then(res => {
            if (res.data.data !== undefined && res.data.data !== null && res.data.data > 0) {
              isUpdatedFinalscore = true;
              console.log("isUpdatedFinalscore", isUpdatedFinalscore);
              this.callGetNextBatch(payload);
            }
          })
      } else {
        //Skip Calling Save Final Score Update
        this.callGetNextBatch(payload);
      }
    })

    this.getCategoriesByQuizID()
  }

  getCategoriesByQuizID() {
    this.props.apiService({
      method: 'post',
      url: '/getCategoriesByQuizID',
      data: {
        quizID: this.state.quizId,
        practiceCount: this.state.practiceCount,
        parent_quiz_id: this.state.parentQuizID,
      },
    }).then(res => {
      console.debug("res.data>>>>>>>", res.data);
      if (res && res.data && res.data.category_names) {

        this.setState({
          categoriesData: res.data.category_names,
        })
      }
    })
  }

  constructAllQuestionsAndAnswers = (gnbData) => {
    let mainQAArray = [];
    let qasArrPayload = [];

    // First gather all questionAnswerState and save only that are not present in questionAnswerStates variable
    if (gnbData && gnbData.questions) {
      gnbData.questions.forEach((question, qi) => {
        let uniqueID = `${question.subject_id}_${question.topic_id}_${question.category_id}_${question.subcategory_id}_${question.question_id}`;

        // check if unique_id is already present
        let qasIndex = this.state.questionAnswerStates?.findIndex(qas => qas.unique_id === uniqueID);
        if (qasIndex > -1) {

        } else {
          let answerDataArr = this.getAnswerFromQuestion(question);
          let answerFormula = question.answer_formula ? { ...question.answer_formula, formulaMap: question.answer_formula.formulaArray ? MathParserUtil.buildAnswerFormulasMap(question.answer_formula.formulaArray) : null } : null

          let tempVectorsVarMap;
          if (question.question_type === 3) {
            tempVectorsVarMap = VectorParser.buildQuestionVariablesMap(question.vector_question_variables);
            if (tempVectorsVarMap && tempVectorsVarMap.isValid()) {
              tempVectorsVarMap.generateValues();
            }
          }

          let currentVariableMap = this.getCurrentVariableMapFromQuestion(question, answerDataArr);

          qasArrPayload.push({
            unique_id: uniqueID,
            subject_id: question.subject_id,
            topic_id: question.topic_id,
            category_id: question.category_id,
            subcategory_id: question.subcategory_id,
            question_id: question.question_id,
            quiz_id: this.state.quizId,
            rp_variable_map_string: currentVariableMap ? currentVariableMap.toString() : "",
            vector_variable_map_string: tempVectorsVarMap ? tempVectorsVarMap.toString() : "",
            student_answer_string: "",
            parent_quiz_id: this.state.parentQuizID,
          });
        }

      })

      this.addQuestionAnswerStates(qasArrPayload, gnbData);
    }
  }

  // Construct mainQAArray
  constructMainQAArray = (gnbData) => {
    let mainQAArray = [];
    let answersMap = {};
    let bookmarkQuestionIDMap = {};
    gnbData.questions.forEach((question, qi) => {
      let uniqueID = `${question.subject_id}_${question.topic_id}_${question.category_id}_${question.subcategory_id}_${question.question_id}`;
      let answerDataArr = this.getAnswerFromQuestion(question);
      let answerFormula = question.answer_formula ? { ...question.answer_formula, formulaMap: question.answer_formula.formulaArray ? MathParserUtil.buildAnswerFormulasMap(question.answer_formula.formulaArray) : null } : null

      let qasIndex = this.state.questionAnswerStates?.findIndex(data => data.unique_id === uniqueID);

      if (qasIndex > -1) {
        let qas = this.state.questionAnswerStates[qasIndex];
        let mainQA = {
          question: question,
          uniqueID: uniqueID,
          questionID: uniqueID,
          questionIndex: qi,
          questionType: question.question_type,
          answerType: question.answer_type,
          questionText: this.constructAndReturnQuestionText(question),
          isCurrentQuestionNonGraded: question.question_nongraded === 1,
          reasoningElements: question?.reasoning_elements ? question?.reasoning_elements : [],
          connectingWords: question?.connecting_words ? question?.connecting_words : [],
          conclusionSentences: question?.conclusion_sentences ? question?.conclusion_sentences : [],
          isConclusionSentenceRequired: question?.is_conclusion_sentence_required,
          showReasoningElementCategoryInfo: question?.show_reasoning_element_category_info,
          answerDataArr: answerDataArr,
          currentVariableMap: qas.rp_variable_map_string ? VariableMap.fromString(qas.rp_variable_map_string) : undefined,
          tempVectorsVarMap: qas.vector_variable_map_string ? VectorVariableMap.fromString(qas.vector_variable_map_string) : undefined,
          answerFormula: answerFormula,
          answerDisplayStyle: question.answerDisplayStyle,
          mqtOptions: question.mqt_options,
          vectorSettingsData: question.vector_settings_data,
          vectorAnswerFormulas: question.vector_answer_formulas,
          bookmarked: qas.bookmarked,
        }
        if (qas.bookmarked) {
          bookmarkQuestionIDMap[uniqueID] = "";
        }
        if (qas.student_answer_string) {
          answersMap[uniqueID] = JSON.parse(qas.student_answer_string);
        }

        mainQAArray.push(mainQA);
      }

    });

    console.debug("mainQAArray and answersMap", mainQAArray, answersMap, bookmarkQuestionIDMap)

    this.setState({
      mainQAArray: [...this.state.mainQAArray, ...mainQAArray],
      answersMap: answersMap,
      bookmarkQuestionIDMap: bookmarkQuestionIDMap,
      pageLoading: false,
      onePageTestLoading: false,
    })
  }

  addSingleQuestionAnswerState = (payload, question) => {
    let tempQuestionID = `${question.subject_id}_${question.topic_id}_${question.category_id}_${question.subcategory_id}_${question.question_id}`;
    let qasPayload = {
      unique_id: tempQuestionID,
      subject_id: question.subject_id,
      topic_id: question.topic_id,
      category_id: question.category_id,
      subcategory_id: question.subcategory_id,
      question_id: question.question_id,
      quiz_id: this.state.quizId,
      parent_quiz_id: this.state.parentQuizID,
      other_state_map_string: JSON.stringify({
        tryAgainCount: this.state.tryAgainCount,
      }),
      delete_previous_states: true,
      ...payload,
    }
    this.setState({
      showSubmitLoader: true,
    })
    this.props.apiService({
      method: 'post',
      url: '/addQuestionAnswerState',
      data: qasPayload,
    }).then((res) => {
      console.debug("res>>>>>", res);
      let updatedQuestionAnswerStates = []
      if (this.state.questionAnswerStates && this.state.questionAnswerStates.length) {
        updatedQuestionAnswerStates = [...this.state.questionAnswerStates, qasPayload];
      } else {
        updatedQuestionAnswerStates = [qasPayload];
      }
      this.setState({
        questionAnswerStates: updatedQuestionAnswerStates,
      })
    }).finally(() => {
      this.setState({
        showSubmitLoader: false,
      })
    })
  }

  addQuestionAnswerStates(qasArrPayload, gnbData) {
    this.setState({
      onePageTestLoading: true,
    })
    this.props.apiService({
      method: 'post',
      url: '/addQuestionAnswerStates',
      data: qasArrPayload,
    }).then((res) => {
      console.debug("res>>>>>", res);
      // Now construct mainQAArray questions;
      let updatedQuestionAnswerStates = []
      if (this.state.questionAnswerStates && this.state.questionAnswerStates.length) {
        updatedQuestionAnswerStates = [...this.state.questionAnswerStates, ...qasArrPayload];
      } else {
        updatedQuestionAnswerStates = [...qasArrPayload];
      }
      this.setState({
        questionAnswerStates: updatedQuestionAnswerStates,
      }, () => {
        console.debug("this.state.questionAnswerStates>>>>", this.state.questionAnswerStates)
        this.constructMainQAArray(gnbData);
      })
    }).finally(() => {
      this.setState({
        onePageTestLoading: false,
      })
    })
  }

  getPausedCategories = () => {

    this.props.apiService({
      method: 'post',
      url: '/getPausedCategories',
      data: {
        quiz_id: this.state.quizId,
        practice_count: this.state.practiceCount,
        parent_quiz_id: this.state.parentQuizID,
      },
    }).then((res) => {
      console.debug("getPausedCategories res", res);
      let data = res?.data;
      if (data && data.message && data.status == 1) {
        NotificationManager.error("Something went wrong")
        return;
      }

      if (data && data.data) {
        let pausedCategoriesMap = JSON.parse(data.data);
        this.setState({
          pausedCategoriesMap: pausedCategoriesMap
        })
      }


    }).finally(() => {

    })
  }

  addPausedCategories = (pausedCategoriesMapJsonString) => {
    this.props.apiService({
      method: 'post',
      url: '/addPausedCategories',
      data: {
        paused_categories: pausedCategoriesMapJsonString,
        quiz_id: this.state.quizId,
        practice_count: this.state.practiceCount,
        parent_quiz_id: this.state.parentQuizID,
      },
    })
  }

  getQuestionAnswerStates() {
    this.props.apiService({
      method: 'post',
      url: '/getQuestionAnswerStates',
      data: {
        quiz_id: this.state.quizId,
        parent_quiz_id: this.state.parentQuizID,
      },
    }).then((res) => {
      console.debug("res>>>>>???", res.data.data);
      if (res && res.data && res.data.data) {
        let questionAnswerStates = res.data.data;

        if (questionAnswerStates && questionAnswerStates.length) {
          let lastQA = questionAnswerStates.reduce((latest, current) => {
            return moment(current.date_time).isAfter(latest.date_time) ? current : latest;
          }, questionAnswerStates[0]);
          if (lastQA && lastQA.date_time) {
            console.debug("MMM>>", moment(lastQA.date_time).format("h:mm a"))
            this.setState({
              lastSavedAt: moment(lastQA.date_time).format("MMM Do YY, h:mm a")
            })
          }
        }

        if (questionAnswerStates && questionAnswerStates.length) {
          this.setState({
            showWelcomeBackMsg: true,
          })
        }

        this.setState({
          questionAnswerStates: questionAnswerStates,
        })

      }
    })
  }

  getDotProgressData() {
    this.props.apiService({
      method: 'post',
      url: '/getDotProgress',
      data: {
        quiz_id: this.state.quizId,
        practice_count: this.state.practiceCount,
        parent_quiz_id: this.state.parentQuizID,
      },
    }).then((res) => {
      if (res && res.data && res.data.data) {
        this.setState({
          dotProgressMap: { ...res.data.data },
        })
      }
    })
  }


  constructAndReturnQuestionText = (question) => {
    let tempDisplayQuestionText = question.question_text;
    if (question.alt_question_text !== undefined && question.alt_question_text !== null &&
      question.alt_question_text !== "") {
      try {
        var altQueText = question.alt_question_text
        altQueText = altQueText.replace(/\n/ig, ' ')
        //finding number of time image present
        var altQueTextCount = altQueText.split(';').length
        var imgTagCount = tempDisplayQuestionText.split('<img').length - 1
        console.debug((altQueTextCount / 2), "==", imgTagCount, "    ", altQueText.split(';').length, tempDisplayQuestionText.split('<img').length)
        if ((altQueTextCount / 2) == imgTagCount) {
          if (imgTagCount >= 1) {
            console.debug("greater than 1")
            var altQueTextArr = altQueText.split(';');
            var lastPosOfImg = 0
            console.debug(altQueTextArr.length)
            for (var i = 0; i <= altQueTextArr.length - 1; i = i + 2) {
              lastPosOfImg = tempDisplayQuestionText.indexOf("<img", lastPosOfImg)
              lastPosOfImg = lastPosOfImg + 4
              var b = "  title =\"" + altQueTextArr[i] + "\"  alt =\"" + altQueTextArr[i + 1] + "\" "
              var output = [tempDisplayQuestionText.slice(0, lastPosOfImg), b, tempDisplayQuestionText.slice(lastPosOfImg)].join('');
              tempDisplayQuestionText = output
            }
          }
        }
      } catch (e) {
        console.debug("ERROR in Alt Text  ", e)
      }
    }
    return tempDisplayQuestionText;
  }

  callGetNextBatch(payload) {
    this.setState({ pageLoading: true, onePageTestLoading: false, gnbLoading: true, });


    this.props.apiService({
      method: 'post',
      //url: 'http://localhost:8095/getAllQuiz',
      url: '/getNextBatch',
      data: {
        ...payload,
        parent_quiz_id: this.state.parentQuizID,
      },

    })
      .then(res => {
        if (res.data.status == 1 && res.data.message) {
          if (res.data.message === 'quiz time over') {
            if (this.state.isTest === 1) {
              this.setState({
                testWindowEnded: true, pageLoading: false,
                showSplashScreen: true
              });
              return;
            } else {
              this.setState({
                quizWindowEnded: true, pageLoading: false,
                showSplashScreen: true
              });
              return;
            }
          }
        }
        if (res.data && res.data.status == 1 && res.data.message) {
          if (res.data.message === 'quiz expired') {
            this.setState({
              quizWindowEnded: true, pageLoading: false,
              showSplashScreen: true
            });
            return;
          }
        }
        this.setState({ pageLoading: false });

        if (res !== undefined && res.data !== undefined && res.data.data !== undefined &&
          res !== null && res.data !== null && res.data.data !== null) {
          this.setState({
            subSectionID: res.data.data.subsection_id,
            gnbCount: this.state.gnbCount + 1,
            categoryPositionMap: res.data.data.categoryPositionMap,
          })

          if (this.state.isTest && this.state.onePageMode) {
            // construct all questions properties to question array and all answers properties to answer array
            this.constructAllQuestionsAndAnswers(res.data.data);
          }

          // if(isDebug){
          let gnbs = []
          /* let gnbsArr = JSON.parse(window.localStorage.getItem("gnbArr"))
          gnbs = gnbsArr !== null ? gnbsArr : [] */
          gnbs.push(res)
          let gnbsStr = JSON.stringify(gnbs)
          let bytes = new TextEncoder().encode(gnbsStr).length;
          let kilobytes = bytes / 1024;
          // Localstorage maximum storage per key is 5000KB
          if (kilobytes < 5000) {
            try {
              window.localStorage.setItem("gnbArr", gnbsStr)
            } catch (error) {
              console.debug("Error Quota Exceeded", error)
            }
          }
          // }
          this.handleGetNextBatch(res)

        }
        else {
          alert("Server encountered an error. Please try again later!");
          this.props.handleRoute('/troubleShooting');
        }

      }).finally(() => {
        this.setState({ gnbLoading: false })
      });
  }



  handleGetNextBatch(res) {
    console.log("this.state.temp --- Calling Next Batch!!")
    currentCategoryCounter = 0;

    if (res.data.data.is_finish === 1) {
      this.finish();
      return;
    }
    var categoriesMapData = {};
    var tempSubcategoriesMap = {};

    var tempSubcategories = null;
    var tempQuestionArr = null;
    var tempSubTopcatSubcatMap = {};

    var tempCategoriesMap = {};
    var tempCategoriesArr = {};
    var tempSubCategoryCategoryMap = {};
    var tempSubCategoryCategoryArr = {};
    var tempCategoryQuestionsMap = {};
    var tempCategorySubcategoryMap = {};
    var tempNewCategorySubcategoryMap = {};

    var tempCategoryArray = [];
    var tempCategorySet = [];
    var tempCategoryForWheel = [];
    var tempQuestionsResponseArr = null;

    var tempSubCategoryQuestionMap = {};
    var tempCSAPMap = {};
    var tempIsCatChoosenFTGNB = {}
    var tempQuestionMap = {};

    var tempNOCQCMap = {};
    var catWiseNocqc = res.data.data.categoryQC === "" ? null : JSON.parse(res.data.data.categoryQC);
    var tempCatNOCQCMap = {};
    var tempSCQCMap = {};

    var tempCorrectAnswerMap = {};
    var tempCorrectAnswerArr = [];
    //var tempCategoriesArremptydata = {};

    var tempSkillTotal = 0;
    var tempAllQOver = true;
    var tempMasteredCategories = [];
    var tempSplashScreen = "";
    var tempIsTest = 0;
    var isTimerEnabled = false;

    var tempQuizSurveyQuestion = 0;
    var tempIsCategoryRandom = false;
    var tempCategoryMasteryCount = {};
    tempCategoryMasteryCount = JSON.parse(res.data.data.category_mastery_count);

    console.debug("tempCategoryMasteryCount =", tempCategoryMasteryCount);
    var tempDate = this.getDateTime();
    const tempQuestionStartTimeStamp = MomentTz(tempDate).tz(this.timeZone).format("YYYY-MM-DD HH:mm:ss");
    console.debug("tempQuestionStartTimeStamp =", tempQuestionStartTimeStamp);


    tempIsTest = res.data.data.is_test;
    tempSkillTotal = res.data.data.mastery_units;
    tempIsCategoryRandom = res.data.data.isCategoryRandom;
    var CRQMap = {};
    var SCRQMap = {};

    let temPNOCQCMap = res.data.data.NOCQCMap
    let isGNBCallFirstQuestion = {};

    Object.keys(temPNOCQCMap).map((key) => {
      isGNBCallFirstQuestion[key] = true;
    });


    if (tempIsTest == 1) {
      CRQMap = res.data.data.CRQMap
      SCRQMap = res.data.data.SCRQMap
    }

    if (res.data.data.isTimerEnabled !== undefined)
      isTimerEnabled = res.data.data.isTimerEnabled;
    var tempSaveStaticProgress = res.data.data.save_static_progress;

    if (tempSaveStaticProgress !== undefined && tempSaveStaticProgress !== null && tempSaveStaticProgress.length > 0) {

      for (var s = 0; s < tempSaveStaticProgress.length; s++) {

        var tempCatID = tempSaveStaticProgress[s].subject_id + "_" + tempSaveStaticProgress[s].topic_id + "_" + tempSaveStaticProgress[s].category_id;
        var tempCategoriesArr = {};
        tempCategoriesArr["categoryName"] = tempSaveStaticProgress[s].category_Name;
        tempCategoriesArr["questionFlag"] = 0;
        tempCategoriesArr["randomizeQuestions"] = 0;
        tempCategoriesArr["evaluateCategory"] = tempSaveStaticProgress[s].evaluate_category;
        tempCategoriesArr["score"] = tempSaveStaticProgress[s].score;
        tempCategoriesArr["questionsAttempted"] = tempSaveStaticProgress[s].quiz_attend;
        tempCategoriesArr["questionsCorrect"] = tempSaveStaticProgress[s].quiz_correct;

        tempCategoriesMap[tempCatID] = tempCategoriesArr;

        if (tempCategoryMasteryCount[tempCatID] != undefined && tempCategoryMasteryCount[tempCatID] != null
          && tempCategoryMasteryCount[tempCatID] != 0) {
          if (tempCategoriesArr["score"] >= tempCategoryMasteryCount[tempCatID]) {
            tempMasteredCategories.push(tempCatID);
          }
        }
        else {
          if (tempCategoriesArr["score"] >= res.data.data.masteryCount) {
            tempMasteredCategories.push(tempCatID);
          }
        }


      }
      console.log("first tempCategoriesMap", tempCategoriesMap);
      console.log("masteredCategories", tempMasteredCategories);
    }
    if (res.data.data.subcategories !== undefined && res.data.data.subcategories !== null && res.data.data.subcategories.length > 0) {

      tempSubcategories = res.data.data.subcategories;
      tempQuestionsResponseArr = res.data.data.questions;



    }
    if (tempSubcategories !== undefined && tempSubcategories !== null && tempSubcategories.length > 0) {
      for (var i = 0; i < tempSubcategories.length; i++) {
        var tempID = tempSubcategories[i].subject_id + "_" + tempSubcategories[i].topic_id + "_" + tempSubcategories[i].category_id;
        var tempsubcatID = tempSubcategories[i].subject_id + "_" + tempSubcategories[i].topic_id + "_" + tempSubcategories[i].category_id + "_" + tempSubcategories[i].subcategory_id;
        console.log("first tempID = ", tempID);
        console.log("tempCategoriesMap[tempID] = ", tempCategoriesMap[tempID]);
        var tempCategoriesArr = {};

        if (tempCategoriesMap[tempID] === undefined || tempCategoriesMap[tempID] === null) {

          tempCategoriesArr["categoryName"] = "";
          tempCategoriesArr["score"] = 0;
          tempCategoriesArr["questionFlag"] = 0;
          tempCategoriesArr["randomizeQuestions"] = 0;
          tempCategoriesArr["evaluateCategory"] = 0;
          tempCategoriesArr["questionsAttempted"] = 0;
          tempCategoriesArr["questionsCorrect"] = 0;
          tempCategoriesArr["enableFeedback"] = false;
          tempCategoriesArr["enableAnalytics"] = false;

          tempCategoriesArr["score"] = 0;
          console.log("is empty tempID = ", tempCategoriesMap);
        } else {
          tempCategoriesArr = tempCategoriesMap[tempID];
        }



        tempCategoriesArr["categoryName"] = tempSubcategories[i].category_name;
        tempCategoriesArr["categoryLabel"] = tempSubcategories[i].category_label;
        tempCategoriesArr["enableFeedback"] = tempSubcategories[i].enable_feedback;
        tempCategoriesArr["enableAnalytics"] = tempSubcategories[i].enable_analytics;
        tempCategoriesArr["questionFlag"] = tempSubcategories[i].question_is_random;
        tempCategoriesArr["randomizeQuestions"] = tempSubcategories[i].randomize_questions;
        tempCategoriesArr["evaluateCategory"] = tempSubcategories[i].evaluate_category;
        //tempCategoriesArr["score"]  = 0;

        tempCategoriesMap[tempID] = tempCategoriesArr;

        var tempSubTopcatSubcatArr = {};
        tempSubTopcatSubcatArr["subject_id"] = tempSubcategories[i].subject_id;
        tempSubTopcatSubcatArr["topic_id"] = tempSubcategories[i].topic_id;
        tempSubTopcatSubcatArr["category_id"] = tempSubcategories[i].category_id;
        tempSubTopcatSubcatArr["subcategory_id"] = tempSubcategories[i].subcategory_id;



        tempSubCategoryCategoryMap[tempSubcategories[i].subcategory_id] = tempID;
        tempSubTopcatSubcatMap[tempID] = tempSubTopcatSubcatArr;

        tempCategoryArray.push(tempID);
        //tempCategorySet.push(tempID);
        tempCategoryForWheel.push(tempID);



        tempNOCQCMap[tempID] = 0;
        tempCatNOCQCMap[tempID] = catWiseNocqc[tempID] ? catWiseNocqc[tempID] : res.data.data.NOCQC
        tempCSAPMap[tempID] = 0;
        tempIsCatChoosenFTGNB[tempID] = true
        tempSCQCMap[tempsubcatID] = 0;

        var tempSubcategoriesArr = {};
        if (tempSubcategoriesMap[tempsubcatID] === undefined || tempSubcategoriesMap[tempsubcatID] === null) {

          tempSubcategoriesArr["answer_type"] = 0;
          tempSubcategoriesArr["non_graded"] = 0;
        }


        tempSubcategoriesArr["answer_type"] = tempSubcategories[i].answer_type;
        tempSubcategoriesArr["category_name"] = tempSubcategories[i].category_name;
        tempSubcategoriesArr["non_graded"] = tempSubcategories[i] && tempSubcategories[i].non_graded !== null && tempSubcategories[i].non_graded !== undefined ? tempSubcategories[i].non_graded : 0;
        tempSubcategoriesArr["subcategory_weight"] = tempSubcategories[i].subcategory_weight;
        tempSubcategoriesArr["subject_id"] = tempSubcategories[i].subject_id;
        tempSubcategoriesArr["category_id"] = tempSubcategories[i].category_id;
        tempSubcategoriesArr["topic_id"] = tempSubcategories[i].topic_id;
        tempSubcategoriesArr["enable_feedback"] = tempSubcategories[i].enable_feedback;
        tempSubcategoriesArr["enable_analytics"] = tempSubcategories[i].enable_analytics;
        tempSubcategoriesMap[tempsubcatID] = tempSubcategoriesArr;

      }
    }

    // categoriesMapData["categoryName"] = tempSubcategories[0].category_name;
    // categoriesMapData["randomizeQuestions"] = tempSubcategories[0].randomize_questions;

    var tempQuestionsArr = [];
    if (tempQuestionsResponseArr !== undefined && tempQuestionsResponseArr !== null && tempQuestionsResponseArr.length > 0) {
      tempAllQOver = false;
      for (var i = 0; i < tempQuestionsResponseArr.length; i++) {

        var tempCatId = tempQuestionsResponseArr[i].subject_id + "_" + tempQuestionsResponseArr[i].topic_id + "_" + tempQuestionsResponseArr[i].category_id;
        var tempSubcatId = tempQuestionsResponseArr[i].subject_id + "_" + tempQuestionsResponseArr[i].topic_id + "_" + tempQuestionsResponseArr[i].category_id + "_" + tempQuestionsResponseArr[i].subcategory_id;
        var tempQuesId = tempQuestionsResponseArr[i].subject_id + "_" + tempQuestionsResponseArr[i].topic_id + "_" + tempQuestionsResponseArr[i].category_id + "_" + tempQuestionsResponseArr[i].subcategory_id + "_" + tempQuestionsResponseArr[i].question_id;


        var tempSubCategoriesArray = tempCategorySubcategoryMap[tempCatId];
        var tempSubCategoriesSet = new Set();
        if (tempSubCategoriesArray !== undefined && tempSubCategoriesArray !== null) {

          tempSubCategoriesSet = new Set(tempSubCategoriesArray)
        }
        tempSubCategoriesSet.add(tempSubcatId);
        tempCategorySubcategoryMap[tempCatId] = Array.from(tempSubCategoriesSet);
        remainingCatSubcatMap[tempCatId] = Array.from(tempSubCategoriesSet);

        tempCategorySet.push(tempCatId);
        // remainingCategorySet.push(tempCatId);


        tempQuestionsArr = tempSubCategoryQuestionMap[tempSubcatId];

        if (tempQuestionsArr === undefined || tempQuestionsArr === null) {
          tempQuestionsArr = [];
          //console.log("tempQuestionsArr", tempQuestionsArr);
        }

        tempQuestionsArr.push(tempQuestionsResponseArr[i])
        tempSubCategoryQuestionMap[tempSubcatId] = tempQuestionsArr;
        console.debug("pops ", tempQuestionsResponseArr[i])
        tempQuestionMap[tempQuesId] = tempQuestionsResponseArr[i];

        // var tempSubCategoriesArray = tempCategorySubcategoryMap[tempCatId];
        // if(tempSubCategoriesArray == null){
        //   tempSubCategoriesArray = [];

        // }
        // tempSubCategoriesArray.push(tempSubcatId);
        // tempCategorySubcategoryMap[tempCatId] = tempSubCategoriesArray;


        var tempAnswerArr = tempQuestionsResponseArr[i].answers;

        tempCorrectAnswerArr = [];
        //To Prevent code from crashing when answer array is null, which is case when answer type is text
        if (tempAnswerArr !== undefined && tempAnswerArr !== null) {
          for (var j = 0; j < tempAnswerArr.length; j++) {

            if (tempAnswerArr[j].is_answer === 1) {

              tempCorrectAnswerArr.push(tempAnswerArr[j].answer_id);
              tempCorrectAnswerMap[tempQuesId] = tempCorrectAnswerArr;


            }
          }
          if (tempQuestionsResponseArr[i].answer_type !== 2) {
            //TODO Handle scenarios where Answer type is not Text but answer array is empty
          }
        }



      }
    }
    // else{
    //   question array is null
    // }




    if (res.data.data.questions !== undefined && res.data.data.questions !== null && res.data.data.questions.length > 0) {
      tempQuestionArr = res.data.data.questions;
    }
    var tempUniqueArray = Array.from(new Set(tempCategorySet));
    remainingCategorySet = Array.from(new Set(tempCategorySet));
    var tempCategoryForWheel = Array.from(new Set(tempCategoryForWheel));
    tempSplashScreen = res.data.data.splashScreen;

    var tempHideNext = true;

    // if(tempIsTest  !== 1 ){
    //   tempHideNext = false;
    // }
    if (res.data.data.quiz_survey_question !== undefined && res.data.data.quiz_survey_question !== null && res.data.data.quiz_survey_question === 1) {
      tempQuizSurveyQuestion = parseInt(res.data.data.quiz_survey_question);
    }

    totalSCCount = tempSubcategories.length;
    remaningSubCatCount = tempSubcategories.length;
    console.log("remainingCatSubcatMap =", remainingCatSubcatMap);
    console.log("remaningSubCatCount =", remaningSubCatCount);
    console.log("totalSCCount =", totalSCCount);


    this.questionStartTimeStamp = tempQuestionStartTimeStamp;
    tempNewCategorySubcategoryMap = this.createTempCategorySubcategoryMap(tempCatNOCQCMap, res.data.data.subcategoryCQCMap);
    this.setState(
      {
        subcategoriesMap: tempSubcategoriesMap,
        subcategoriesArr: tempSubcategories,
        questionArr: tempQuestionArr,
        subTopcatSubcatMap: tempSubTopcatSubcatMap,
        categoriesMap: tempCategoriesMap,
        categoryAvailableQuestion: res.data.data.categoryAvailableQuestions,
        subcategoryAvailableQuestion: res.data.data.subcategoryAvailableQuestions,
        subCategoryQuestionsCount: res.data.data.subCategoryQuestionsCount,
        QSS: tempIsTest === 1 ? new Set(res.data.data.qss) : new Set(),
        RandomSubcategoryOrder: res.data.data.RandomSubcategoryOrder,
        subCategoryCategoryMap: tempSubCategoryCategoryMap,
        categoryRandomizedKeys: res.data.data.categoryRandomizedKeys,
        categoryArray: tempUniqueArray,
        categorySet: tempUniqueArray,
        categoryForWheel: tempCategoryForWheel,
        categoryQuestionsMap: tempCategoryQuestionsMap,
        NOCQCMap: res.data.data.NOCQCMap,
        catNOCQCMap: tempCatNOCQCMap,
        subCQCMap: res.data.data.subcategoryCQCMap, //weight
        CatRI: res.data.data.CatRI,
        SubCatRI: res.data.data.SubCatRI,
        SCQCMap: res.data.data.SCQCMap, //user current count
        SQCBackup: { ...res.data.data.subcategoryCQCMap },//weight
        NOCQC: res.data.data.NOCQC,
        categorySubcategoryMap: res.data.data.categorySubcategoryMap,
        subCategoryQuestionMap: tempSubCategoryQuestionMap,
        CSAPMap: tempCSAPMap,
        IsCatChoosenFTGNB: tempIsCatChoosenFTGNB,
        questionMap: tempQuestionMap,
        correctAnswerMap: tempCorrectAnswerMap,
        correctAnswerArr: tempCorrectAnswerArr,
        masteryCount: res.data.data.masteryCount,
        maxWrong: res.data.data.maxWrong,
        skillsMasterd: res.data.data.skills_masterd,
        skillTotal: tempSkillTotal,
        allQOver: tempAllQOver,
        masteredCategories: tempMasteredCategories,
        splashScreen: tempSplashScreen,
        isTest: tempIsTest,
        CRQMap: CRQMap,
        SCRQMap: SCRQMap,
        isTimerEnabled,
        elapsedTime: res.data.data.elapsedTime,
        totalTime: res.data.data.test_time,
        hideNext: tempHideNext,

        totalQuestions: res.data.data.over_all_question_count,
        questionsCorrect: res.data.data.questions_correct,
        questionsAttended: res.data.data.questions_attended,
        isSurveyOn: tempQuizSurveyQuestion,
        numberOfCategories: tempMasteredCategories.length,
        isCategoryRandom: tempIsCategoryRandom,
        quizAttempt: res.data.data.quiz_attempt,
        categoryMasteryCount: tempCategoryMasteryCount,
        isAbsoluteTimerOn: res.data.data.absoluteTimeEnabled,
        questionLength: res.data.data.questions ? res.data.data.questions.length : 0,
        showSubmitLoader: false,
        isGNBCallFirstQuestion: isGNBCallFirstQuestion,
        isResetSubCatWeight: {},
        CategoryNoOfQuestions: res.data.data.CategoryNoOfQuestions,
        NumberOfAttendedQuestions: res.data.data.NumberOfAttendedQuestions,
      }, () => {
        var isQuizAttempt = false;
        if (tempAllQOver === true) {
          console.log("All question Showed");
          if ((this.state.isTest === 1 &&
            res.data.data.questions_attended >= res.data.data.over_all_question_count) ||
            (this.state.isTest !== 1 &&
              this.state.skillsMasterd >= this.state.skillTotal)) {
            console.log("Completed Quiz/Test questions");

            this.setState({
              hasMasteredQuiz: true,
            }, () => {
              this.finish();

            })
            return;
          }
          else {
            if (this.state.isTest === 0) {
              this.updateQuizAttemptInDB();
            }
            else {
              alert("Test is in an inconsistent state. Please take a screenshot and report a bug");
              this.setState({
                hasMasteredQuiz: true,
              }, () => {
                this.finish();
              })
            }
            return;
          }


        }
        this.completedCategoryIdRemoved();

        if (this.state.isTest === 1 && isTimerEnabled === true) {
          this.startQuizTimer();
        }
      })









    console.log("subcategoriesMap", this.state.subcategoriesMap);
    console.log("subcategoriesArr", this.state.subcategoriesArr);
    console.log("questionArr", this.state.questionArr);
    console.log("subTopcatSubcatMap", this.state.subTopcatSubcatMap);
    console.log("categoriesMap", this.state.categoriesMap);
    console.log("subCategoryCategoryMap", this.state.subCategoryCategoryMap);
    console.log("categoryArray", this.state.categoryArray);
    console.log("categorySet", this.state.categorySet);
    console.log("categoryForWheel", this.state.categoryForWheel);
    console.log("categoryQuestionsMap", this.state.categoryQuestionsMap);
    console.log("NOCQCMap", this.state.NOCQCMap);
    console.log("categorySubcategoryMap", this.state.categorySubcategoryMap);
    console.log("subCategoryQuestionMap", this.state.subCategoryQuestionMap);
    console.log("CSAPMap", this.state.CSAPMap);
    //console.log("correctAnswerMap",this.state.correctAnswerMap);
    //console.log("correctAnswerArr",this.state.correctAnswerArr);
    console.log("masteryCount = ", this.state.masteryCount);
    console.log("maxWrong = ", this.state.maxWrong);
    console.log("skillsMasterd = ", this.state.skillsMasterd);
    console.log("skillTotal = ", this.state.skillTotal);
    console.log("masteredCategories = ", this.state.masteredCategories);
    // console.log("splashScreen = ", this.state.splashScreen);

    console.log("quiz isSurveyOn = ", this.state.isSurveyOn);
    console.log("is test  = ", this.state.isTest);
    console.log("questionStartTimeStamp  = ", this.questionStartTimeStamp);

    console.log("remainingCategorySet = ", remainingCategorySet);


    this.resetUI()
    //}
  }


  updateQuizAttemptInDB() {
    var tempQuizAttempt = this.state.quizAttempt;
    tempQuizAttempt = tempQuizAttempt + 1;


    const payloadQuizAttempt = {

      quiz_id: this.state.quizId,
      user_id: this.state.userId,//"test123",
      quiz_name: this.state.quiz_name,//"test 123"
      quiz_attempt: tempQuizAttempt,
      parent_quiz_id: this.state.parentQuizID,

    }
    console.log("tempQuizAttempt = ", tempQuizAttempt);
    console.log("QuizAttempt payload = ", payloadQuizAttempt);
    this.props.apiService({
      method: 'post',
      url: '/quizAttemptUpdate',
      data: payloadQuizAttempt,

    })
      .then(res => {
        console.log("quizAttemptUpdate response =", res.data.data);
        if (res.data.data === true) {
          //isQuizAttempt = true;
          this.setState({
            quizAttempt: tempQuizAttempt,
          }, () => {
            console.log("call onStartClick");
            this.onStartClick(false);
            return;
          })

        }

      })



  }

  createTempCategorySubcategoryMap = (CQC, SCQC) => {

    let categoryMap = {};
    Object.keys(CQC).map(k => {
      let arr = [];
      Object.keys(SCQC).map(ik => {
        if (ik.includes(`${k}_`)) {
          arr.push(ik);
        }
      });
      categoryMap[k] = arr;
    });

    return categoryMap;

  }

  completedCategoryIdRemoved() {

    var i;
    var j = 0;
    var tempSubCategoryArray = [];
    var stateCategorySet = this.state.categorySet;
    var stateCategoryArray = this.state.categoryArray;
    var subCategoryCategoryMap = this.state.subCategoryCategoryMap;
    var categorySubcategoryMap = this.state.categorySubcategoryMap;
    var hasMasteredQuiz = this.state.hasMasteredQuiz;

    if (this.state.masteredCategories.length > 0) {

      //Making a duplicate
      var tempCatArray = this.state.masteredCategories.slice(0);
      for (i = 0; i < tempCatArray.length; i++) {
        //console.log("Inspecting Category %d",tempCatArray[i] );
        tempSubCategoryArray = this.state.categorySubcategoryMap[tempCatArray[i]];
        if (tempSubCategoryArray !== undefined && tempSubCategoryArray !== null) {
          //console.log("Subcategory array of length %d found",tempSubCategoryArray.length );
          //Making a duplicate
          var subCatArray = tempSubCategoryArray.slice(0);

          for (j = 0; j < tempSubCategoryArray.length; j++) {

            if (this.state.subCategoryQuestionMap[tempSubCategoryArray[j]] === undefined ||
              this.state.subCategoryQuestionMap[tempSubCategoryArray[j]] === null) {

              //console.log("Subcategory %d is missing in subCategoryQuestionMap." +
              //"So deleting it from subCategoryCategoryMap and categorySubcategoryMap",tempSubCategoryArray[j]);
              delete subCategoryCategoryMap[tempSubCategoryArray[j]];
              subCatArray = this.removeElementFromArray(subCatArray, tempSubCategoryArray[j]);

              categorySubcategoryMap[tempCatArray[i]] = subCatArray;
              remainingCatSubcatMap[tempCatArray[i]] = subCatArray.slice();

              if (subCatArray.length === 0) {
                //console.log("Subcategory Array is empty in categorySubcategoryMap. So deleting category %d from categorySubcategoryMap, categoryArray and categorySet",
                //	categorySet[i]);

                delete categorySubcategoryMap[tempCatArray[i]];
                delete remainingCatSubcatMap[tempCatArray[i]];
                stateCategoryArray = this.removeElementFromArray(stateCategoryArray, tempCatArray[i]);
                stateCategorySet = this.removeElementFromArray(stateCategorySet, tempCatArray[i]);
              }
            }
          }
        }
      }

      //if(this.state.masteredCategories.length > 0){
      var tempMasteredCategories = this.state.masteredCategories;
      for (var m = 0; m < tempMasteredCategories.length; m++) {
        console.log("Before categoryArray", this.state.categoryArray);
        console.log("tempMasteredCategories value ", tempMasteredCategories[m]);
        stateCategoryArray = this.removeElementFromArray(stateCategoryArray, tempMasteredCategories[m]);
        stateCategorySet = this.removeElementFromArray(stateCategorySet, tempMasteredCategories[m]);
      }

      //}

      console.log("this.state.categoryArray", this.state.categoryArray);
      console.log("this.state.categorySet", this.state.categorySet);


      if (this.state.categorySet.length === 0 && this.state.categoryArray.length === 0) {
        console.log("Quiz finished categorySet is 0");
        console.log("Quiz finished hasMasteredQuiz = ", this.state.hasMasteredQuiz);

        hasMasteredQuiz = true;

      }

      this.setState({
        categorySet: stateCategorySet,
        categoryArray: stateCategoryArray,
        subCategoryCategoryMap: subCategoryCategoryMap,
        categorySubcategoryMap: categorySubcategoryMap,
        hasMasteredQuiz: hasMasteredQuiz
      }, () => {
        this.getRandomQuestion();
      });
      // on start button click to cal getrandom function
    } else {
      this.getRandomQuestion();

    }

  }

  removeElementFromArray(arr, element) {
    var i = arr.indexOf(element);
    if (i !== -1) {
      arr.splice(i, 1);
    }
    ////console.log("questionIds Array value =",arr);
    return arr;
  }

  //   shuffle(array) {
  // 	let currentIndex = array.length,  randomIndex;

  // 	// While there remain elements to shuffle.
  // 	while (currentIndex != 0) {

  // 	  // Pick a remaining element.
  // 	  randomIndex = Math.floor(Math.random() * currentIndex);
  // 	  currentIndex--;

  // 	  // And swap it with the current element.
  // 	  [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
  // 	}

  // 	return array;
  //   }

  async getCategory() {
    var currCategory = 0;
    var nextCatflag = false;
    let isFirstQuestion = true;
    let catNOCQCMap = this.state.catNOCQCMap;
    let CRQMap = this.state.CRQMap; // remaining question in cat
    var NOCQCMap = this.state.NOCQCMap; //User value
    if (this.state.isTest == 1) {
      // Object.keys(CRQMap).map((key)=> {
      //   if(CRQMap[key]== 0){
      //     delete NOCQCMap[key];
      //   }
      // });

      Object.keys(NOCQCMap).map((key) => {
        if ((NOCQCMap[key] == 0) && (CRQMap[key] < catNOCQCMap[key])) {
          catNOCQCMap[key] = CRQMap[key]
        }
        // if(NOCQCMap[key] >= catNOCQCMap[key]){
        //   NOCQCMap[key] = 0;
        // }
      });
    }
    let SCQCMap = this.state.SCQCMap;
    let subCQCMap = this.state.subCQCMap;
    let allCatKeys = this.state.categoryRandomizedKeys;
    allCatKeys = allCatKeys.filter(key => !this.state.pausedCategoriesMap[key])
    console.debug("allCatKeys>>??", allCatKeys, this.state.pausedCategoriesMap, this.state.categoryRandomizedKeys);
    if (allCatKeys === null || allCatKeys === undefined || allCatKeys.length === 0) {
      this.addPausedCategories("{}");
      NotificationManager.info("You’ve completed all unpaused categories. Paused categories have now been resumed.", "Categories Resumed", 6000);
      this.setState({ pausedCategoriesMap: {} });
    }
    /* if (allCatKeys.length === 0 && Object.keys(this.state.pausedCategoriesMap).length) {
      const result = await this.showAlert("Paused Categories!", "You've completed all unpaused categories, but some remain paused. Do you want to resume them or submit your assignment?", "Resume", "Submit");
      console.debug("result>>>", result)
      if (result) { // Resume
        this.addPausedCategories("{}")
      } else { // Submit
        this.submitAssignment();
      }
    } */
    // let Round = 0;
    // let QuetientARR = [];
    // Object.keys(subCQCMap).map((key)=>{
    //   QuetientARR.push(Math.trunc((SCQCMap[key] / subCQCMap[key])));  
    // });

    // const allEqual = QuetientARR => QuetientARR.every( v => v === QuetientARR[0] );

    // if(allEqual(QuetientARR)){
    //   Round = QuetientARR[0];
    // }else{
    //   Round = Math.min(...QuetientARR);
    // }

    Object.values(NOCQCMap).map((data) => {
      if (data != 0) {
        isFirstQuestion = false;
      }
    });


    // if(this.state.isFirstQuestion === true && isFirstQuestion === true){
    //   this.setState({isFirstQuestion: false})
    //       currCategory = allCatKeys[0];
    //       let currentCategoryIndex = this.state.categoryArray.indexOf(currCategory);
    //       NOCQCMap[currCategory]++;
    //       this.setState({NOCQCMap:NOCQCMap,categoryArrayIndex:currentCategoryIndex});
    //       if(this.state.isTest == 1){
    //         if (CRQMap[currCategory] != 0){
    //           CRQMap[currCategory]--;
    //         }
    //         this.setState({CRQMap:CRQMap});
    //       }
    //       return currCategory;
    // }else// if(this.state.isFirstQuestion && !isFirstQuestion)
    // {
    // let catRoundCompleted =  [...this.state.catRoundCompleted]
    // let currentCatKey = allCatKeys[currentCategoryCounter]

    // console.log("getCategory - currentCatKey = ", currentCatKey)
    // console.log("getCategory - NOCQCMap = ", NOCQCMap)
    // console.log("getCategory - catNOCQCMap = ", catNOCQCMap)
    // //check if the round is completed for all the category then add the key in the catRoundCompleted array
    // if(NOCQCMap[currentCatKey] === catNOCQCMap[currentCatKey]){
    // 	catRoundCompleted.push(currentCatKey)
    // }
    let foundData = "";
    let x = currentCategoryCounter;
    console.log("getCategory - allCatKeys = ", allCatKeys)
    console.log("getCategory - currentCategoryCounter = ", currentCategoryCounter)
    if ((allCatKeys.length - 1) <= currentCategoryCounter) {
      currentCategoryCounter = 0;
    }
    let isAllCatCompleted = false
    for (let index = 0; index < allCatKeys.length; index++) {
      if (this.state.isTest == 1) {
        if (CRQMap[allCatKeys[index]] == 0) {
          isAllCatCompleted = true
        } else {
          isAllCatCompleted = false
          break;
        }
      } else {
        //:TODO: remove mastered category from allCat keys
      }
    }
    console.log("getCategory - isAllCatCompleted = ", isAllCatCompleted)
    if (isAllCatCompleted) {
      console.log("getCategory - ---isAllCatCompleted----")
      return "-1"
    }
    let breakCounter = 0
    let prevCat = ""
    let data = ""
    let tempCatRI = this.state.CatRI
    // console.log("getCategory - catRoundCompleted ",catRoundCompleted)
    // if(catRoundCompleted !== undefined && catRoundCompleted.length === allCatKeys.length){
    // 	console.log("getCategory - NOCQCMap ",NOCQCMap)
    // 	console.log("getCategory - x ",x)
    // 	console.log("this.state.temp - ----- client-side randomisation ----")
    // 	NOCQCMap[allCatKeys[x]] = 0
    // 	allCatKeys = this.shuffle(allCatKeys)
    // 	x = 0
    // 	catRoundCompleted = []
    // 	console.log("getCategory - allCatKeys after shuffle",allCatKeys)
    // }
    // this.setState({
    // 	catRoundCompleted: catRoundCompleted,
    // 	categoryRandomizedKeys:allCatKeys
    // })
    for (; currentCategoryCounter < allCatKeys.length; x++) {
      if (breakCounter == breakCheck) {
        console.log("getCategory - ---Infinite loop break----", breakCounter)
        return "-1"
      }
      breakCounter++
      x = (allCatKeys.length) < x + 1 ? 0 : x;
      prevCat = allCatKeys[currentCategoryCounter]
      //TODO: if allCatKeys.length < index radom based on round index 
      console.log("getCategory - ---prevCat----", prevCat)
      console.log("getCategory - ---NOCQCMap[prevCat]----", NOCQCMap)
      console.log("getCategory - ---currentCategoryCounter----", currentCategoryCounter)
      console.log("getCategory - ---x----", x)
      console.log("getCategory - ---CRQMap[prevCat] ----", CRQMap)
      console.log("getCategory - ---catNOCQCMap[prevCat] ----", catNOCQCMap)
      if (NOCQCMap[prevCat] >= catNOCQCMap[prevCat] && (allCatKeys.length === 1 || currentCategoryCounter !== x)) {
        if (this.state.isTest === 1) {
          if (CRQMap[prevCat] !== 0) {
            NOCQCMap[prevCat] = 0;
          }
        } else {
          NOCQCMap[prevCat] = 0;
        }
        tempCatRI[prevCat]++
      }
      console.log("getCategory - ---CRQMap[prevCat] ----", CRQMap)
      currentCategoryCounter = x;
      console.log("getCategory - ---NOCQCMap----", NOCQCMap)
      console.log("getCategory - ---currentCategoryCounter----", currentCategoryCounter)
      console.log("getCategory - ---categoryMasteryCount----", this.state.categoryMasteryCount)
      console.log("getCategory - ---this.state.categoriesMap----", this.state.categoriesMap)
      console.log("getCategory - ---this.state.masteryCount----", this.state.masteryCount)
      console.log("getCategory - ---this.state.NumberOfAttendedQuestions----", this.state.NumberOfAttendedQuestions)
      console.log("getCategory - ---this.state.CategoryNoOfQuestions----", this.state.CategoryNoOfQuestions)
      data = allCatKeys[x];
      let checkMastered = false
      if (this.state.isTest === 0) {
        let tempMasteryCount = this.state.categoryMasteryCount[data] !== undefined && this.state.categoryMasteryCount[data] !== null && this.state.categoryMasteryCount[data] !== 0 ? this.state.categoryMasteryCount[data] : this.state.masteryCount
        if (this.state.categoriesMap[data] !== undefined && this.state.categoriesMap[data].score !== undefined && this.state.categoriesMap[data].score !== null && this.state.categoriesMap[data].score === tempMasteryCount) {
          checkMastered = true
        }
      } else {
        if (this.state.NumberOfAttendedQuestions[data] !== undefined && this.state.CategoryNoOfQuestions[data] !== undefined && this.state.NumberOfAttendedQuestions[data] >= this.state.CategoryNoOfQuestions[data]) {
          checkMastered = true
        }
      }
      if (NOCQCMap[data] != undefined) {
        if (NOCQCMap[data] < catNOCQCMap[data] && !checkMastered) {
          NOCQCMap[data]++;
          foundData = data;
          break;
        }
        // }else // if(catNOCQCMap[data] != 0 && NOCQCMap[data] == catNOCQCMap[data])
        // {
        //   NOCQCMap[data] = 0;
        //   let newIndex = allCatKeys.length > index + 1 ? index + 1 : 0;
        //   NOCQCMap[allCatKeys[newIndex]]++;
        //   foundData = allCatKeys[newIndex];
        //   currentCategoryCounter = newIndex
        //   break;
        // }
      }
      console.log("data - ---NOCQCMap----", data)
      console.log("getCategory - ---NOCQCMap----", NOCQCMap)
    }
    let currentCategoryIndex = this.state.categoryArray.indexOf(foundData);
    console.log("getCategory - foundData is - ", foundData)
    console.log("getCategory - this.state.categoryArray is - ", this.state.categoryArray)
    console.log("getCategory - currentCategoryIndex is - ", currentCategoryIndex)
    if (currentCategoryIndex != -1) {
      this.setState({
        NOCQCMap: NOCQCMap, categoryArrayIndex: currentCategoryIndex,
        CatRI: tempCatRI,
      });
      if (this.state.isTest == 1) {
        if (CRQMap[this.state.categoryArray[currentCategoryIndex]] != 0) {
          CRQMap[this.state.categoryArray[currentCategoryIndex]]--;
        }
        this.setState({ CRQMap: CRQMap });
      }
      return this.state.categoryArray[currentCategoryIndex];
    } else {
      console.log("currentCategoryIndex is -1 ")
      //let indexCat = 0; 
      // if(Round > 0){
      //   Object.keys(NOCQCMap).map((key, i)=>{
      //     if(i==0){
      //       indexCat = this.state.categoryArray.indexOf(key);
      //     }
      //   });
      //   NOCQCMap[this.state.randomCategory] = 0;
      // }else{
      //   NOCQCMap[this.state.categoryArray[indexCat]] = 0;
      // }
      // NOCQCMap[this.state.categoryArray[indexCat]]++;
      // this.setState({NOCQCMap:NOCQCMap,categoryArrayIndex:indexCat});
      // if(this.state.isTest == 1){
      //   if (CRQMap[this.state.categoryArray[indexCat]] != 0){
      //     CRQMap[this.state.categoryArray[indexCat]]--;
      //   }
      //   this.setState({CRQMap:CRQMap});
      // }
      //return this.state.categoryArray[indexCat];
      return "-1";
    }
    // }


    // if(NOCQCMap[this.state.randomCategory] < catNOCQCMap[this.state.randomCategory]){
    // 		var index = this.state.categoryArray.indexOf(this.state.randomCategory);
    // 		if(index === -1){
    //       let catindex = allCatKeys.indexOf(this.state.randomCategory);

    //         if(catindex == (allCatKeys.length - 1)){
    //           catindex = 0;
    //         }else{
    //           catindex++;
    //         }
    //       let nextCatKey = allCatKeys[catindex];
    //       let newindex = this.state.categoryArray.indexOf(nextCatKey);
    //       if(newindex === -1){
    //         return "-1";
    //       }
    // 			nextCatflag = true;
    // 		}
    // }else{
    //     var index = this.state.categoryArray.indexOf(this.state.randomCategory);
    // 		if(index === -1){
    // 			nextCatflag = true;
    // 		}
    // }

    // if(NOCQCMap[this.state.randomCategory] >= catNOCQCMap[this.state.randomCategory]){
    //   nextCatflag = true;
    // }
    // if(nextCatflag === false){
    //   NOCQCMap[this.state.randomCategory]++;
    //   this.setState({NOCQCMap:NOCQCMap});
    //   if(this.state.isTest == 1){
    //     if (CRQMap[this.state.randomCategory] != 0){
    //       CRQMap[this.state.randomCategory]--;
    //     }
    //     this.setState({CRQMap:CRQMap});
    //   }
    //   return this.state.randomCategory;
    // }
    // NOCQCMap[this.state.randomCategory] = 0;

    // currCategory =  this.nextCategory();

    // NOCQCMap[currCategory]++;
    // this.setState({NOCQCMap:NOCQCMap});
    // if(this.state.isTest == 1){
    //   if (CRQMap[currCategory] != 0){
    //     CRQMap[currCategory]--;
    //   }
    //   this.setState({CRQMap:CRQMap});
    // }
    // return currCategory;


  }

  nextCategory() {

    var categoryArrayIndex = this.state.categoryArrayIndex;

    if (categoryArrayIndex >= this.state.categoryArray.length) {
      categoryArrayIndex = 0;
    } else {
      if (categoryArrayIndex == (this.state.categoryArray.length - 1)) {
        categoryArrayIndex = 0;
      } else {
        categoryArrayIndex++;
      }
    }
    this.setState({ categoryArrayIndex: categoryArrayIndex });
    return this.state.categoryArray[categoryArrayIndex];

  }


  deleteCategory(categoryID) {
    var index = 0;
    console.log("Start deleteCategory");
    var categorySet = this.state.categorySet;
    var getNextBatch = this.state.getNextBatch;
    var categoryArrayIndex = this.state.categoryArrayIndex;
    var categoryArray = this.state.categoryArray;

    var indexRem = remainingCategorySet.indexOf(categoryID);
    if (indexRem !== -1) {
      remainingCategorySet.splice(indexRem, 1);
    }
    if (this.state.isCategoryRandom === true) {
      index = categorySet.indexOf(categoryID);
      if (index !== -1) {
        categorySet.splice(index, 1);
      }

      if (categorySet.length === 0) {
        console.log("Get New Batch!");
        getNextBatch = true;

        if (this.state.isTest === 1 &&
          this.state.questionsAttempted + 1 >= this.state.totalQuestions) {
          this.setState({ hasMasteredQuiz: true });
        }
        //getNewBatch();

      }
    } else {
      index = categoryArray.indexOf(categoryID);
      if (index !== -1) {
        categoryArray.splice(index, 1);
        if (this.state.isCategoryRandom === true) {
          if (categoryArrayIndex <= index) {
            categoryArrayIndex--;
          }
        }
      }
      if (categoryArray.length === 0) {
        console.log("Get New Batch!");
        getNextBatch = true;
        if (this.state.isTest === 1 &&
          this.state.questionsAttempted + 1 >= this.state.totalQuestions) {
          this.setState({ hasMasteredQuiz: true });
        }
        //getNewBatch();

      }
    }
    //console.log("categorySet = ",categorySet);
    this.setState({
      categoryArrayIndex: categoryArrayIndex,
      categorySet: categorySet,
      getNextBatch: getNextBatch,
      categoryArray: categoryArray,
    });
  }


  getQuestion(randomSubCategoryId, categoryID) {
    console.log("getQuestion:", randomSubCategoryId);
    var questionArray = [];
    questionArray = this.state.subCategoryQuestionMap[randomSubCategoryId];
    var qArraySet = new Set(this.state.questionArray);
    var QNSS = [];
    var i = 0;
    var randomQ = 0;
    var index = 0;
    var questionRandom = false;
    var randomQuestionJson = null;
    let repeatMode = false;

    var subCategoryQuestionMap = this.state.subCategoryQuestionMap;
    var QSS = this.state.QSS;
    var categorySubcategoryMap = this.state.categorySubcategoryMap;

    console.log("categoryID =", categoryID);
    //console.log("Random question  set true =",this.state.categoriesMap[categoryID]["randomizeQuestions"]);
    console.log("subCategoryQuestionMap =", subCategoryQuestionMap);
    console.log("subCategoryQuestionMap =", subCategoryQuestionMap[randomSubCategoryId]);
    console.log("randomSubCategoryId =", randomSubCategoryId);
    console.log("questionArray =", questionArray);
    console.log("QSS =", QSS);
    console.log("questionArray =", questionArray);
    var catNOCQCMap = this.state.catNOCQCMap;
    var currentNOCQCMap = this.state.NOCQCMap;
    var categoryAvailableQuestion = this.state.categoryAvailableQuestion;
    let SCQCMap = this.state.SCQCMap;
    let subCQCMap = this.state.subCQCMap;
    var subCategoryQuestionsCount = this.state.subCategoryQuestionsCount;


    if (this.state.categoriesMap[categoryID]["randomizeQuestions"] !== undefined &&
      this.state.categoriesMap[categoryID]["randomizeQuestions"] === 1) {

      questionRandom = true;
    }
    //console.log("subCategoryQuestionMap[%d]  = ",randomSubCategoryId,questionArray);
    console.log("Question Array length = ", questionArray);
    if (questionArray == undefined) {
      return { getNextBatch: true };
    }
    console.log("Question Array length = ", questionArray.length);
    if (questionArray.length > 0) {
      for (i = 0; i < questionArray.length; i++) {
        var tempQuestionID = randomSubCategoryId + "_" + questionArray[i].question_id;
        if (!QSS.has(tempQuestionID)) {
          QNSS.push(questionArray[i]);
        }
      }
      //if QNSS is empty, copy all questions from questionArray into QNSS
      if (QNSS.length === 0 && this.state.isTest != 1) {
        if (currentNOCQCMap[categoryID] <= catNOCQCMap[categoryID] && subCategoryQuestionsCount[randomSubCategoryId] <= 0) {
          return { getNextBatch: true };
        } else {
          QNSS = [...questionArray];
          repeatMode = true;
        }
      }

      if (QNSS.length === 0 && this.state.isTest == 1) {
        return { getNextBatch: true };
      }
    }
    else {
      return { getNextBatch: true };
      /* console.log("subcategory is empty get another subcategory");
      //getRandomQuestion();

      //getNextBatch = true;
      //console.log("QNSS is = ",QNSS.length);
      var sc = this.getSubCategory(categoryID, true);
      if(sc === undefined || sc === null || sc === "-1"){
        return "-1";
      }
      return {nextSC:sc.nextSC, nextQuestion: this.getQuestion(sc.nextSC, categoryID)}; */
    }

    //questionNotShowedSubCategory = questionArray - questionShowedSubCategory;
    console.log("QNSS is = ", QNSS);
    console.log("QNSS is = ", QNSS.length);
    // if(QNSS.length === 1){

    //   var subCatArr = categorySubcategoryMap[categoryID];
    //   console.log("subCatArr is = ",subCatArr);
    //   index = subCatArr.indexOf(randomSubCategoryId);
    //   if(index  !== -1) {
    //     subCatArr.splice(index, 1);
    //   }
    //   categorySubcategoryMap[categoryID] = subCatArr;
    //   remainingCatSubcatMap[categoryID] = subCatArr.slice();
    //   if(subCatArr.length === 0){
    //     //remove category from following array
    //     //categorySet.delete(categoryID);
    //     console.log("delete category id ",categoryID);
    //     this.deleteCategory(categoryID);
    //     delete categorySubcategoryMap[categoryID];
    //     delete remainingCatSubcatMap[categoryID];


    //   }
    //   randomQuestionJson = QNSS[0];
    //   randomQ = QNSS[0].question_id;

    // }
    //else{
    //getRandomQuestion()
    // if(questionRandom === true){
    //   //console.debug("Math.floor(Math.random()* QNSS.length)",Math.floor(Math.random()* QNSS.length))
    //   randomQuestionJson = QNSS[Math.floor(Math.random()* QNSS.length)];
    //   randomQ = randomQuestionJson.question_id;
    // }
    //else{
    let QIndex = 0;
    if (repeatMode) {
      QIndex = SCQCMap[randomSubCategoryId] % QNSS.length;
    }
    randomQ = QNSS[QIndex].question_id;
    //}
    //}
    QSS.add(randomSubCategoryId + "_" + randomQ);
    //Remove from subCategoryQuestionMap
    //questionArray
    var index = questionArray.indexOf(randomQuestionJson);
    if (index !== -1) {
      questionArray.splice(index, 1);
    }
    subCategoryQuestionMap[randomSubCategoryId] = questionArray;

    subCategoryQuestionsCount[randomSubCategoryId]--

    this.setState({
      subCategoryQuestionMap: subCategoryQuestionMap,
      QSS: QSS,
      categorySubcategoryMap: categorySubcategoryMap,
      subCategoryQuestionsCount: subCategoryQuestionsCount
    });


    return { nextQuestion: randomQ };


  }

  checkCatVaildAndRemoveSubcat(categoryId, subcategoryId) {
    console.log("checkCatVaildAndRemoveSubcat():");
    console.log("selected categoryId =", categoryId);
    console.log("selected subcategoryId =", subcategoryId);
    console.log("remaningSubCatCount = ", remaningSubCatCount);


    var tempSubcateArrList = [];
    if (remainingCatSubcatMap[categoryId] !== undefined && remainingCatSubcatMap[categoryId] !== null) {
      console.log("remainingCatSubcatMap[categoryId]:", remainingCatSubcatMap[categoryId]);
      var tempSubcateArrList = remainingCatSubcatMap[categoryId];
      if (tempSubcateArrList === undefined || tempSubcateArrList === null) {
        console.log("Category ", categoryId, " is not present in remainingCatSubcatMap");
        return;
      }
      if (tempSubcateArrList.length > 0) {
        tempSubcateArrList = this.removeElementFromArray(tempSubcateArrList, subcategoryId);
      }
      if (tempSubcateArrList.length <= 0) {
        //Giving precedence to NOCQC= 1
        console.log("this.state.categorySubcategoryMap[categoryId]=", this.state.categorySubcategoryMap[categoryId]);

        tempSubcateArrList = (this.state.categorySubcategoryMap[categoryId]).slice();


        remainingCategorySet = this.removeElementFromArray(remainingCategorySet, categoryId);
        if (remainingCategorySet.length <= 0) {
          if (this.state.isCategoryRandom === true) {
            remainingCategorySet = this.state.categorySet.slice();
            console.log("selected  remainingCategorySet categorySet =", remainingCategorySet);
          }
          else {
            remainingCategorySet = this.state.categoryArray.slice();
            console.log("selected  remainingCategorySet categoryArray =", remainingCategorySet);
          }
        }
        console.log("Removed remainingCategorySet = ", remainingCategorySet);

      }
      remainingCatSubcatMap[categoryId] = tempSubcateArrList;
      remaningSubCatCount = remaningSubCatCount - 1;
      console.log("remaningSubCatCount = ", remaningSubCatCount);


    }
    console.log("remaningSubCatCount = ", remaningSubCatCount);

    /*if(remaningSubCatCount <= 1){

      console.log("remaningSubCatCount is 1 = reset catsub map to ",this.state.categorySubcategoryMap);
      remainingCatSubcatMap = this.state.categorySubcategoryMap;
      remaningSubCatCount = totalSCCount;
    }*/

    console.log("End check fun remainingCatSubcatMap = ", remainingCatSubcatMap);


  }

  getSubCategory(categoryID, nextSC) {

    var subcategoryArrayList;
    let SCQCMap = this.state.SCQCMap;  //user current count
    let subCQCMap = this.state.subCQCMap; //weight
    let SCRQMap = this.state.SCRQMap; // remaining questions in subcat
    // let isGNBCallFirstQuestion = this.state.isGNBCallFirstQuestion;
    let chooseNextSC = false
    let isCatChoosenFTGNB = { ...this.state.IsCatChoosenFTGNB }

    let Round = 0;
    let isAllTrue = false;
    let isAllSCQCEqual = false;
    let isResetSubCatWeight = this.state.isResetSubCatWeight

    Object.keys(SCQCMap).map((key) => {
      if (this.state.isTest == 1) {
        chooseNextSC = false
        //availableQue = 8, sqc = 3, there will be 3 round in the 3rd round there will only be 2 so we cant choose the nextSC
        if ((SCQCMap[key] % this.state.SQCBackup[key] == 0) && (SCRQMap[key] < subCQCMap[key]) &&
          isResetSubCatWeight[key] !== undefined && isResetSubCatWeight[key] !== null && !isResetSubCatWeight[key]) {
          subCQCMap[key] = SCRQMap[key] //overwritting for final round
          isResetSubCatWeight[key] = true
          SCQCMap[key] = 0
        }
        // if(SCRQMap[key] !== 0 && SCQCMap[key] > subCQCMap[key]){
        //   SCQCMap[key] = 0;// reset user count only if there are remaining questions
        // }
      } else {
        // if(SCQCMap[key] > subCQCMap[key]){
        //   SCQCMap[key] = 0;
        // }
      }
    });
    this.setState({ isResetSubCatWeight: isResetSubCatWeight })


    var CSAPMap = this.state.CSAPMap;


    subcategoryArrayList = this.state.categorySubcategoryMap[categoryID];

    var scChosen = 0;

    console.log("getSubCategory - subcategoryArrayList = ", subcategoryArrayList)
    if (subcategoryArrayList === undefined || subcategoryArrayList === null ||
      (subcategoryArrayList !== undefined && subcategoryArrayList !== null && subcategoryArrayList.length <= 0)) {
      var nextCat = this.nextCategory();
      if (nextCat === undefined || nextCat === null || nextCat === "-1") {
        console.log("---subcategory returning -1 since nextCat is empty---")
        this.onStartClick(false)
        return "-1";
      }
      scChosen = this.getSubCategory(nextCat, false)
      this.checkCatVaildAndRemoveSubcat(nextCat, scChosen);

      // SCQCMap[scChosen]++;
      // this.setState({SCQCMap:SCQCMap});
      // if(this.state.isTest == 1){
      //   if (SCRQMap[scChosen] != 0){
      //     SCRQMap[scChosen]--;
      //   }
      //   this.setState({SCRQMap:SCRQMap});
      // }
      console.log("nextCat-", nextCat)
      console.log("scChosen-", scChosen)
      return { nextCat: nextCat, nextSc: scChosen };

    }
    else {
      if (this.state.isTest === 1 && CSAPMap[categoryID] >= subcategoryArrayList.length) {
        CSAPMap[categoryID] = 0;
        //Todo random subcat by shuffling subcategoryArrayList
      }

      let QuetientARR = [];
      let Remainder = [];
      Object.keys(subCQCMap).map((key) => {
        QuetientARR.push(Math.trunc((SCQCMap[key] / subCQCMap[key])));
        Remainder.push((SCQCMap[key] % subCQCMap[key]))
      });

      const allEqual = QuetientARR => QuetientARR.every(v => v === QuetientARR[0]);
      const allSCQCEqual = Remainder => Remainder.every(v => v === Remainder[0]);

      if (allEqual(QuetientARR)) {
        Round = QuetientARR[0];
        isAllTrue = true
      } else {
        Round = Math.min(...QuetientARR);
      }

      if (allSCQCEqual(Remainder)) {
        isAllSCQCEqual = true;
      }


      // if(isGNBCallFirstQuestion[categoryID]){
      //   isGNBCallFirstQuestion[categoryID] = false;
      //   if(this.state.isTest != 1){
      //     CSAPMap[categoryID] = 0
      //     scChosen = subcategoryArrayList[CSAPMap[categoryID]];
      //     if(SCQCMap[scChosen] === 0 || (SCQCMap[scChosen] % subCQCMap[scChosen]) === 0){
      //       SCQCMap[scChosen]++;
      //       this.setState({SCQCMap:SCQCMap, CSAPMap:CSAPMap, isGNBCallFirstQuestion: isGNBCallFirstQuestion});
      //       return {nextSc:  scChosen};
      //     }
      //   }else{
      //     for(let z = 0; z < subcategoryArrayList.length; z++ ){
      //       if(SCRQMap[subcategoryArrayList[z]] != 0){
      //         scChosen = subcategoryArrayList[z];
      //         SCQCMap[scChosen]++;
      //         this.setState({SCQCMap:SCQCMap, CSAPMap:CSAPMap, isGNBCallFirstQuestion: isGNBCallFirstQuestion});

      //           if (SCRQMap[scChosen] != 0){
      //             SCRQMap[scChosen]--;
      //           }
      //           this.setState({SCRQMap:SCRQMap});

      //         return {nextSc:  scChosen};
      //       }
      //     }
      //   }
      // }


      scChosen = subcategoryArrayList[CSAPMap[categoryID]];

      console.log("getSubCategory - scChosen 1 = ", scChosen)

      // if(this.state.isTest == 1){
      //  for(let z = CSAPMap[categoryID]; z < subcategoryArrayList.length; z++ ){
      //     if(this.state.SQCBackup[subcategoryArrayList[z]] === SCQCMap[subcategoryArrayList[z]] && !isCatChoosenFTGNB[categoryID]){
      //       console.log("Choose next subcategory if test!")
      //       chooseNextSC = true
      //       // if(SCRQMap[subcategoryArrayList[z]] !== 0){
      //       //   SCQCMap[subcategoryArrayList[z]] = 0;
      //       // }
      //       break;
      //     }else if(SCRQMap[subcategoryArrayList[z]] != 0){ 
      // 		//&& this.state.SQCBackup[subcategoryArrayList[z]] == subCQCMap[subcategoryArrayList[z]]){
      //       console.log("Choose existing subcategory if test!")
      //       break;
      //     }else{
      //       console.log("Choose next subcategory if test! -- 2nd else")
      //     //   chooseNextSC = true
      //     }
      //   }
      // } 

    }
    console.log("getSubCategory - SCQCMap[scChosen] = ", SCQCMap)
    console.log("getSubCategory - subCQCMap[scChosen] 1 = ", subCQCMap)
    console.log("getSubCategory - isCatChoosenFTGNB[categoryID] 1 = ", isCatChoosenFTGNB)
    console.log("getSubCategory - chooseNextSC 1 = ", chooseNextSC)
    // if(this.state.isTest !== 1){ 
    // if((SCQCMap[scChosen] % subCQCMap[scChosen]) < subCQCMap[scChosen]){
    //this condition check if the round for the currentSC is over, if over nextSC is choosen
    //availableQue = 8, sqc = 3, there will be 3 round in the 3rd round there will only be 2 so we cant choose the nextSC
    if (SCQCMap[scChosen] !== 0 && (SCQCMap[scChosen] % subCQCMap[scChosen]) === 0 && !isCatChoosenFTGNB[categoryID]) {
      // (SCQCMap[scChosen] !== 0 && (SCQCMap[scChosen] % subCQCMap[scChosen]) === 0 && isAllSCQCEqual && isAllTrue) ||
      // (SCQCMap[scChosen] !== 0 && (SCQCMap[scChosen] % subCQCMap[scChosen]) !== 0 && subCQCMap[scChosen] === this.state.SQCBackup[scChosen]) ||
      // (SCQCMap[scChosen] !== 0 && (SCQCMap[scChosen] % subCQCMap[scChosen]) >= 0 && isAllTrue && Round > 0)){
      console.log("Choose next subcategory if quizz !")
      chooseNextSC = true
    }
    // }
    // }
    console.log("getSubCategory - chooseNextSC 2 = ", chooseNextSC)
    console.log("getSubCategory - CSAPMap 2 = ", CSAPMap)
    console.log("getSubCategory - SCQCMap 2 = ", SCQCMap)
    console.log("getSubCategory - subcategoryArrayList 2 = ", subcategoryArrayList)
    let tempSubCatRI = this.state.SubCatRI

    if (chooseNextSC) {
      tempSubCatRI[scChosen]++
      SCQCMap[scChosen] = 0
      let subCategoryArrayIndex = 0;

      if (CSAPMap[categoryID] >= subcategoryArrayList.length - 1) {
        //TODO random subcategory subcategoryArrayList
        CSAPMap[categoryID] = -1;
        // subCategoryArrayIndex = CSAPMap[categoryID];
      }
      CSAPMap[categoryID]++;
      subCategoryArrayIndex = CSAPMap[categoryID]
      scChosen = subcategoryArrayList[subCategoryArrayIndex];
    }
    console.log("getSubCategory - CSAPMap 2 = ", CSAPMap)
    console.log("getSubCategory - SCQCMap 2 = ", SCQCMap)
    console.log("getSubCategory - scChosen 2 = ", scChosen)
    SCQCMap[scChosen]++;
    isCatChoosenFTGNB[categoryID] = false
    this.setState({
      SCQCMap: SCQCMap, CSAPMap: CSAPMap,
      IsCatChoosenFTGNB: isCatChoosenFTGNB,
      SubCatRI: tempSubCatRI,
    });
    if (this.state.isTest == 1) {
      if (SCRQMap[scChosen] != 0) {
        SCRQMap[scChosen]--;
        //Removing the subcategory if all the questions in the subcategory are shown
        if (SCRQMap[scChosen] === 0) {
          let categorySubcategoryMap = this.state.categorySubcategoryMap
          subcategoryArrayList.splice(CSAPMap[categoryID], 1)
          categorySubcategoryMap[categoryID] = subcategoryArrayList
          this.setState({ categorySubcategoryMap: categorySubcategoryMap });
        }
      }
      this.setState({ SCRQMap: SCRQMap });
    }
    return { nextSc: scChosen };



  }

  getAnswerFromQuestion = (question) => {
    // START
    let tempDisplayAnswerArr = [];
    if (question) {

      if (question.alt_question_text !== undefined && question.alt_question_text !== null &&
        question.alt_question_text !== "") {
        try {
          var altQueText = question.alt_question_text
          altQueText = altQueText.replace(/\n/ig, ' ')
          //finding number of time image present
          var altQueTextCount = altQueText.split(';').length
          var imgTagCount = tempDisplayQuestionText.split('<img').length - 1
          console.debug((altQueTextCount / 2), "==", imgTagCount, "    ", altQueText.split(';').length, tempDisplayQuestionText.split('<img').length)
          if ((altQueTextCount / 2) == imgTagCount) {
            if (imgTagCount >= 1) {
              console.debug("greater than 1")
              var altQueTextArr = altQueText.split(';');
              var lastPosOfImg = 0
              console.debug(altQueTextArr.length)
              for (var i = 0; i <= altQueTextArr.length - 1; i = i + 2) {
                lastPosOfImg = tempDisplayQuestionText.indexOf("<img", lastPosOfImg)
                lastPosOfImg = lastPosOfImg + 4
                var b = "  title =\"" + altQueTextArr[i] + "\"  alt =\"" + altQueTextArr[i + 1] + "\" "
                var output = [tempDisplayQuestionText.slice(0, lastPosOfImg), b, tempDisplayQuestionText.slice(lastPosOfImg)].join('');
                tempDisplayQuestionText = output
              }
            }
          }
        } catch (e) {
          console.debug("ERROR in Alt Text  ", e)
        }
      }
      //Alt question Text
      tempDisplayAnswerArr = question.answers;
      console.debug("question.answers", question)
      tempDisplayAnswerArr?.forEach((_, index) => {
        if (tempDisplayAnswerArr[index].isChecked) {
          tempDisplayAnswerArr[index].isChecked = false
        }
      })

      if (question.question_type === 0 && [70, 80].includes(question.answer_type)) {
        tempDisplayAnswerArr?.forEach((answerArr, cIndex) => {
          const vectorVariableMap = VectorParserUtil.buildQuestionVariablesMap(answerArr?.vectorAnswerVariable);
          let vectorSettingsData = question.vector_settings_data
          // Calculate newVectorValues
          const newVectorValues = vectorVariableMap
            ? vectorVariableMap.getVectorsArray(
              vectorSettingsData.enableIdenticalVector,
              vectorSettingsData
            ).filter(value => value !== undefined)
            : [];

          // Check if newVectorValues is an array and has elements
          if (Array.isArray(newVectorValues) && newVectorValues.length > 0) {
            // Assign newVectorValues to answerArr
            answerArr.newVectorValues = [...newVectorValues];
          }
        })
      }

      //Alt answer text
      try {
        for (var i = 0; i <= question.answers?.length - 1; i++) {
          if (question.answers[i].answer_text !== undefined && question.answers[i].answer_text !== null &&
            question.answers[i].answer_text !== "" && question.answers[i].alt_answer_text !== undefined &&
            question.answers[i].alt_answer_text !== null && question.answers[i].alt_answer_text !== "") {
            var tempDisplayAnwserText = question.answers[i].answer_text
            var altAnsText = question.answers[i].alt_answer_text
            altAnsText = altAnsText.replace(/\n/ig, ' ')
            //finding number of time image present
            var altAnsTextCount = altAnsText.split(';').length
            var imgTagCount = tempDisplayAnwserText.split('<img').length - 1
            console.debug((altAnsTextCount / 2), "==", imgTagCount)
            if ((altAnsTextCount / 2) == imgTagCount) {
              if (imgTagCount >= 1) {
                // console.debug("Answer greater than 1")
                var altAnsTextArr = altAnsText.split(';');
                var lastPosOfImg = 0
                for (var j = 0; j <= altAnsTextArr.length - 1; j = j + 2) {
                  lastPosOfImg = tempDisplayAnwserText.indexOf("<img", lastPosOfImg)
                  lastPosOfImg = lastPosOfImg + 4
                  var b = "  title =\"" + altAnsTextArr[j] + "\"  alt =\"" + altAnsTextArr[j + 1] + "\" "
                  var output = [tempDisplayAnwserText.slice(0, lastPosOfImg), b, tempDisplayAnwserText.slice(lastPosOfImg)].join('');
                  tempDisplayAnwserText = output
                }
              }
            }
            tempDisplayAnswerArr[i].answer_text = tempDisplayAnwserText
            console.debug("tempDisplayAnswerArr[i]>>", tempDisplayAnswerArr[i])
            tempDisplayAnswerArr[i].isChecked = false
          }

        }
      } catch (e) {
        console.debug("ERROR in Alt answer Text and feedback ", e)
      }

    }
    console.debug("tempDisplayAnswerArr>>>>", tempDisplayAnswerArr)
    return tempDisplayAnswerArr ? tempDisplayAnswerArr : []
    // END

  }


  getCurrentVariableMapFromQuestion = (question, answerArr) => {
    let tempVariableMap;
    if (question.question_type === 1 && question.answer_type !== 2) {
      let tempDisplayAnswerArr = answerArr;
      if (tempDisplayAnswerArr === null || tempDisplayAnswerArr === undefined) {
        tempDisplayAnswerArr = [];
      }
      const AnswerArr = [...tempDisplayAnswerArr];
      tempVariableMap = MathParserUtil.buildQuestionVariablesMap(question.question_variables);
      if (tempVariableMap && tempVariableMap.isValid()) {
        tempVariableMap.generateValues();
        let RPAnswerArr = MathParserUtil.stringToValueRPAnswer(AnswerArr, tempVariableMap)
        let shouldRandomize = false;
        let firstAttempt = true;
        let i = 0;
        do {
          if (firstAttempt) {
            shouldRandomize = MathParserUtil.shouldRandomize(RPAnswerArr);
          }
          if (shouldRandomize) {
            tempVariableMap.generateValues();
          }
          RPAnswerArr = MathParserUtil.stringToValueRPAnswer(AnswerArr, tempVariableMap)
          shouldRandomize = MathParserUtil.shouldRandomize(RPAnswerArr);
          firstAttempt = false;
          i++;
          //For Avoid Crashing
          if (i >= 10) {
            console.log("Randomized Continously.. Crash State..")
            break;
          }
        } while (shouldRandomize);
      }
    }
    return tempVariableMap;
  }

  getQuestionAnswerState = (tempQuestionID, shouldUpdateAnswerState) => {
    if (this.state.questionAnswerStates && this.state.questionAnswerStates.length) {
      let qas = this.state.questionAnswerStates.find(qa => qa.unique_id === tempQuestionID)
      if (qas) {
        // console.debug("qas.student_answer_string>>", qas.student_answer_string, shouldUpdateAnswerState)
        if (qas.student_answer_string && shouldUpdateAnswerState) {
          let currentQuestion = null;
          let answer_type = null;

          if (qas.other_state_map_string && qas.other_state_map_string !== "{}") {
            let otherStateMap = JSON.parse(qas.other_state_map_string);
            // console.debug("otherStateMap>>>???", otherStateMap)
            this.setState(otherStateMap);
          }

          if (this.state.surveyQuestionsRetrieved === true) {
            currentQuestion = this.state.surveyQuestionMap[tempQuestionID];
            answer_type = currentQuestion.answer_type;
          } else {
            currentQuestion = this.state.questionMap[tempQuestionID];
            answer_type = currentQuestion.answer_type;
          }
          // console.debug("currentQuestion>>>", currentQuestion)
          let studentAnswer = JSON.parse(qas.student_answer_string);
          this.setState({ selectedAnswers: studentAnswer, selectedAnswer: studentAnswer, alreadyPickedAnswer: true });
        }

        return qas;
      };
      return null
    }
    return null;
  }

  IsCategoryCompleted = (catKey) => {
    let isCompleted = false;

    if (this.state.categoryForWheel && this.state.categoryForWheel.length) {
      let l = this.state.categoryForWheel.length;
      for (let i = 0; i < l; i++) {
        let categorySetId = this.state.categoryForWheel[i];

        const score = Math.round(this.state.categoriesMap[categorySetId].score / ((this.state.categoryMasteryCount[categorySetId] !== undefined &&
          this.state.categoryMasteryCount[categorySetId] !== null && this.state.categoryMasteryCount[categorySetId] !== 0) ?
          this.state.categoryMasteryCount[categorySetId]
          : this.state.masteryCount) * 100)

        if (categorySetId === catKey && score >= 100) {
          isCompleted = true;
          break;
        }
      }
    }

    return isCompleted;
  }

  isEmbeddedTutorial = () => {
    return typeof window !== "undefined"
      && window.self !== window.top
      && Number(this.state.parentQuizID) > 0;
  }

  focusEmbeddedTutorialQuestion = () => {
    if (!this.isEmbeddedTutorial()) return;

    const focusQuestion = () => {
      const questionTarget = document.getElementById("embedded-tutorial-question-content")
        || document.getElementById("embedded-tutorial-question");
      questionTarget?.focus();
    };

    window.requestAnimationFrame(() => {
      window.setTimeout(focusQuestion, 0);
    });
  }

  navigateToOnePageQuestion = (uniqueID) => {
    const question = document.getElementById(`question-no-${uniqueID}`);
    if (!question) return;

    question.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'nearest'
    });
    window.requestAnimationFrame(() => question.focus({ preventScroll: true }));
  }

  async getRandomQuestion() {

    console.log("-------------------------------------");
    console.log("getRandomQuestion:");
    const previousQuestionKey = `${this.state.randomSubCategory}_${this.state.randomQuestionID}`;
    if (this.state.isTest === 1) {
      this.getDateTime();
    }

    this.setState(
      {
        showAnswerResponse: false,
        answerCorrect: false,
        submitClicked: false,
        hideNext: true,
        showSubmitLoader: false,
        submitButtonDisplay: true
        //pageLoading:true,


      })

    if (this.state.isTest === 1 && this.state.questionsAttempted >= this.state.totalQuestions) {
      this.setState({ hasMasteredQuiz: true });
      this.finish();
      return;
    }
    if (this.state.hasMasteredQuiz === true) {


      console.log("Quiz finish");

      console.log("this.state.surveyQuestionsRetrieved = ", this.state.surveyQuestionsRetrieved);
      if (this.state.surveyQuestionsRetrieved === false) {
        console.log("finish ()= 1");
        // this.finish();
        this.finish();
        return;
      } else {
        if (this.state.surveyQuestionIdArr.length <= this.state.surveyQPointer) {
          console.log("finish ()= 2");
          //this.finish();
          this.finish();
          return;
        }
      }
    }

    if (this.state.surveyQuestionsRetrieved === false) {
      if (this.state.questionLength == 0) {
        this.onStartClick(false);
        return;
      }
      if (this.state.getNextBatch === true) {

        console.log("getNextBatch = ", this.state.getNextBatch);
        // var url = "VTStaticQuiz.php?class=" + clas + "&qname="
        //   + quizName + "&name=" + name + "&practice=" + practice +"&qid="+quizId;
        this.setState({
          getNextBatch: false,
          QSS: new Set(),
        });
        this.onStartClick(false);

        //window.location.href = "/practiceCompleted";
        //this.onfinishPageCall();
        //window.location.reload();
        return;
      }

    }

    //console.log("categoryArray = ", categoryArray);
    //console.log("categoryset = ", categorySet);

    var tempDisplayQuestionText = null;
    var tempDisplayAnswerArr = null;
    var randomCategory = null;
    var randomSubCategory = null;
    var randomQuestionID = null;
    let answerDisplayStyleLocal = 1;
    let questionAnswerStateData = null;
    if (this.state.surveyQuestionsRetrieved === false) {

      // is survey question false
      if (this.state.questionAnswerStates && this.state.questionAnswerStates.length) {
        let qas = this.state.questionAnswerStates[0];
        let categoryID = `${qas.subject_id}_${qas.topic_id}_${qas.category_id}`;

        //Corner test case check: if qas category is already completed then set qas state to null and call getRandomQuestion again
        /* console.debug("this.IsCategoryCompleted(categoryID)", this.IsCategoryCompleted(categoryID), this.state.pausedCategoriesMap)
        if (this.IsCategoryCompleted(categoryID) && (this.state.pausedCategoriesMap === null || this.state.pausedCategoriesMap == undefined || this.state.pausedCategoriesMap === "{}")) {
          this.onNextClick();
          return;
        } */

        /* if (qas && qas.other_state_map_string && qas.other_state_map_string !== "{}") {
          let otherStateMap = JSON.parse(qas.other_state_map_string)
          setTimeout(() => {
            this.setState(otherStateMap);  
          }, 100);
          
        }*/
        var tempQuestionID = qas.unique_id;
        randomCategory = `${qas.subject_id}_${qas.topic_id}_${qas.category_id}`
        randomSubCategory = `${qas.subject_id}_${qas.topic_id}_${qas.category_id}_${qas.subcategory_id}`
        randomQuestionID = qas.question_id;
        let newQSS = this.state.QSS;
        newQSS.add(tempQuestionID);
        this.setState({
          QSS: newQSS,
        })
        console.log("this.state.temp - QuestionID = ", tempQuestionID,
          "Cat RI = ", this.state.CatRI[randomCategory] + 1,
          "SubCat RI = ", this.state.SubCatRI[randomSubCategory] + 1,
        );
      } else {
        randomCategory = await this.getCategory();

        console.log("randomCategory = ", randomCategory);
        if (randomCategory === undefined || randomCategory === null || randomCategory === "-1") {
          console.log("call getNextbatch from getCategory, randomCategory=", randomCategory);
          this.onStartClick(false);
          return;
        }


        var scRetVal = this.getSubCategory(randomCategory, false);
        console.log("getSubCategory response = ", scRetVal);
        if (scRetVal === undefined || scRetVal === null || scRetVal === "-1") {
          console.log("call getNextbatch from getSubCategory, scRetVal=", scRetVal);
          return "-1";
        }
        randomSubCategory = scRetVal.nextSc;
        console.log("randomSubCategory = ", randomSubCategory);

        if (scRetVal.nextCat !== undefined && scRetVal.nextCat !== null) {
          console.log("new cat ID = ", scRetVal.nextCat);
          randomCategory = scRetVal.nextCat;
          console.log("new randomCategory = ", randomCategory);
        }
        console.log("randomSubCategory = ", randomSubCategory);



        var qRetVal = this.getQuestion(randomSubCategory, randomCategory);
        console.log("getQuestion qRetVal = ", qRetVal);

        if (qRetVal === undefined || qRetVal === null || qRetVal === "-1") {
          console.log("call getNextbatch from getQuestion, qRetVal=", qRetVal);
          return "-1";
        }
        if (qRetVal.hasOwnProperty('getNextBatch')) {
          this.onStartClick(false);
          return;
        }

        this.setState(prevState => {
          return {
            questionLength: prevState.questionLength - 1
          }
        });

        randomQuestionID = qRetVal.nextQuestion;



        console.log("randomQuestionID = ", randomQuestionID);

        if (qRetVal.nextSC !== undefined && scRetVal.nextSC !== null) {
          console.log("new randomSubCategory ID = ", scRetVal.nextSC);

          randomSubCategory = scRetVal.nextSC;
        }


        console.log("this.state.questionMap = ", this.state.questionMap);
        console.debug("current subctegory ", randomSubCategory)
        this.setState({ currentFeedbackSubCategory: randomSubCategory })
        var tempQuestionID = randomSubCategory + "_" + randomQuestionID;
        console.log("this.state.temp - QuestionID = ", tempQuestionID,
          "Cat RI = ", this.state.CatRI[randomCategory] + 1,
          "SubCat RI = ", this.state.SubCatRI[randomSubCategory] + 1,
        );
      }

      var randomQuestion = this.state.questionMap[tempQuestionID] ? { ...this.state.questionMap[tempQuestionID] } : undefined;
      this.setState({
        feedbackCurrentQuestion: this.state.questionMap[tempQuestionID]
      })
      // Check this randomQuestionID is exists in this.state
      questionAnswerStateData = this.getQuestionAnswerState(tempQuestionID);
      console.log("this.state.randomQuestion = ", randomQuestion);
      this.setState({
        currentQuestionObj: randomQuestion,
      })

      //  tempDisplayQuestionText = randomQuestion.question_text;
      //  tempDisplayAnswerArr = randomQuestion.answers;
      // if(randomQuestion.randomize_answer === 1){
      //   tempDisplayAnswerArr = this.shuffle(tempDisplayAnswerArr);
      // }


      tempDisplayQuestionText = randomQuestion.question_text;

      //Alt Question text
      if (randomQuestion.alt_question_text !== undefined && randomQuestion.alt_question_text !== null &&
        randomQuestion.alt_question_text !== "") {
        try {
          var altQueText = randomQuestion.alt_question_text
          altQueText = altQueText.replace(/\n/ig, ' ')
          //finding number of time image present
          var altQueTextCount = altQueText.split(';').length
          var imgTagCount = tempDisplayQuestionText.split('<img').length - 1
          console.debug((altQueTextCount / 2), "==", imgTagCount, "    ", altQueText.split(';').length, tempDisplayQuestionText.split('<img').length)
          if ((altQueTextCount / 2) == imgTagCount) {
            if (imgTagCount >= 1) {
              console.debug("greater than 1")
              var altQueTextArr = altQueText.split(';');
              var lastPosOfImg = 0
              console.debug(altQueTextArr.length)
              for (var i = 0; i <= altQueTextArr.length - 1; i = i + 2) {
                lastPosOfImg = tempDisplayQuestionText.indexOf("<img", lastPosOfImg)
                lastPosOfImg = lastPosOfImg + 4
                var b = "  title =\"" + altQueTextArr[i] + "\"  alt =\"" + altQueTextArr[i + 1] + "\" "
                var output = [tempDisplayQuestionText.slice(0, lastPosOfImg), b, tempDisplayQuestionText.slice(lastPosOfImg)].join('');
                tempDisplayQuestionText = output
                //console.debug("test ",tempDisplayQuestionText)
              }
            }
          }/*else{
              var posOfImg = tempDisplayQuestionText.search("<img");
              posOfImg = posOfImg + 4
              var b = " alt =\""+altQueText+"\" "
              var output = [tempDisplayQuestionText.slice(0, posOfImg), b, tempDisplayQuestionText.slice(posOfImg)].join('');
              tempDisplayQuestionText = output
              }*/
          //console.debug(imgTagCount,"position of image    ",tempDisplayQuestionText," ")
        } catch (e) {
          console.debug("ERROR in Alt Text  ", e)
        }
      }
      //Alt question Text



      tempDisplayAnswerArr = randomQuestion.answers?.map(ans => {
        return {
          ...ans,
          subject_id: randomQuestion.subject_id,
          topic_id: randomQuestion.topic_id,
          category_id: randomQuestion.category_id,
          subcategory_id: randomQuestion.subcategory_id,
        }
      });
      console.debug("randomQuestion.answers", randomQuestion)
      tempDisplayAnswerArr?.forEach((_, index) => {
        if (tempDisplayAnswerArr[index].isChecked) {
          tempDisplayAnswerArr[index].isChecked = false
        }
      })
      //TODO:Append New Random vector Values
      if (randomQuestion.question_type === 0 && [70, 80].includes(randomQuestion.answer_type)) {
        tempDisplayAnswerArr?.forEach((answerArr, cIndex) => {
          const vectorVariableMap = VectorParserUtil.buildQuestionVariablesMap(answerArr?.vectorAnswerVariable);
          let vectorSettingsData = randomQuestion.vector_settings_data
          // Calculate newVectorValues
          const newVectorValues = vectorVariableMap
            ? vectorVariableMap.getVectorsArray(
              vectorSettingsData.enableIdenticalVector,
              vectorSettingsData
            ).filter(value => value !== undefined)
            : [];

          // Check if newVectorValues is an array and has elements
          if (Array.isArray(newVectorValues) && newVectorValues.length > 0) {
            // Assign newVectorValues to answerArr
            answerArr.newVectorValues = [...newVectorValues];
          }
        })
      }
      // console.debug("tempDisplayAnswerArr ", tempDisplayAnswerArr);

      //Alt answer text
      try {
        for (var i = 0; i <= randomQuestion.answers.length - 1; i++) {
          if (randomQuestion.answers[i].answer_text !== undefined && randomQuestion.answers[i].answer_text !== null &&
            randomQuestion.answers[i].answer_text !== "" && randomQuestion.answers[i].alt_answer_text !== undefined &&
            randomQuestion.answers[i].alt_answer_text !== null && randomQuestion.answers[i].alt_answer_text !== "") {
            var tempDisplayAnwserText = randomQuestion.answers[i].answer_text
            var altAnsText = randomQuestion.answers[i].alt_answer_text
            altAnsText = altAnsText.replace(/\n/ig, ' ')
            //finding number of time image present
            var altAnsTextCount = altAnsText.split(';').length
            var imgTagCount = tempDisplayAnwserText.split('<img').length - 1
            // console.debug("altAnsTextCount ,imgTagCount ",altAnsTextCount,imgTagCount,randomQuestion.answers.length-1)
            console.debug((altAnsTextCount / 2), "==", imgTagCount)
            if ((altAnsTextCount / 2) == imgTagCount) {
              if (imgTagCount >= 1) {
                // console.debug("Answer greater than 1")
                var altAnsTextArr = altAnsText.split(';');
                var lastPosOfImg = 0
                // console.debug("altanswer",altAnsTextArr)
                for (var j = 0; j <= altAnsTextArr.length - 1; j = j + 2) {
                  // console.debug(j)
                  lastPosOfImg = tempDisplayAnwserText.indexOf("<img", lastPosOfImg)
                  lastPosOfImg = lastPosOfImg + 4
                  var b = "  title =\"" + altAnsTextArr[j] + "\"  alt =\"" + altAnsTextArr[j + 1] + "\" "
                  var output = [tempDisplayAnwserText.slice(0, lastPosOfImg), b, tempDisplayAnwserText.slice(lastPosOfImg)].join('');
                  tempDisplayAnwserText = output
                  // console.debug("answertest",j ," " ,tempDisplayAnwserText)
                }
              }
            }

            /*else{
              var posOfImg = tempDisplayAnwserText.search("<img");
              posOfImg = posOfImg + 4
              var b = " alt =\""+altAnsText+"\"  title =\""+altAnsTextArr[j+1]+"\" "
              var output = [tempDisplayAnwserText.slice(0, posOfImg), b, tempDisplayAnwserText.slice(posOfImg)].join('');
              tempDisplayAnwserText = output
              }*/
            // console.debug("answerTExt",imgTagCount,"position of image ",posOfImg,"   ",tempDisplayAnwserText," ")
            tempDisplayAnswerArr[i].answer_text = tempDisplayAnwserText
            console.debug("tempDisplayAnswerArr[i]>>", tempDisplayAnswerArr[i])
            tempDisplayAnswerArr[i].isChecked = false
          }

        }
      } catch (e) {
        console.debug("ERROR in Alt answer Text and feedback ", e)
      }
      //Alt answer Text

      // QUESTION TYPE = 1 = Randomized Parameters
      if (randomQuestion.question_type === 1 && randomQuestion.answer_type !== 2) {
        if (tempDisplayAnswerArr === null || tempDisplayAnswerArr === undefined) {
          tempDisplayAnswerArr = [];
        }
        const AnswerArr = [...tempDisplayAnswerArr];
        let tempVariableMap = MathParserUtil.buildQuestionVariablesMap(randomQuestion.question_variables);
        if (tempVariableMap && tempVariableMap.isValid()) {
          tempVariableMap.generateValues();
          let RPAnswerArr = MathParserUtil.stringToValueRPAnswer(AnswerArr, tempVariableMap)
          let shouldRandomize = false;
          let firstAttempt = true;
          let i = 0;
          do {
            if (firstAttempt) {
              shouldRandomize = MathParserUtil.shouldRandomize(RPAnswerArr);
            }
            if (shouldRandomize) {
              tempVariableMap.generateValues();
            }
            RPAnswerArr = MathParserUtil.stringToValueRPAnswer(AnswerArr, tempVariableMap)
            shouldRandomize = MathParserUtil.shouldRandomize(RPAnswerArr);
            firstAttempt = false;
            i++;
            //For Avoid Crashing
            if (i >= 10) {
              console.log("Randomized Continously.. Crash State..")
              break;
            }
          } while (shouldRandomize);

          if (questionAnswerStateData) {
            tempVariableMap = VariableMap.fromString(questionAnswerStateData.rp_variable_map_string);
          } else {
            let rp_variable_map_string = tempVariableMap.toString();
            if (questionAnswerStateData === null) {
              this.addSingleQuestionAnswerState({
                rp_variable_map_string,
              }, randomQuestion);
            }
          }

          this.setState({
            currentVariableMap: tempVariableMap,
          })
        }
      }


      //console.debug("tempDisplayAnswerArr ",tempDisplayAnswerArr);
      if (randomQuestion.randomize_answer === 1 && randomQuestion.answer_type !== 2) {
        tempDisplayAnswerArr = this.shuffle(tempDisplayAnswerArr);
      }

      if (randomQuestion.answerDisplayStyle !== undefined) {
        answerDisplayStyleLocal = randomQuestion.answerDisplayStyle;
      }

      /* if(this.state.NOCQC === 1){
        if(remainingCategorySet.length <= 1){

          if(this.state.isCategoryRandom === true){
            remainingCategorySet = this.state.categoryArray.slice();
          }
          else{
            remainingCategorySet = this.state.categorySet.slice();
          }
        }
        if(remainingCategorySet.length > 1){
          var remIdx = remainingCategorySet.indexOf(randomCategory);

          if(remIdx  !== -1) {
            remainingCategorySet.splice(remIdx, 1);
          }
        }
        console.log("remainingCategorySet = ", remainingCategorySet);
      } */
    }


    //TODO: Implement the Algorithm
    /* if (randomQuestion.question_type === 1) {
      const tempVariableMap = MathParserUtil.buildQuestionVariablesMap(randomQuestion.question_variables);
      if (tempVariableMap && tempVariableMap.isValid()) {
        tempVariableMap.generateValues();
        this.setState({
          currentVariableMap: tempVariableMap,
        })
      }
    } */


    // QUESTION TYPE = 3 = Vector Arrow Rand. Par
    if (randomQuestion.question_type === 3 || (randomQuestion.question_type === 0 && randomQuestion.answerDisplayStyle == 90)) {
      console.log("tempVectorsVarMap = ", this.state.questionMap);
      console.log("tempVectorsVarMap = ", randomQuestion.vector_question_variables);
      const tempVectorsVarMap = VectorParser.buildQuestionVariablesMap(randomQuestion.vector_question_variables);
      if (tempVectorsVarMap && tempVectorsVarMap.isValid()) {
        tempVectorsVarMap.generateValues();
        console.log("tempVectorsVarMap =>>", tempVectorsVarMap);
        if (questionAnswerStateData === null) {
          this.setState({
            currentVectorVariable: tempVectorsVarMap,
          })
        } else {
          let vectorVariable = VectorVariableMap.fromString(questionAnswerStateData.vector_variable_map_string);
          this.setState({
            currentVectorVariable: vectorVariable,
          })
        }
      }
    }

    // Reasoning chain type question
    if (randomQuestion.question_type === 4) {
      console.debug("randomQuestion?.conclusion_sentences", randomQuestion?.conclusion_sentences)
      this.setState({
        reasoningElements: randomQuestion?.reasoning_elements ? randomQuestion?.reasoning_elements : [],
        connectingWords: randomQuestion?.connecting_words ? randomQuestion?.connecting_words : [],
        conclusionSentences: randomQuestion?.conclusion_sentences ? randomQuestion?.conclusion_sentences : [],
        isConclusionSentenceRequired: randomQuestion?.is_conclusion_sentence_required,
        showReasoningElementCategoryInfo: randomQuestion?.show_reasoning_element_category_info,
      })
    }

    //console.log("tempDisplayQuestionText = ", tempDisplayQuestionText);
    console.debug("tempDisplayAnswerArr>>>>>>>>????", tempDisplayAnswerArr)
    tempDisplayQuestionText = tempDisplayQuestionText.replaceAll("<figure>", "")
    tempDisplayQuestionText = tempDisplayQuestionText.replaceAll("</figure>", "")

    this.setState({
      questionStartTime: new Date(),
      displayQuestionText: tempDisplayQuestionText,
      displayAnswerArr: tempDisplayAnswerArr,
      answerType: randomQuestion.answer_type,
      forCheckBoxQuestion: randomQuestion.for_checkbox_question,
      randomQuestionID: randomQuestionID,
      randomSubCategory: randomSubCategory,
      randomCategory: randomCategory,
      answerDisplayStyle: answerDisplayStyleLocal,
      currentQuestionType: randomQuestion.question_type,
      mqt_options: randomQuestion.mqt_options,
      currentVectorSettings: randomQuestion.vector_settings_data,
      answer_formula: randomQuestion.answer_formula ? { ...randomQuestion.answer_formula, formulaMap: randomQuestion.answer_formula.formulaArray ? MathParserUtil.buildAnswerFormulasMap(randomQuestion.answer_formula.formulaArray) : null } : null,
      vectorAnswerFormulas: randomQuestion.vector_answer_formulas,
      freeFormVectorOptions: randomQuestion.freeform_vector_options,
      vectorBelowQuestionText: randomQuestion.vector_below_question_text
    }, () => {
      if (this.state.isTest !== 1) {
        this.getExplanationData();
        this.getTutorialsData();
      }

      const currentQuestionKey = `${this.state.randomSubCategory}_${this.state.randomQuestionID}`;
      if (previousQuestionKey !== currentQuestionKey || this.shouldFocusEmbeddedTutorialQuestion) {
        this.shouldFocusEmbeddedTutorialQuestion = false;
        this.focusEmbeddedTutorialQuestion();
      }
    }


    )
    // Standard, Multiple Question Grid, Reasoning Chain, 
    if ((randomQuestion.question_type === 0 || randomQuestion.question_type === 2 || randomQuestion.question_type === 4)
      && questionAnswerStateData === null) {
      this.addSingleQuestionAnswerState({}, randomQuestion)
    }
    // }else{

    // }


    if (this.state.isTest === 1) {
      this.setState({
        pageLoading: false,
        showSubmitLoader: false
      });
    }

  }

  shuffle(arra1) {
    if (arra1) {
      var ctr = arra1.length, temp, index;

      // While there are elements in the array
      while (ctr > 0) {
        // Pick a random index
        index = Math.floor(Math.random() * ctr);
        // Decrease ctr by 1
        ctr--;
        // And swap the last element with it
        temp = arra1[ctr];
        arra1[ctr] = arra1[index];
        arra1[index] = temp;
      }
    }
    return arra1;
  }


  finish() {
    this.stopQuizTimer();

    let sectionID = parseInt(this.params.get("section_id"))

    let practiceCompletedURL = `/practiceCompleted?quizID=${this.state.quizId}&sectionID=${sectionID}&courseID=${this.state.courseID}&quizName=${this.state.quizName}&isTutorial=${this.state.isTutorial}`
    this.props.handleRoute(practiceCompletedURL);
  }

  submitAssignment = () => {
    this.props.apiService({
      method: 'post',
      url: '/submitAssignment',
      data: {
        quiz_id: this.state.quizId,
        practice_count: this.state.practiceCount,
        parent_quiz_id: this.state.parentQuizID,
      },
    }).then(res => {
      if (res && res.data) {
        if (res.data.status === 0) {
          this.finish();
        } else {
          // console.debug("res.data.message", res.data.message);
        }
      }
    })
  }


  fetchSurveyQuestions() {
    const payload = {

      quiz_id: this.state.quizId,
      user_id: this.state.userId,
      parent_quiz_id: this.state.parentQuizID,
    }

    console.log("isSurveyOn", this.state.isSurveyOn);
    this.setState({ pageLoading: true });
    this.props.apiService({
      method: 'post',
      url: '/getSurveyQuestions',
      data: payload,

    })
      .then(res => {
        if (res !== undefined && res !== null && res.data !== undefined && res.data !== null &&
          res.data.data !== undefined && res.data.data !== null && res.data.data.questions !== undefined &&
          res.data.data.questions !== null) {
          console.log("getSurveyQuestions = ", res.data.data);

          var tempSurveyQuestionMap = {};
          var tempSurveyQuestionAnswerMap = {};
          var tempSurveyQuestionIdArr = [];

          var tempSurveyQuestionsArr = res.data.data.questions;
          console.log("tempSurveyQuestionsArr", tempSurveyQuestionsArr);

          for (var i = 0; i < tempSurveyQuestionsArr.length; i++) {


            var tempQuestionID = tempSurveyQuestionsArr[i].subject_id + "_" +
              tempSurveyQuestionsArr[i].topic_id + "_" +
              tempSurveyQuestionsArr[i].category_id + "_" +
              tempSurveyQuestionsArr[i].subcategory_id + "_" +
              tempSurveyQuestionsArr[i].question_id;

            tempSurveyQuestionIdArr.push(tempQuestionID);

            tempSurveyQuestionMap[tempQuestionID] = {
              "question_id": tempSurveyQuestionsArr[i].question_id,
              "question_text": tempSurveyQuestionsArr[i].question_text,
              "topic_id": tempSurveyQuestionsArr[i].topic_id,
              "subject_id": tempSurveyQuestionsArr[i].subject_id,
              "category_id": tempSurveyQuestionsArr[i].category_id,
              "subcategory_id": tempSurveyQuestionsArr[i].subcategory_id,
              "answer_type": tempSurveyQuestionsArr[i].answer_type,
              "randomize_answer": tempSurveyQuestionsArr[i].randomize_answer,
              "is_text_above_image": tempSurveyQuestionsArr[i].is_text_above_image,
              "answers": tempSurveyQuestionsArr[i].answers,
              "evaluate_question": tempSurveyQuestionsArr[i].evaluate_question,
              "image_library_id": tempSurveyQuestionsArr[i].image_library_id,
              "survey_question": tempSurveyQuestionsArr[i].survey_question
            }



          }
          console.log("this.state.surveyQPointer", this.state.surveyQPointer);

          var tempRandomQuestion = tempSurveyQuestionIdArr[this.state.surveyQPointer];
          console.log("tempRandomQuestionID = ", tempRandomQuestionID);

          var tempQuestionDetails = tempRandomQuestion.split("_");
          var tempRandomQuestionID = tempQuestionDetails[4];

          var tempRandomSubCategory = tempQuestionDetails[0] + "_" + tempQuestionDetails[1] + "_" +
            tempQuestionDetails[2] + "_" + tempQuestionDetails[3];

          this.setState({
            surveyQuestionMap: tempSurveyQuestionMap,
            surveyQuestionIdArr: tempSurveyQuestionIdArr,
            randomQuestionID: tempRandomQuestionID,
            randomSubCategory: tempRandomSubCategory,

            surveyQuestionsRetrieved: !this.state.surveyQuestionsRetrieved,
            pageLoading: false,
            hideNext: true,

          }, () => {
            console.log("tempSurveyQuestionMap", this.state.surveyQuestionMap);
            console.log("surveyQuestionsRetrieved = ", this.state.surveyQuestionsRetrieved);
            this.displaySurveyQuestion();
          });





        }
        else {
          this.finish();
        }

      })
  }

  displaySurveyQuestion() {

    console.log("this.state.randomQuestionID", this.state.randomQuestionID);
    console.log("this.state.randomQuestionID", this.state.randomSubCategory);
    console.log("this.state.surveyQuestionMap", this.state.surveyQuestionMap);
    console.log("this.state.surveyQuestionMap", this.state.surveyQuestionMap[this.state.randomQuestionID]);
    var tempQuestionDetails = null;
    if (this.state.randomQuestionID !== null) {

      var randomQuestion = this.state.surveyQuestionMap[this.state.randomSubCategory + "_" + this.state.randomQuestionID];
      this.setState({
        displayQuestionText: randomQuestion.question_text,
        displayAnswerArr: randomQuestion.answers,
        answerType: randomQuestion.answer_type,
        forCheckBoxQuestion: randomQuestion.for_checkbox_question,
        //randomCategory:randomCategory,
        answerDisplayStyle: randomQuestion.answerDisplayStyleLocal,
        pageLoading: false,
        currentVariableMap: MathParserUtil.buildQuestionVariablesMap(randomQuestion.question_variables),
        currentQuestionType: randomQuestion.question_type,
      });
    }
  }


  isNonGradedQuestion() {
    const tempQuestionID = this.state.randomSubCategory + "_" + this.state.randomQuestionID;
    const tempSubcategoriesMap = this.state.subcategoriesMap;
    const currentQuestion = this.state.questionMap[tempQuestionID];

    if (tempSubcategoriesMap && tempSubcategoriesMap[this.state.randomSubCategory] && tempSubcategoriesMap[this.state.randomSubCategory].non_graded === 1) {
      return true;
    }

    if (currentQuestion.question_nongraded !== undefined &&
      currentQuestion.question_nongraded !== null) {

      if (currentQuestion.question_nongraded === 1) {
        return true;
      }
    }


    return false;
  }

  checkIfAllQuestionsAreAnswered() {
    // console.debug("this.state.answersMap>>>>", this.state.answersMap)
    for (let mainQAIndex = 0; mainQAIndex < this.state.mainQAArray.length; mainQAIndex++) {
      let mainQA = this.state.mainQAArray[mainQAIndex];
      let question = mainQA.question;
      let uniqueID = `${question.subject_id}_${question.topic_id}_${question.category_id}_${question.subcategory_id}_${question.question_id}`;

      /* if (question.question_type === 2 && !this.checkIfMQTAnswersSelectedForQuestion(question, this.state.answersMap[uniqueID])) {
        return false;
      } */

      if (!this.hasValidValue(this.state.answersMap[uniqueID], question)) {
        return false
      }

    }

    return true;

  }

  async shallSubmitOnePageTest() {

    let isQAnswered = this.checkIfAllQuestionsAreAnswered();
    if (isQAnswered) {
      return true;
    }

    const result = await this.showAlert("Gentle reminder", "You have some unanswered questions (see the left sidebar for details). You cannot attend the assignment later. Submit anyway?", "Submit", "Cancel");
    // console.debug("result???", result)
    if (!result) {
      return false;
    }

    return true;
  }

  saveOnePageTest(question, answersMap) {
    let uniqueID = `${question.subject_id}_${question.topic_id}_${question.category_id}_${question.subcategory_id}_${question.question_id}`;

    let ans = answersMap[uniqueID];

    if (question.question_type === 2) {
      ans = { ...ans };
    }

    this.updateAnswerState({
      unique_id: uniqueID,
      subject_id: question.subject_id,
      topic_id: question.topic_id,
      category_id: question.category_id,
      subcategory_id: question.subcategory_id,
      question_id: question.question_id,
      quiz_id: this.state.quizId,
      section_id: parseInt(this.params.get("section_id")),
      student_answer_string: JSON.stringify(ans),
      parent_quiz_id: this.state.parentQuizID,
    })
  }

  updateAnswerState(payload) {
    this.setState({
      onePageTestSaving: true,
      lastSavedAt: "",
    })
    this.props.apiService({
      method: 'post',
      url: '/updateAnswerState',
      data: payload,
    }).then((res) => {
      if (res && res.data) {
        if (res.data.message === "quiz time over") {
          this.setState({
            testWindowEnded: true, pageLoading: false,
            showSplashScreen: true
          });
          return;
        }
      }
    }).finally(() => {
      this.setState({
        onePageTestSaving: false
      })
    })
  }

  updateQuestionState(payload) {
    this.props.apiService({
      method: 'post',
      url: '/updateQuestionState',
      data: {
        ...payload,
        parent_quiz_id: this.state.parentQuizID,
      },
    }).then((res) => {
      if (res && res.data) {
        if (res.data.message === "quiz time over") {
          this.setState({
            testWindowEnded: true, pageLoading: false,
            showSplashScreen: true
          });
        }
      }
    })

  }

  deleteAllQuestionAnswerState() {
    return this.props.apiService({
      method: 'post',
      url: '/deleteAllQuestionAnswerState',
      data: {
        quiz_id: this.state.quizId,
        parent_quiz_id: this.state.parentQuizID, 
      },
    });
  }

  async onSubmitOnePageTest() {

    // check if all mqg grid quetions are answered
    for (let mainQAIndex = 0; mainQAIndex < this.state.mainQAArray.length; mainQAIndex++) {
      let mainQA = this.state.mainQAArray[mainQAIndex];
      let question = mainQA.question;
      let uniqueID = `${question.subject_id}_${question.topic_id}_${question.category_id}_${question.subcategory_id}_${question.question_id}`;

      if (question.question_type === 2 && !this.checkIfMQTAnswersSelectedForQuestion(question, this.state.answersMap[uniqueID])) {
        NotificationManager.warning(`Please choose an answer for each Multiple Grid Question for "Question: ${mainQAIndex + 1}"`, '', 3000)
        return
      }
    }

    let val = await this.shallSubmitOnePageTest()
    if (!val) return;


    let payloadArr = [];
    let answersMap = this.state.answersMap;

    for (let mainQAIndex = 0; mainQAIndex < this.state.mainQAArray.length; mainQAIndex++) {
      const mainQA = this.state.mainQAArray[mainQAIndex];

      let question = mainQA.question;
      var currentQuestion = question;

      var userID = this.state.userId;;
      let uniqueID = `${question.subject_id}_${question.topic_id}_${question.category_id}_${question.subcategory_id}_${question.question_id}`;

      // check if answersMap has real value
      const amValue = answersMap[uniqueID];
      if (amValue === undefined || amValue === null) continue;
      if (amValue && typeof amValue === 'object' && Object.keys(amValue).length === 0) continue;
      if (amValue && amValue.length === 0) continue;
      if (amValue && typeof amValue === 'string' && amValue === "") continue;


      var quizName = decodeURIComponent(this.params.get("quiz_name"));//"test 123";
      var tempCategoriesMap = this.state.categoriesMap;


      if (this.state.surveyQuestionsRetrieved === false) {

        var tempAnswerChoosen = answersMap[uniqueID];

        var answerText = ""
        var tempSelectedAnswer = "";
        //MQT Selected Answer
        if (currentQuestion.question_type === 2) { // Multiple Grid
          tempSelectedAnswer = JSON.stringify(tempAnswerChoosen);
        } else if (currentQuestion.answer_type === 0 || currentQuestion.answer_type === 70) {
          //Radio button
          //answer string convert to array
          tempSelectedAnswer = tempAnswerChoosen.toString();
          var tempAnsArray = [];
          tempAnsArray.push(parseInt(tempAnswerChoosen));
          tempAnswerChoosen = tempAnsArray;
        } else if (currentQuestion.answer_type === 1 || currentQuestion.answer_type === 80) {
          //Checkbox
          // answers already array
          var tempAnsArray = [];
          if (tempAnswerChoosen !== undefined && tempAnswerChoosen.length > 0) {
            for (var i = 0; i < tempAnswerChoosen.length; i++) {
              tempAnsArray.push(parseInt(tempAnswerChoosen[i]))
              if (tempSelectedAnswer != "") {

                tempSelectedAnswer = tempSelectedAnswer + "," + tempAnswerChoosen[i].toString();
              } else {
                tempSelectedAnswer = tempAnswerChoosen[i].toString();
              }

            }
            console.log("check box tempAnsArray", tempAnsArray)
            tempAnswerChoosen = tempAnsArray;
          }
          console.log("check box tempAnswerChoosen", tempAnswerChoosen)
        } else {
          // answer textbox
          answerText = tempAnswerChoosen;
          tempSelectedAnswer = tempAnswerChoosen;
        }

        console.log("tempAnswerChoosen = ", tempAnswerChoosen);

        // is test API call
        console.log("*******Test*************");

        var tempQuestionMap = currentQuestion;
        var answerText = "";

        if (tempQuestionMap.answer_type !== undefined && tempQuestionMap.answer_type !== null &&
          (tempQuestionMap.answer_type === 2 || tempQuestionMap.answer_type === 90)) {
          answerText = answersMap;
          tempAnswerChoosen = [];
        }

        if (currentQuestion.question_type === 2) {
          const selectedAnswers = Object.keys(answersMap[uniqueID]).map((questionKey) => {
            if (currentQuestion.mqt_options.mqt_answer_header === true) {
              return answersMap[uniqueID][questionKey].map(val => {
                return (parseInt(val.charAt(0), 10)).toString();
              });
            } else {
              return answersMap[uniqueID][questionKey].map(val => (val).toString());
            }
          })
          answerText = JSON.stringify(selectedAnswers);
          // console.debug("selectedAnswers>>>", selectedAnswers)
        }
        const ltiUserID = this.params.get("ltiUserID");
        let stringSelectedAnswersMap = {};
        let selectedAnswer = answersMap[uniqueID];
        let scietificAnswer = this.state.scientificAnswerEvalMap[uniqueID];
        if (selectedAnswer) {
          Object.keys(selectedAnswer).forEach(key => {
            if (mainQA.currentVariableMap?.get(key) && mainQA.currentVariableMap?.get(key).type === "LIST") {
              //Ignore Number Formating for List TYPE since it is a string
              stringSelectedAnswersMap[key] = selectedAnswer[key] ? selectedAnswer[key] : "";
            } else {
              if (
                (
                  (question.question_type === 1 && question.answer_type === 3 && (question.answerDisplayStyle === 2 ||
                    question.answerDisplayStyle === 3
                  ))
                  ||
                  (question.question_type === 3 && question.answer_type === 3 && (question.answerDisplayStyle === 2))
                )
              ) {

                let answer = selectedAnswer[key];
                if (question.answerDisplayStyle === 2) { // Explicit scientific notation
                  answer = answer.replace("x", "*");
                }

                if (question.answerDisplayStyle === 3) { // Fraction
                  stringSelectedAnswersMap[key] = selectedAnswer[key] || selectedAnswer[key] === 0 ? Number(math.eval(answer)).toString() : "";
                } else {
                  stringSelectedAnswersMap[key] = selectedAnswer[key] || selectedAnswer[key] === 0 ? Number(simplify(answer)).toString() : "";
                }
              } else {
                stringSelectedAnswersMap[key] = selectedAnswer[key] || selectedAnswer[key] === 0 ? Number(selectedAnswer[key]).toString() : "";
              }
            }
          });
        }

        var testSavedData = {
          "quiz_id": this.state.quizId,
          "user_id": userID,
          "subject_id": question.subject_id,
          "topic_id": question.topic_id,
          "category_id": question.category_id,
          "subcategory_id": question.subcategory_id,
          "question_id": question.question_id,
          "quizName": quizName,
          "chosen_answer_array": tempAnswerChoosen,
          "category_name": "",
          "category_label": "",
          "ques_att": 20,
          "answer_text": answerText,
          "over_all_question_count": this.state.totalQuestions,
          "question_type": question.question_type,
          "selected_answer_map": answersMap[uniqueID],
          "rp_answers_map": stringSelectedAnswersMap, //This will processed differently in server from selected_answer_map
          "que_elapsed_time": Math.trunc((new Date().getTime() - this.startTime) / 1000),
          "section_id": parseInt(this.params.get("section_id")),
          "course_id": parseInt(this.params.get("course_id")),
          "subsection_id": parseInt(this.state.subSectionID),
          "answer_type": question.answer_type,
          "for_checkbox_question": question.for_checkbox_question,
          "question_variables": mainQA.currentVariableMap ? MathParserUtil.mapToObj(mainQA.currentVariableMap) : {},
          "selected_answer": !isNaN(answersMap[uniqueID]) ? answersMap[uniqueID].toString() : "",
          "ltiUserID": ltiUserID,
          "selectedAnswerDetails": answersMap[uniqueID], // TODO
          answerDisplayStyle: currentQuestion.answerDisplayStyle
        };

        let isCorrect = false;
        isCorrect = this.checkAnswerIsCorrectForQuestion(mainQA, answersMap)
        // console.debug("uniqueID, isCorrect", uniqueID, isCorrect, testSavedData, question)

        if (question.question_type === 3 && question.answer_type === 2) {
          const score = isCorrect ? 1 : 0;
          testSavedData.is_answer_correct = score;
          const {
            vector_answer_formulas,
          } = currentQuestion;

          const currentVectorVariable = mainQA.tempVectorsVarMap;
          let selectedAnswer = answersMap[uniqueID];

          const correctAnswerStringArr = VectorParser.getAllCorrectAnswers(vector_answer_formulas, currentVectorVariable);
          if (correctAnswerStringArr.length > 0) {
            testSavedData.rp_correct_answer = correctAnswerStringArr.join();
          } else {
            testSavedData.rp_correct_answer = "";
          }
          const selectedAnswerStringArr = VectorParser.getAllSelectedAnswers(selectedAnswer, currentVectorVariable)
          if (selectedAnswerStringArr.length > 0) {
            testSavedData.selected_answer = `<p>{<br>${selectedAnswerStringArr.join(',<br>')}<br>}</p>`;
          }
        }

        //Draw vector combination 2.0
        if ((question.question_type === 0 && question.answer_type === 90)) {
          const score = isCorrect ? 1 : 0;
          testSavedData.is_answer_correct = score;
        }

        if (question.question_type === 2) {
          let newSelectedAnswerMap = {};
          Object.keys(testSavedData.selected_answer_map).map(key => {
            newSelectedAnswerMap[key] = testSavedData.selected_answer_map[key];
          })
          testSavedData.selected_answer_map = newSelectedAnswerMap;
        }

        payloadArr.push(testSavedData);

      }

    }

    // console.debug("testSavedData PAYLOADArray", payloadArr, this.state.answersMap, this.state.scientificAnswerEvalMap);

    this.props.apiService({
      method: 'post',
      url: '/submitOnePageTest',
      data: {
        'quiz_id': this.state.quizId,
        parent_quiz_id: this.state.parentQuizID,
        'section_id': parseInt(this.params.get("section_id")),
        data: payloadArr
      },

    })
      .then(res => {

        if (res.data.status == 1 && res.data.message) {
          if (res.data.message === 'quiz time over') {
            this.setState({
              testWindowEnded: true, pageLoading: false,
              showSplashScreen: true
            });
            return;
          }
        }
        console.log("saveTestOnePageMode response =", res);
        if (res !== undefined && res !== null && res.data !== undefined && res.data !== null && res.data !== "") {
          if (res.data.status !== undefined && res.data.status !== null && res.data.status === 1 &&
            res.data.message !== undefined && res.data.message !== null) {
            alert("Unable to save your progress. Please try again later! \n Error : " + res.data.message);

          }
          else if (res.data !== undefined && res.data !== null && res.data !== "") {
            this.finish();
          }
          else {
            console.log("Error - saveTest did not received response from server");
            alert("Server encountered an error. Please try again later!");
            this.props.handleRoute('/troubleShooting');

          }
        }
        else {
          console.log("Error - saveTest did not received response from server");
          alert("Server encountered an error. Please try again later!");
          this.props.handleRoute('/troubleShooting');

        }

      })

  }


  saveProgress(isCorrect) {
    this.setState({ showSkip: false });

    console.log("saveProgress isCorrect = ", isCorrect);
    var userID = this.state.userId;//"test123";
    /*var subjectID = 0;
    var topicID = 0;
    var categoryID = 0;
    var subcategoryID = 0;*/

    var quizName = decodeURIComponent(this.params.get("quiz_name"));//"test 123";
    var quizAttemptCount = this.state.quizAttempt;
    var tempCategoriesMap = this.state.categoriesMap;
    //var score = 0;
    var isAnswerCorrect = 0;
    var randomCategory = this.state.randomCategory;
    var randomSubCategory = this.state.randomSubCategory;
    //var quizQuestions = [];
    var tempQuestionsCorrect = this.state.questionsCorrect;

    //const tempQuestionStartTimeStamp = this.questionStartTimeStamp;



    //var tempAnswerChoosen = this.state.selectedAnswer;

    if (this.state.isTest === 1) {
      let tempNumberOfAttendedQuestions = {
        ...this.state.NumberOfAttendedQuestions,
        [randomCategory]: this.state.NumberOfAttendedQuestions[randomCategory] + 1
      }
      this.setState({
        NumberOfAttendedQuestions: tempNumberOfAttendedQuestions
      })
    }
    if (this.state.surveyQuestionsRetrieved === false) {
      console.log("tempCategoriesMap = ", tempCategoriesMap);
      console.log("tempCategoriesMap for category = ", tempCategoriesMap[this.state.randomCategory]);
      console.log("tempCategoriesMap score= ", tempCategoriesMap[this.state.randomCategory].score);
      console.log("randomCategory = ", randomCategory);

      var tempQuestionsAttended = this.state.questionsAttended;

      var tempCategoryID = randomCategory.split('_');
      var tempRandomSubCategory = this.state.randomSubCategory.split('_');

      var tempAnswerChoosen = this.state.selectedAnswer;
      var cat_qcorrect = 0;

      var tempQuestionID = this.state.randomSubCategory + "_" + this.state.randomQuestionID;
      var currentQuestion = this.state.questionMap[tempQuestionID];
      var answerText = ""
      var tempSelectedAnswer = "";
      //MQT Selected Answer
      if (currentQuestion.question_type === 2) {
        tempSelectedAnswer = JSON.stringify(tempAnswerChoosen);
      } else if (currentQuestion.answer_type === 0 || currentQuestion.answer_type === 70) {
        //Radio button
        //answer string convert to array
        tempSelectedAnswer = tempAnswerChoosen.toString();
        var tempAnsArray = [];
        tempAnsArray.push(parseInt(tempAnswerChoosen));
        tempAnswerChoosen = tempAnsArray;



      } else if (currentQuestion.answer_type === 1 || currentQuestion.answer_type === 80) {
        //Checkbox
        // answers already array
        var tempAnsArray = [];
        if (tempAnswerChoosen !== undefined && tempAnswerChoosen.length > 0) {
          for (var i = 0; i < tempAnswerChoosen.length; i++) {
            tempAnsArray.push(parseInt(tempAnswerChoosen[i]))
            if (tempSelectedAnswer != "") {

              tempSelectedAnswer = tempSelectedAnswer + "," + tempAnswerChoosen[i].toString();
            } else {
              tempSelectedAnswer = tempAnswerChoosen[i].toString();
            }

          }
          console.log("check box tempAnsArray", tempAnsArray)
          tempAnswerChoosen = tempAnsArray;
        }
        console.log("check box tempAnswerChoosen", tempAnswerChoosen)
      } else {
        // answer textbox
        answerText = tempAnswerChoosen;
        tempSelectedAnswer = tempAnswerChoosen;
      }

      var savedData = {
        "quiz_id": this.state.quizId,
        "user_id": userID,
        "subject_id": parseInt(tempCategoryID[0]),
        "topic_id": parseInt(tempCategoryID[1]),
        "category_id": parseInt(tempCategoryID[2]),
        "question_type": currentQuestion.question_type,
        "subcategory_id": parseInt(tempRandomSubCategory[3]),
        "quizName": quizName,
        "category_name": tempCategoriesMap[this.state.randomCategory].categoryName,
        "category_label": tempCategoriesMap[this.state.randomCategory].categoryLabel,
        //"question_start_timestamp":tempQuestionStartTimeStamp,
        "time_taken": new Date().getTime() - this.startTime,
        "mastery_count": this.state.masteryCount,
        "mastery_unit": this.state.skillTotal,
        "selected_answer_map": this.state.selectedAnswer,
        "selected_answer": tempSelectedAnswer,
        "answer_type": currentQuestion.answer_type,
        "for_checkbox_question": currentQuestion.for_checkbox_question,
        "section_id": parseInt(this.params.get("section_id")),
        "course_id": parseInt(this.params.get("course_id")),
        "subsection_id": parseInt(this.state.subSectionID),
        "question_start_timestamp": this.state.questionStartTime,
        "question_end_timestamp": new Date()
      };

      if (this.state.currentQuestionType === 2) {
        let newSelectedAnswerMap = {};
        Object.keys(savedData.selected_answer_map).map(key => {
          newSelectedAnswerMap[key] = savedData.selected_answer_map[key];
        })
        savedData.selected_answer_map = newSelectedAnswerMap;
        savedData.selected_answer = JSON.stringify(newSelectedAnswerMap);
      }

      if (this.state.currentQuestionType === 3 && currentQuestion.answer_type === 2) {
        const {
          vector_answer_formulas,
        } = currentQuestion;
        const { currentVectorVariable, selectedAnswer } = this.state;
        const correctAnswerStringArr = VectorParser.getAllCorrectAnswers(vector_answer_formulas, currentVectorVariable);
        if (correctAnswerStringArr.length > 0) {
          savedData.rp_correct_answer = correctAnswerStringArr.join();
        } else {
          savedData.rp_correct_answer = "";
        }
        const selectedAnswerStringArr = VectorParser.getAllSelectedAnswers(selectedAnswer, currentVectorVariable)
        if (selectedAnswerStringArr.length > 0) {
          savedData.selected_answer = `<p>{<br>${selectedAnswerStringArr.join(',<br>')}<br>}</p>`;
        }
      }

      if (isCorrect === false) {

        isAnswerCorrect = 0;
        var updateData = {};
        savedData.score = 0;
        tempCategoriesMap[this.state.randomCategory].score = 0;

        if (quizAttemptCount !== 0) {

          // update question_showed table- One QUestion is wrong update all
          //category question is_correct answer field  is 0

          console.log("quizAttemptCount  = ", quizAttemptCount);
          var updateDataUserId = userID;

          var updateDataQuizAttempt = this.state.quizAttempt - 1;

          const payload = {

            quiz_id: this.state.quizId,
            user_id: userID,
            quiz_name: quizName,
            category_id: randomCategory,
            quiz_attempt: updateDataQuizAttempt
          }
          //console.log("updateCategoryQuestionScore =",payload);
          // this.props.apiService({
          //     method: 'post',
          //     url: '/updateCategoryQuestionScore',
          //     data: payload,

          // })
          // .then(res => {
          //   console.log("updateCategoryQuestionScore response =",res);
          // })

        }


      }
      else {
        //tempCategoriesMap[this.state.randomCategory].score =tempCategoriesMap[this.state.randomCategory].score+1;
        savedData.score = tempCategoriesMap[this.state.randomCategory].score;

        //     //console.log(tempCategoryArray["score"])
        //     //savedData.score = ++tempCategoryArray["score"];
        //     //savedData.score = 0;
        //     //savedData.is_answer_correct = 1;
        isAnswerCorrect = 1;
        if (tempCategoriesMap[this.state.randomCategory].questionsCorrect !== undefined &&
          tempCategoriesMap[this.state.randomCategory].questionsCorrect !== null) {
          cat_qcorrect = ++tempCategoriesMap[this.state.randomCategory].questionsCorrect;
        }
        else {
          tempCategoriesMap[this.state.randomCategory].questionsCorrect = cat_qcorrect;
        }

        ++tempQuestionsCorrect;


      }
      savedData.cat_qcorrect = cat_qcorrect;
      savedData.ques_corr = tempQuestionsCorrect;

      savedData.NOCQC = this.state.NOCQCMap[randomCategory];
      savedData.is_answer_correct = isAnswerCorrect;

      var cat_qatt = 1;
      if (tempCategoriesMap[this.state.randomCategory].questionsAttempted !== undefined &&
        tempCategoriesMap[this.state.randomCategory].questionsAttempted !== null) {
        cat_qatt = ++tempCategoriesMap[this.state.randomCategory].questionsAttempted;
      } else {
        tempCategoriesMap[this.state.randomCategory].questionsAttempted = cat_qatt;
      }


      savedData.cat_qatt = cat_qatt;
      savedData.ques_att = tempQuestionsAttended + 1;

      ////console.log("before if skillsMasterd ",skillsMasterd);
      savedData.skill_mast = this.state.skillsMasterd;
      //savedData.skillTotal = this.state.masteryCount;
      savedData.quiz_attempt = this.state.quizAttempt
      //savedData.checkedAnswerIs = this.state.checkedAnswerIs;
      //savedData.isTest = 0;
      //savedData.className = clas;

      savedData.question_id = this.state.randomQuestionID;
      savedData.question_attempt = this.state.question_attempt;


      let isNonGraded = this.isNonGradedQuestion();
      console.log("tempAnswerChoosen = ", tempAnswerChoosen);

      const ltiUserID = this.params.get("ltiUserID");

      savedData.ltiUserID = ltiUserID ? ltiUserID : "";
      savedData.parent_quiz_id = this.state.parentQuizID;

      if (this.state.isTest !== 1) {
        console.log("savedData =", savedData);
        this.props.apiService({
          method: 'post',
          url: '/saveQuiz',
          data: savedData,

        })
          .then(res => {

            // console.log("saveQuiz response =",res);
            if (res.data.status == 1 && res.data.message) {
              if (res.data.message === 'quiz time over') {
                this.setState({
                  quizWindowEnded: true, pageLoading: false,
                  showSplashScreen: true
                });
                return;
              }
            }


            if (res !== undefined && res !== null && res.data !== undefined && res.data !== null) {
              if (res.data.status !== undefined && res.data.status !== null
                && res.data.status === 1 &&
                res.data.message !== undefined && res.data.message !== null) {
                alert("Unable to save your progress. Please try again later! \n Error : " + res.data.message);

              }
              else if (res.data.data !== undefined) {
                //TODO : Wheel progress update
                this.setState({ showSubmitLoader: false });

                if (this.state.hasMasteredQuiz && this.state.isSurveyOn === true) {
                  this.fetchSurveyQuestions();
                }
                if (res.data.data.skills_mastered !== undefined && res.data.data.skills_mastered !== null) {
                  let catKey = this.state.randomCategory;
                  let updatedCategoriesData = this.state.categoriesData.map(catData => {
                    let key = `${catData.subject_id}_${catData.topic_id}_${catData.category_id}`;
                    if (catKey === key) {
                      return {
                        ...catData,
                        currentAccuracyGoal: res.data.data.current_accuracy_goal,
                        currentTimeGoal: res.data.data.current_time_goal,
                      }
                    }
                    return catData;
                  });
                  // console.debug("updatedCategoriesData>>>>", updatedCategoriesData)
                  this.setState({
                    skillsMasterd: res.data.data.skills_mastered,
                    categoriesData: updatedCategoriesData,
                    currentAccuracyGoal: res.data.data.current_accuracy_goal,
                    currentTimeGoal: res.data.data.current_time_goal
                  });
                }

                if (res.data.data.score !== undefined && res.data.data.score !== null) {
                  tempCategoriesMap[this.state.randomCategory].score = res.data.data.score;

                }

                if (res.data.data.has_mastered !== undefined && res.data.data.has_mastered !== null && res.data.data.has_mastered === true) {
                  this.setState({ hasMasteredQuiz: true })
                  this.finish();
                }
                if (isNonGraded) {
                  this.onNextClick();
                  /* this.deleteAllQuestionAnswerState().then(res => {
                    this.setState({questionAnswerStates: []})
                    this.onNextClick();
                  }) */
                } else {
                  // setTimeout(() => {
                  let tempQuestionID = this.state.randomSubCategory + "_" + this.state.randomQuestionID;
                  let question = this.state.questionMap[tempQuestionID];
                  let tryAgainButtonDisplay = false;
                  let displayCorrectAnswer = false;
                  let showAnswerResponse = false;
                  let answerCorrect = isCorrect;
                  if (this.state.isTest !== 1) {
                    //Is test is true doesn't buttons
                    if (this.state.maxWrong === this.state.tryAgainCount) {
                      tryAgainButtonDisplay = false;
                      displayCorrectAnswer = true;
                    } else {
                      tryAgainButtonDisplay = true;
                      displayCorrectAnswer = false;
                    }
                    showAnswerResponse = true;

                  }
                  if (isCorrect) {
                    tryAgainButtonDisplay = false;
                    displayCorrectAnswer = false;
                  }

                  let payload = {
                    unique_id: tempQuestionID,
                    subject_id: question.subject_id,
                    topic_id: question.topic_id,
                    category_id: question.category_id,
                    subcategory_id: question.subcategory_id,
                    question_id: question.question_id,
                    quiz_id: this.state.quizId,
                    section_id: parseInt(this.params.get("section_id")),
                    other_state_map_string: ""
                  }

                  let otherStateMap = {
                    tryAgainButtonDisplay,
                    displayCorrectAnswer,
                    feedbackPopupVisible: this.state.feedbackPopupVisible,
                    feedbackAnswer: this.state.feedbackAnswer,
                    feedbackButtonVisible: this.state.feedbackButtonVisible,
                    showAnswerResponse,
                    answerCorrect,
                    submitButtonDisplay: this.state.submitButtonDisplay,
                    hideNext: this.state.hideNext,
                    explanationButtonDisplay: this.state.explanationButtonDisplay,
                  }
                  if (this.state.pausedCategoriesMap && Object.keys(this.state.pausedCategoriesMap).length) {
                    let totalCategoryCount = this.state.categoryForWheel ? this.state.categoryForWheel.length : 0;
                    let pausedCategorCount = this.state.pausedCategoriesMap ? Object.keys(this.state.pausedCategoriesMap).length : 0;
                    let completedCategoryCount = this.getCompletedCategoryCount();
                    let unpausedCategoryCount = totalCategoryCount - pausedCategorCount;
                    if (completedCategoryCount === unpausedCategoryCount) {
                      otherStateMap['showPausedCategoryAlert'] = true
                    }
                  }

                  payload['other_state_map_string'] = JSON.stringify(otherStateMap)

                  this.updateQuestionState(payload)
                  // }, 500);

                }
              }
              else {
                alert("Server encountered an error. Please try again later!");
                this.props.handleRoute('/troubleShooting');

              }

            }
            else {
              alert("Server encountered an error. Please try again later!");
              this.props.handleRoute('/troubleShooting');

            }
          })
          .catch(error => {
            alert("Unable to save your progress. Please try again later! \n Error: : " + error);
            this.props.handleRoute('/troubleShooting');

          });

        let updatedDotProgressMap = { ...this.state.dotProgressMap };
        if (updatedDotProgressMap[this.state.randomCategory]) {
          updatedDotProgressMap[this.state.randomCategory].push(isCorrect);
        } else {
          updatedDotProgressMap[this.state.randomCategory] = [isCorrect]
        }

        this.setState({
          questionsCorrect: tempQuestionsCorrect,
          questionsAttended: tempQuestionsAttended + 1,
          categoriesMap: tempCategoriesMap,
          isCurrentQuestionNonGraded: isNonGraded,
          dotProgressMap: updatedDotProgressMap,
        })

      }
      else {
        // is test API call
        console.log("*******Test*************");

        console.log("randomCategory.split = ", randomCategory.split('_'));
        var randomSubCategory = this.state.randomSubCategory.split('_');
        console.log("randomSubCategory.split = ", randomSubCategory[3]);

        var tempQuestionMap = this.state.questionMap[this.state.randomSubCategory + "_" + this.state.randomQuestionID];
        var answerText = "";

        if (tempQuestionMap.answer_type !== undefined && tempQuestionMap.answer_type !== null &&
          (tempQuestionMap.answer_type === 2 || tempQuestionMap.answer_type === 90)) {
          answerText = this.state.selectedAnswer;
          tempAnswerChoosen = [];
        }

        if (this.state.currentQuestionType === 2) {
          // console.debug("this.state.selectedAnswer>>?", this.state.selectedAnswer)
          const selectedAnswers = Object.keys(this.state.selectedAnswer).map((questionKey) => {
            if (this.state.mqt_options.mqt_answer_header === true) {
              return this.state.selectedAnswer[questionKey].map(val => {
                return (parseInt(val.charAt(0), 10)).toString();
              });
            } else {
              return this.state.selectedAnswer[questionKey].map(val => (val).toString());
            }
          })
          answerText = JSON.stringify(selectedAnswers);

        }
        var tempCategoryID = randomCategory.split('_');
        const ltiUserID = this.params.get("ltiUserID");
        let stringSelectedAnswersMap = {};
        if (this.state.selectedAnswer) {
          Object.keys(this.state.selectedAnswer).forEach(key => {
            if (this.state.currentVariableMap?.get(key) && this.state.currentVariableMap?.get(key).type === "LIST") {
              //Ignore Number Formating for List TYPE since it is a string
              stringSelectedAnswersMap[key] = this.state.selectedAnswer[key] ? this.state.selectedAnswer[key] : "";
            } else {
              stringSelectedAnswersMap[key] = this.state.selectedAnswer[key] || this.state.selectedAnswer[key] === 0 ? Number(this.state.selectedAnswer[key]).toString() : "";
            }

          });
        }

        var testSavedData = {
          "quiz_id": this.state.quizId,
          "user_id": userID,
          "subject_id": parseInt(tempCategoryID[0]),
          "topic_id": parseInt(tempCategoryID[1]),
          "category_id": parseInt(tempCategoryID[2]),
          "subcategory_id": parseInt(randomSubCategory[3]),
          "question_id": this.state.randomQuestionID,
          "quizName": quizName,
          "chosen_answer_array": tempAnswerChoosen,
          "category_name": tempCategoriesMap[this.state.randomCategory].categoryName,
          "category_label": tempCategoriesMap[this.state.randomCategory].categoryLabel,
          "ques_att": tempQuestionsAttended + 1,
          "answer_text": answerText,
          "over_all_question_count": this.state.totalQuestions,
          "question_type": this.state.currentQuestionType,
          "selected_answer_map": this.state.selectedAnswer,
          "rp_answers_map": stringSelectedAnswersMap, //This will processed differently in server from selected_answer_map
          "que_elapsed_time": Math.trunc((new Date().getTime() - this.startTime) / 1000),
          "section_id": parseInt(this.params.get("section_id")),
          "course_id": parseInt(this.params.get("course_id")),
          "subsection_id": parseInt(this.state.subSectionID),
          "answer_type": this.state.answerType,
          "for_checkbox_question": this.state.forCheckBoxQuestion,
          "question_variables": this.state.currentVariableMap ? MathParserUtil.mapToObj(this.state.currentVariableMap) : {},
          "selected_answer": !isNaN(this.state.selectedAnswer) ? this.state.selectedAnswer.toString() : "",
          "ltiUserID": ltiUserID,
          "selectedAnswerDetails": { ...this.state.selectedAnswerDetails },
          answerDisplayStyle: this.state.answerDisplayStyle
        };

        if (this.state.currentQuestionType === 3 && this.state.answerType === 2) {
          const score = isCorrect ? 1 : 0;
          testSavedData.is_answer_correct = score;
          const {
            vector_answer_formulas,
          } = currentQuestion;
          const { currentVectorVariable, selectedAnswer } = this.state;
          const correctAnswerStringArr = VectorParser.getAllCorrectAnswers(vector_answer_formulas, currentVectorVariable);
          if (correctAnswerStringArr.length > 0) {
            testSavedData.rp_correct_answer = correctAnswerStringArr.join();
          } else {
            testSavedData.rp_correct_answer = "";
          }
          const selectedAnswerStringArr = VectorParser.getAllSelectedAnswers(selectedAnswer, currentVectorVariable)
          if (selectedAnswerStringArr.length > 0) {
            testSavedData.selected_answer = `<p>{<br>${selectedAnswerStringArr.join(',<br>')}<br>}</p>`;
          }
        }

        //Draw vector combination 2.0
        if ((this.state.currentQuestionType === 0 && currentQuestion.answer_type === 90)) {
          const score = isCorrect ? 1 : 0;
          testSavedData.is_answer_correct = score;
        }

        if (this.state.currentQuestionType === 2) {
          let newSelectedAnswerMap = {};
          Object.keys(testSavedData.selected_answer_map).map(key => {
            newSelectedAnswerMap[key] = testSavedData.selected_answer_map[key];
          })
        }

        // Check for automation question answer validation for ex: date should be in this format mm/dd/yyyy
        if (this.state.currentQuestionObj && this.state.currentQuestionObj.is_automation) {
          let automationType = this.state.currentQuestionObj.automation_type;
          if (automationType === AutomationType.END_DATE) {
            testSavedData.answer_text = testSavedData.answer_text.trim()
            if (!CheckDateValidation(testSavedData.answer_text)) {
              NotificationManager.error('Please enter a valid date in MM/DD/YYYY format.', 'Invalid Date', 3000);
              this.setState({
                submitButtonDisplay: true,
                showSubmitLoader: false,
              })
              return;
            }
          } else if (automationType === AutomationType.TEST_TIME) {
            testSavedData.answer_text = testSavedData.answer_text.trim()
            if (!CheckNumberValidation(testSavedData.answer_text)) {
              NotificationManager.error('Please enter a valid numeric value.', 'Invalid Input', 3000);
              this.setState({
                submitButtonDisplay: true,
                showSubmitLoader: false,
              })
              return;
            }
          } else if (automationType === AutomationType.EMAIL) {
            testSavedData.answer_text = testSavedData.answer_text.trim()
            if (!CheckEmailValidation(testSavedData.answer_text)) {
              NotificationManager.error('Please enter a valid email address.', 'Invalid Email', 3000);
              this.setState({
                submitButtonDisplay: true,
                showSubmitLoader: false,
              })
              return;
            }
          } else if (automationType === AutomationType.EXCLUDE_AO_CONTEXT) {
            console.debug("testSavedData>>??", testSavedData)
            try {
              let parsed = typeof testSavedData.selected_answer_map === 'string' ? JSON.parse(testSavedData.selected_answer_map) : testSavedData.selected_answer_map;
              let excludedAo = parsed && parsed.excluded_ao ? parsed.excluded_ao : [];
              if (!Array.isArray(excludedAo) || excludedAo.length === 0) {
                NotificationManager.error('Please select at least one option.', 'Empty Answer', 3000);
                this.setState({
                  submitButtonDisplay: true,
                  showSubmitLoader: false,
                })
                return;
              }
            } catch (e) {
              NotificationManager.error('Please select at least one option.', 'Empty Answer', 3000);
              this.setState({
                submitButtonDisplay: true,
                showSubmitLoader: false,
              })
              return;
            }
          }
        }

        if (this.state.currentQuestionType === 1 && testSavedData.answer_type === 3) {
          let newSelectedAnswerDetails = {};

          Object.keys(testSavedData.selected_answer_map).map(key => {
            newSelectedAnswerDetails[key] = testSavedData.selected_answer_map[key];
          })
          if (testSavedData.selectedAnswerDetails && Object.keys(testSavedData.selectedAnswerDetails).length === 0) {
            testSavedData.selectedAnswerDetails = newSelectedAnswerDetails;
          }
          let correctAnswerStrForRPTest = "";

          Object.keys(testSavedData.selectedAnswerDetails).map(key => {
            let newKey = key;
            if (key.includes("eval{")) {
              newKey = key.replace(/\\eval\{([^}]+)\}/g, '[$1]');
              newKey = newKey.trim();
            }
            Object.entries(testSavedData.question_variables).forEach(([varKey, questVar]) => {
              console.debug("varKey>>??", varKey)
              if (newKey.includes(varKey)) {
                newKey = newKey.replaceAll(`${varKey}`,questVar.value);
              }
            });
            correctAnswerStrForRPTest += newKey;
          })
          debugger;
          // adding try catch here because for some rp questions answer have text data, so eval will throw error
          try {
            testSavedData.correct_answer_str_for_rp_test = String(math.eval(correctAnswerStrForRPTest));
            testSavedData.rp_answers_map = testSavedData.selectedAnswerDetails
            Object.keys(testSavedData.rp_answers_map).map(key => {
              let val = testSavedData.rp_answers_map[key];
              if (val && typeof val === "string") {
                val = val.replace("x10", "* 10")
                testSavedData.student_answer_str_for_rp_test = val;
                testSavedData.rp_answers_map[key] = `${math.format(math.eval(val), { precision: 14 })}`
              }
            })
          } catch (error) {
              console.debug(error)
          }
        }

        console.debug("testSavedData>>??", testSavedData);
        // return;
        testSavedData.parent_quiz_id = this.state.parentQuizID;

        //bug id 225 fixes
        this.setState({
          selectedAnswer: [],
          questionsAttended: tempQuestionsAttended + 1,
        }, () => {
          console.log("testSavedData =", testSavedData);
          this.props.apiService({
            method: 'post',
            url: '/saveTest',
            data: testSavedData,

          })
            .then(res => {
              if (res.data.status == 1 && res.data.message) {
                if (res.data.message === 'quiz time over') {
                  this.setState({
                    testWindowEnded: true, pageLoading: false,
                    showSplashScreen: true
                  });
                  return;
                }
              }
              console.log("saveTest response =", res);
              if (res !== undefined && res !== null && res.data !== undefined && res.data !== null && res.data !== "") {
                if (res.data.status !== undefined && res.data.status !== null && res.data.status === 1 &&
                  res.data.message !== undefined && res.data.message !== null) {
                  alert("Unable to save your progress. Please try again later! \n Error : " + res.data.message);

                }
                else if (res.data !== undefined && res.data !== null && res.data !== "") {
                  if (res.data.data.ques_att !== undefined && res.data.data.ques_att !== null) {
                    if (res.data.data.ques_att === this.state.totalQuestions) {
                      this.finish();
                    } else {
                      this.setState({
                        questionAnswerStates: [],
                      }, () => {
                        this.setState({
                          submitButtonDisplay: true,
                          questionsAttended: res.data.data.ques_att
                        })
                        this.getRandomQuestion();
                      })
                    }

                  }
                }
                else {
                  console.log("Error - saveTest did not received response from server");
                  alert("Server encountered an error. Please try again later!");
                  this.props.handleRoute('/troubleShooting');

                }
              }
              else {
                console.log("Error - saveTest did not received response from server");
                alert("Server encountered an error. Please try again later!");
                this.props.handleRoute('/troubleShooting');

              }



            })
        })
      }

    } else {
      //survey question Api call

    }
  }

  saveSurvey() {

    console.log("*******Survey Question save *************");

    console.log("surveyPreviousQuestionId = ", this.state.surveyPreviousQuestionId);
    //console.log("randomSubCategory.split = ",randomSubCategory[3]);
    var tempSubcategoryID = this.state.randomSubCategory;
    var tempRandomQuestionID = this.state.randomQuestionID;
    var tempAnswerChoosen = [];
    var tempSurveyQuestionsArr = [];
    if (this.state.surveyPreviousQuestionId !== 0) {
      tempSurveyQuestionsArr = this.state.surveyQuestionMap[tempSubcategoryID + "_" + tempRandomQuestionID];
    }

    var tempAnswerText = "";


    if (tempSurveyQuestionsArr.answer_type === 2 || tempSurveyQuestionsArr.answer_type === 90) {
      tempAnswerText = this.state.selectedAnswer;
    } else if (tempSurveyQuestionsArr.answer_type === 0) {
      tempAnswerChoosen.push(parseInt(this.state.selectedAnswer));
    } else {
      for (var i = 0; i < this.state.selectedAnswer.length; i++) {
        tempAnswerChoosen.push(parseInt(this.state.selectedAnswer[i]));
      }

    }

    var surveyQuestionPayload = {
      "quiz_id": this.state.quizId,
      "user_id": this.state.userId,
      "subject_id": parseInt(tempSubcategoryID[0]),
      "topic_id": parseInt(tempSubcategoryID[1]),
      "category_id": parseInt(tempSubcategoryID[2]),
      "subcategory_id": parseInt(tempSubcategoryID[3]),
      "question_id": parseInt(tempSubcategoryID[4]),
      "quizName": this.state.quizName,
      "chosen_answer_array": tempAnswerChoosen,
      "answer_text": tempAnswerText,
      "course_id": 0,
      "section_id": 0,
      parent_quiz_id: this.state.parentQuizID,

    };
    this.setState({
      selectedAnswer: [],
    })
    console.log("surveyQuestionPayload = ", surveyQuestionPayload);
    this.props.apiService({
      method: 'post',
      url: '/saveProgressSurveyQuestion',
      data: surveyQuestionPayload,
    })
      .then(res => {
        console.log("saveTest response =", res);
        //this.getRandomQuestion();
        this.getNextSurveyQuestion();
        this.setState({
          submitButtonDisplay: true,
        })
      })

  }

  CheckAnswerTextForQuestion = function (selectedAnswer, mainQA) {
    let listkey = '';
    let listexpectedAnswer = '';
    let listinputAnswer = '';
    let currentQuestion = mainQA.question;

    console.log("CheckAnswerText", currentQuestion);
    const { answerDisplayStyle, question_type, answer_type, answer_formula } = currentQuestion;

    //vector Question with RP float answer type
    if (answer_type === 3 && question_type === 3 && answerDisplayStyle === 1 &&
      !(answer_formula?.formulaOneEvaluateOption === 0 && !answer_formula?.addFormulaSwitch)
    ) {
      let isCorrectAnswer = false
      let isCorrectAnswerFormulaOne = false;
      let isCorrectAnswerFormulaTwo = false;
      const FormulaOneCondition = answer_formula?.formulaOneEvaluateOption;
      const FormulaOne = answer_formula?.formula;
      const FormulaWithoutBrackets = FormulaOne ? FormulaOne.replace("{{", "").replace("}}", "") : "";
      const QueryOption = answer_formula?.formulaqueryOption;
      const FormulaTwoCondition = answer_formula?.formulaTwoEvaluateOption;
      const FormulaTwo = answer_formula?.formulaTwo;
      const FormulaTwoSwitch = answer_formula?.addFormulaSwitch;

      isCorrectAnswerFormulaOne = MathParserUtil.EvaluateAnswerWithQueryOptions(FormulaOne,
        mainQA.tempVectorsVarMap, FormulaOneCondition, parseFloat(selectedAnswer[FormulaWithoutBrackets]))
      //console.log("Vector answer Range----------_>rp3",isCorrectAnswerFormulaOne)

      if (FormulaTwoSwitch) {
        isCorrectAnswerFormulaTwo = MathParserUtil.EvaluateAnswerWithQueryOptions(FormulaTwo,
          mainQA.tempVectorsVarMap, FormulaTwoCondition, parseFloat(selectedAnswer[FormulaWithoutBrackets]))
        //console.log("Vector answer Range----------_>rp4",isCorrectAnswerFormulaTwo)
        if (QueryOption == 0) {
          //AND operator
          isCorrectAnswer = isCorrectAnswerFormulaOne && isCorrectAnswerFormulaTwo;
        } else if (QueryOption == 1) {
          //OR operator
          isCorrectAnswer = isCorrectAnswerFormulaOne || isCorrectAnswerFormulaTwo;
        }
      } else {
        isCorrectAnswer = isCorrectAnswerFormulaOne
      }
      return isCorrectAnswer

    }

    //vector Question with RP scifi notion answer type
    if (answer_type === 3 && question_type === 3 && answerDisplayStyle === 2 &&
      !(answer_formula?.formulaOneEvaluateOption === 0 && !answer_formula?.addFormulaSwitch)
    ) {
      //console.log("Vector answer Range----------_>formulaArray",answer_formula)
      let isCorrectAnswer = false
      let isCorrectAnswerFormulaOne = false;
      let isCorrectAnswerFormulaTwo = false;
      const FormulaOneCondition = answer_formula?.formulaOneEvaluateOption;
      const FormulaOne = answer_formula?.formula;
      const FormulaWithoutBrackets = FormulaOne ? FormulaOne.replace("{{", "").replace("}}", "") : "";
      const QueryOption = answer_formula?.formulaqueryOption;
      const FormulaTwoCondition = answer_formula?.formulaTwoEvaluateOption;
      const FormulaTwo = answer_formula?.formulaTwo;
      const FormulaTwoSwitch = answer_formula?.addFormulaSwitch;
      const inputAnswer = parseFloat(selectedAnswer[FormulaWithoutBrackets]);

      isCorrectAnswerFormulaOne = MathParserUtil.EvaluateAnswerWithQueryOptions(FormulaOne,
        mainQA.tempVectorsVarMap, FormulaOneCondition, parseFloat(selectedAnswer[FormulaWithoutBrackets]))
      //console.log("Vector answer Range----------_>rp3",isCorrectAnswerFormulaOne,inputAnswer)

      if (FormulaTwoSwitch) {
        isCorrectAnswerFormulaTwo = MathParserUtil.EvaluateAnswerWithQueryOptions(FormulaTwo,
          mainQA.tempVectorsVarMap, FormulaTwoCondition, parseFloat(selectedAnswer[FormulaWithoutBrackets]))
        //console.log("Vector answer Range----------_>rp4",isCorrectAnswerFormulaTwo)
        if (QueryOption == 0) {
          //AND operator
          isCorrectAnswer = isCorrectAnswerFormulaOne && isCorrectAnswerFormulaTwo;
        } else if (QueryOption == 1) {
          //OR operator
          isCorrectAnswer = isCorrectAnswerFormulaOne || isCorrectAnswerFormulaTwo;
        }
      } else {
        isCorrectAnswer = isCorrectAnswerFormulaOne
      }
      return isCorrectAnswer

    }

    if (answer_type === 3 || answer_type === 90) {
      const { formulaArray } = answer_formula;
      if (formulaArray && formulaArray.length > 0) {

        for (var index = 0; index < formulaArray.length; index++) {
          const { validationMode, text, ...rest } = formulaArray[index];
          const textWithoutBrackets = text ? text.replace("{{", "").replace("}}", "") : "";
          // console.debug("validationMode and currentQuestion", validationMode, currentQuestion, mainQA.currentVariableMap, mainQA.tempVectorsVarMap, text)
          switch (validationMode) {
            case 'valueRange':
              {
                const { absAccuracyValue } = rest;
                // const correctAnswer = MathParserUtil.computeAnswer(text, mainQA.currentVariableMap);
                let correctAnswer = 0;
                if (currentQuestion.question_type === 3 && currentQuestion.answer_type === 3) {
                  correctAnswer = MathParserUtil.computeAnswer(text, mainQA.tempVectorsVarMap)
                } else {
                  correctAnswer = MathParserUtil.computeAnswer(text, mainQA.currentVariableMap);
                }
                const lowerRange = correctAnswer - parseFloat(absAccuracyValue);
                const upperRange = correctAnswer + parseFloat(absAccuracyValue);
                const inputAnswer = parseFloat(selectedAnswer[textWithoutBrackets]);
                if (lowerRange <= inputAnswer && inputAnswer <= upperRange) {
                  console.log("correct answer");

                } else {
                  return false;
                }
                break;
              }
            case 'precision':
              const { answerPrecision } = rest;
              // const correctAnswer = MathParserUtil.computeAnswer(text, this.state.currentVariableMap);
              let correctAnswer = 0;
              if (currentQuestion.question_type === 3 && currentQuestion.answer_type === 3) {
                correctAnswer = MathParserUtil.computeAnswer(text, mainQA.tempVectorsVarMap)
              } else {
                correctAnswer = MathParserUtil.computeAnswer(text, mainQA.currentVariableMap);
              }
              const expectedAnswer = correctAnswer.toPrecision(answerPrecision);
              const inputAnswer = parseFloat(selectedAnswer[textWithoutBrackets]).toPrecision(answerPrecision);
              if (expectedAnswer === inputAnswer) {
                console.log("correct answer");
              } else {
                return false;
              }
              break;
            case 'list':
              {
                let isEnteredAnswerCorrect = false;
                const { listValues } = rest;
                const { isCaseSensitive } = rest;
                const { shouldAnswerAll } = rest;
                listkey = mainQA.currentVariableMap.get(textWithoutBrackets).value;
                listexpectedAnswer = listValues[listkey];
                listinputAnswer = selectedAnswer[textWithoutBrackets];
                switch (answerDisplayStyle) {
                  case 1: // decimal type answer format
                    if (listexpectedAnswer.includes(',')) {
                      expectedAnswers = listexpectedAnswer.split(',');
                      for (const expectedAnswer of expectedAnswers) {
                        if (expectedAnswer.toLowerCase().trim() === listinputAnswer.toLowerCase().trim()) {
                          isEnteredAnswerCorrect = true;
                          break;
                        }
                      }
                    }
                    else { // check when expected answers dont have comma
                      if (listexpectedAnswer.toLowerCase().trim() === listinputAnswer.toLowerCase().trim()) {
                        isEnteredAnswerCorrect = true;
                      }
                    }
                    break;
                  case 4:  // text type answer format
                    let enteredAnswers = [];
                    let expectedAnswers = [];
                    let answer;
                    if (listexpectedAnswer.includes(',')) {
                      expectedAnswers = listexpectedAnswer.split(',');
                    }
                    else {
                      expectedAnswers.push(listexpectedAnswer);
                    }
                    if (listinputAnswer.includes(',')) {
                      enteredAnswers = listinputAnswer.split(',');  // more than one answer entered
                    }
                    else {
                      enteredAnswers.push(listinputAnswer); // if only one answer enetered
                    }
                    // check conditions for case sensitive and case insensitive
                    for (let enteredAnswer of enteredAnswers) {
                      if (isCaseSensitive) {
                        answer = enteredAnswer.trim();
                        enteredAnswers[enteredAnswers.indexOf(enteredAnswer)] = answer;
                      }
                      else if (isCaseSensitive === false) {
                        answer = enteredAnswer.trim();
                        answer = answer.toLowerCase();
                        enteredAnswers[enteredAnswers.indexOf(enteredAnswer)] = answer;
                      }
                    }
                    for (let expectedAnswer of expectedAnswers) {
                      if (isCaseSensitive) {
                        answer = expectedAnswer.trim();
                        expectedAnswers[expectedAnswers.indexOf(expectedAnswer)] = answer;
                      }
                      else if (isCaseSensitive === false) {
                        answer = expectedAnswer.trim();
                        answer = answer.toLowerCase();
                        expectedAnswers[expectedAnswers.indexOf(expectedAnswer)] = answer;
                      }
                    }
                    // check conditions for answer all or any and verify accordingly
                    for (let expectedAnswer of expectedAnswers) {
                      if (shouldAnswerAll === false) {
                        if (enteredAnswers.includes(expectedAnswer)) {  // verify one expected answer is found in entered answer
                          isEnteredAnswerCorrect = true;     // if yes then answer is correct
                          break;
                        }
                      }
                      else if (shouldAnswerAll === true) {
                        if (enteredAnswers.includes(expectedAnswer)) {  // checks each expected answer is found in entered answer
                          isEnteredAnswerCorrect = true;
                        }
                        else {
                          isEnteredAnswerCorrect = false;   // else if any one is not found then it stops remaining verification and regards as incorrect
                          break;
                        }
                      }
                    }
                    break;
                }
                // check correct flag
                if (isEnteredAnswerCorrect) {
                  return true;
                } else {
                  return false;
                }
              }
            default:
              {
                const { accuracyRange } = rest;
                // const correctAnswer = MathParserUtil.computeAnswer(text, this.state.currentVariableMap);

                let correctAnswer = 0;
                if (question_type === 3 && answer_type === 3 || (question_type === 0 && answer_type === 90)) {
                  correctAnswer = MathParserUtil.computeAnswer(text, mainQA.tempVectorsVarMap)
                } else {
                  correctAnswer = MathParserUtil.computeAnswer(text, mainQA.currentVariableMap)
                }

                const acceptedDeviationValue = Math.abs(correctAnswer * (accuracyRange / 100));
                const lowerRange = correctAnswer - acceptedDeviationValue;
                const upperRange = correctAnswer + acceptedDeviationValue;

                const inputAnswer = parseFloat(selectedAnswer[textWithoutBrackets]);
                if (lowerRange <= inputAnswer && inputAnswer <= upperRange) {
                  console.log("correct answer");
                } else {
                  return false;
                }
              }
          }
        }
      }
    }

    return true;
  }

  CheckAnswerText = function (selectedAnswer, currentQuestion) {
    let listkey = '';
    let listexpectedAnswer = '';
    let listinputAnswer = '';

    console.log("CheckAnswerText", currentQuestion);
    const { answerDisplayStyle, answer_type, answer_formula } = currentQuestion;

    //vector Question with RP float answer type
    if (answer_type === 3 && this.state.currentQuestionType === 3 && answerDisplayStyle === 1 &&
      !(answer_formula?.formulaOneEvaluateOption === 0 && !answer_formula?.addFormulaSwitch)
    ) {
      let isCorrectAnswer = false
      let isCorrectAnswerFormulaOne = false;
      let isCorrectAnswerFormulaTwo = false;
      const FormulaOneCondition = answer_formula?.formulaOneEvaluateOption;
      const FormulaOne = answer_formula?.formula;
      const FormulaWithoutBrackets = FormulaOne ? FormulaOne.replace("{{", "").replace("}}", "") : "";
      const QueryOption = answer_formula?.formulaqueryOption;
      const FormulaTwoCondition = answer_formula?.formulaTwoEvaluateOption;
      const FormulaTwo = answer_formula?.formulaTwo;
      const FormulaTwoSwitch = answer_formula?.addFormulaSwitch;

      isCorrectAnswerFormulaOne = MathParserUtil.EvaluateAnswerWithQueryOptions(FormulaOne,
        this.state.currentVectorVariable, FormulaOneCondition, parseFloat(selectedAnswer[FormulaWithoutBrackets]))
      //console.log("Vector answer Range----------_>rp3",isCorrectAnswerFormulaOne)

      if (FormulaTwoSwitch) {
        isCorrectAnswerFormulaTwo = MathParserUtil.EvaluateAnswerWithQueryOptions(FormulaTwo,
          this.state.currentVectorVariable, FormulaTwoCondition, parseFloat(selectedAnswer[FormulaWithoutBrackets]))
        //console.log("Vector answer Range----------_>rp4",isCorrectAnswerFormulaTwo)
        if (QueryOption == 0) {
          //AND operator
          isCorrectAnswer = isCorrectAnswerFormulaOne && isCorrectAnswerFormulaTwo;
        } else if (QueryOption == 1) {
          //OR operator
          isCorrectAnswer = isCorrectAnswerFormulaOne || isCorrectAnswerFormulaTwo;
        }
      } else {
        isCorrectAnswer = isCorrectAnswerFormulaOne
      }
      return isCorrectAnswer

    }

    //vector Question with RP scifi notion answer type
    if (answer_type === 3 && this.state.currentQuestionType === 3 && answerDisplayStyle === 2 &&
      !(answer_formula?.formulaOneEvaluateOption === 0 && !answer_formula?.addFormulaSwitch)
    ) {
      //console.log("Vector answer Range----------_>formulaArray",answer_formula)
      let isCorrectAnswer = false
      let isCorrectAnswerFormulaOne = false;
      let isCorrectAnswerFormulaTwo = false;
      const FormulaOneCondition = answer_formula?.formulaOneEvaluateOption;
      const FormulaOne = answer_formula?.formula;
      const FormulaWithoutBrackets = FormulaOne ? FormulaOne.replace("{{", "").replace("}}", "") : "";
      const QueryOption = answer_formula?.formulaqueryOption;
      const FormulaTwoCondition = answer_formula?.formulaTwoEvaluateOption;
      const FormulaTwo = answer_formula?.formulaTwo;
      const FormulaTwoSwitch = answer_formula?.addFormulaSwitch;
      const inputAnswer = parseFloat(selectedAnswer[FormulaWithoutBrackets]);

      isCorrectAnswerFormulaOne = MathParserUtil.EvaluateAnswerWithQueryOptions(FormulaOne,
        this.state.currentVectorVariable, FormulaOneCondition, parseFloat(selectedAnswer[FormulaWithoutBrackets]))
      //console.log("Vector answer Range----------_>rp3",isCorrectAnswerFormulaOne,inputAnswer)

      if (FormulaTwoSwitch) {
        isCorrectAnswerFormulaTwo = MathParserUtil.EvaluateAnswerWithQueryOptions(FormulaTwo,
          this.state.currentVectorVariable, FormulaTwoCondition, parseFloat(selectedAnswer[FormulaWithoutBrackets]))
        //console.log("Vector answer Range----------_>rp4",isCorrectAnswerFormulaTwo)
        if (QueryOption == 0) {
          //AND operator
          isCorrectAnswer = isCorrectAnswerFormulaOne && isCorrectAnswerFormulaTwo;
        } else if (QueryOption == 1) {
          //OR operator
          isCorrectAnswer = isCorrectAnswerFormulaOne || isCorrectAnswerFormulaTwo;
        }
      } else {
        isCorrectAnswer = isCorrectAnswerFormulaOne
      }
      return isCorrectAnswer

    }

    if (answer_type === 3 || answer_type === 90) {
      const { formulaArray } = answer_formula;
      if (formulaArray && formulaArray.length > 0) {

        for (var index = 0; index < formulaArray.length; index++) {
          const { validationMode, text, ...rest } = formulaArray[index];
          const textWithoutBrackets = text ? text.replace("{{", "").replace("}}", "") : "";
          console.debug("validationMode", validationMode, this.state.currentVariableMap, this.state.currentVectorVariable)
          switch (validationMode) {
            case 'valueRange':
              {
                const { absAccuracyValue } = rest;
                // const correctAnswer = MathParserUtil.computeAnswer(text, this.state.currentVariableMap);
                let correctAnswer = 0;
                if (this.state.currentQuestionType === 3 && this.state.answerType === 3) {
                  correctAnswer = MathParserUtil.computeAnswer(text, this.state.currentVectorVariable)
                } else {
                  correctAnswer = MathParserUtil.computeAnswer(text, this.state.currentVariableMap);
                }
                const lowerRange = correctAnswer - parseFloat(absAccuracyValue);
                const upperRange = correctAnswer + parseFloat(absAccuracyValue);
                const selectedAnswerInput = selectedAnswer[textWithoutBrackets];
                if (answerDisplayStyle === 5) {
                  //decimal only Evaluation
                  if (!checkIsDecimalOnly(selectedAnswerInput)) {
                    return false
                  }
                }

                if (answerDisplayStyle === 6) {
                  //E Notation only Evaluation
                  if (!checkIsENotationOnly(selectedAnswerInput)) {
                    return false
                  }
                }

                // SigFig option Enable answer type ( Dcimal,Enotaion and scifi Notation)
                if ([1, 2, 5, 6].includes(Number(answerDisplayStyle)) && answer_formula?.formulaSigFigOption === 1) {
                  //SigFigOption Enabled
                  let inputAnswerstr = selectedAnswer[textWithoutBrackets];
                  //Evaluate Sig fig Evaluation
                  let sigFigValue;
                  if (Number(answerDisplayStyle) === 2) {// scifi Notation
                    const formulaTextArray = MathParserUtil.splitAnswerTextFormulaToArray(answer_formula.formula);
                    formulaTextArray.map((ansSegment, index) => {
                      if (this.state.selectedAnswerDetails[ansSegment]) {
                        sigFigValue = countSignificantFiguresForScifi(this.state.selectedAnswerDetails[ansSegment])
                      }
                    })
                  } else {
                    sigFigValue = countSignificantFigures(inputAnswerstr)
                  }
                  if (sigFigValue !== answer_formula?.formulaSigFigOptionValue) {
                    return false
                  }
                }
                const inputAnswer = parseFloat(selectedAnswer[textWithoutBrackets]);
                if (lowerRange <= inputAnswer && inputAnswer <= upperRange) {
                  console.log("correct answer");

                } else {
                  return false;
                }
                break;
              }
            case 'precision':
              const { answerPrecision } = rest;
              // const correctAnswer = MathParserUtil.computeAnswer(text, this.state.currentVariableMap);
              let correctAnswer = 0;
              if (this.state.currentQuestionType === 3 && this.state.answerType === 3) {
                correctAnswer = MathParserUtil.computeAnswer(text, this.state.currentVectorVariable)
              } else {
                correctAnswer = MathParserUtil.computeAnswer(text, this.state.currentVariableMap);
              }
              const expectedAnswer = correctAnswer.toPrecision(answerPrecision);
              const selectedAnswerInput = selectedAnswer[textWithoutBrackets];

              if (answerDisplayStyle === 5) {
                //decimal only Evaluation
                if (!checkIsDecimalOnly(selectedAnswerInput)) {
                  return false
                }
              }

              if (answerDisplayStyle === 6) {
                //E Notation only Evaluation
                if (!checkIsENotationOnly(selectedAnswerInput)) {
                  return false
                }
              }
              // SigFig option Enable answer type ( Dcimal,Enotaion and scifi Notation)
              if ([1, 2, 5, 6].includes(Number(answerDisplayStyle)) && answer_formula?.formulaSigFigOption === 1) {
                //SigFigOption Enabled
                let inputAnswerstr = selectedAnswer[textWithoutBrackets];
                //Evaluate Sig fig Evaluation
                let sigFigValue;
                if (Number(answerDisplayStyle) === 2) {// scifi Notation
                  const formulaTextArray = MathParserUtil.splitAnswerTextFormulaToArray(answer_formula.formula);
                  formulaTextArray.map((ansSegment, index) => {
                    if (this.state.selectedAnswerDetails[ansSegment]) {
                      sigFigValue = countSignificantFiguresForScifi(this.state.selectedAnswerDetails[ansSegment])
                    }
                  })
                } else {
                  sigFigValue = countSignificantFigures(inputAnswerstr)
                }
                if (sigFigValue !== answer_formula?.formulaSigFigOptionValue) {
                  return false
                }
              }
              const inputAnswer = parseFloat(selectedAnswer[textWithoutBrackets]).toPrecision(answerPrecision);
              if (expectedAnswer === inputAnswer) {
                console.log("correct answer");
              } else {
                return false;
              }
              break;
            case 'list':
              {
                let isEnteredAnswerCorrect = false;
                const { listValues } = rest;
                const { isCaseSensitive } = rest;
                const { shouldAnswerAll } = rest;
                listkey = this.state.currentVariableMap.get(textWithoutBrackets).value;
                if (listkey && typeof listkey === "string") {
                  listkey = listkey.trim();
                }
                listexpectedAnswer = listValues[listkey] ? listValues[listkey] : [];
                listinputAnswer = selectedAnswer[textWithoutBrackets];
                switch (answerDisplayStyle) {
                  case 1: // decimal type answer format
                    if (listexpectedAnswer.includes(',')) {
                      expectedAnswers = listexpectedAnswer.split(',');
                      for (const expectedAnswer of expectedAnswers) {
                        if (expectedAnswer.toLowerCase().trim() === listinputAnswer.toLowerCase().trim()) {
                          isEnteredAnswerCorrect = true;
                          break;
                        }
                      }
                    }
                    else { // check when expected answers dont have comma
                      if (listexpectedAnswer.toLowerCase().trim() === listinputAnswer.toLowerCase().trim()) {
                        isEnteredAnswerCorrect = true;
                      }
                    }
                    break;
                  case 4:  // text type answer format
                    let enteredAnswers = [];
                    let expectedAnswers = [];
                    let answer;
                    if (listexpectedAnswer.includes(',')) {
                      expectedAnswers = listexpectedAnswer.split(',');
                    }
                    else {
                      expectedAnswers.push(listexpectedAnswer);
                    }
                    if (listinputAnswer.includes(',')) {
                      enteredAnswers = listinputAnswer.split(',');  // more than one answer entered
                    }
                    else {
                      enteredAnswers.push(listinputAnswer); // if only one answer enetered
                    }
                    // check conditions for case sensitive and case insensitive
                    for (let enteredAnswer of enteredAnswers) {
                      if (isCaseSensitive) {
                        answer = enteredAnswer.trim();
                        enteredAnswers[enteredAnswers.indexOf(enteredAnswer)] = answer;
                      }
                      else if (isCaseSensitive === false) {
                        answer = enteredAnswer.trim();
                        answer = answer.toLowerCase();
                        enteredAnswers[enteredAnswers.indexOf(enteredAnswer)] = answer;
                      }
                    }
                    for (let expectedAnswer of expectedAnswers) {
                      if (isCaseSensitive) {
                        answer = expectedAnswer.trim();
                        expectedAnswers[expectedAnswers.indexOf(expectedAnswer)] = answer;
                      }
                      else if (isCaseSensitive === false) {
                        answer = expectedAnswer.trim();
                        answer = answer.toLowerCase();
                        expectedAnswers[expectedAnswers.indexOf(expectedAnswer)] = answer;
                      }
                    }
                    // check conditions for answer all or any and verify accordingly
                    for (let expectedAnswer of expectedAnswers) {
                      if (shouldAnswerAll === false) {
                        if (enteredAnswers.includes(expectedAnswer)) {  // verify one expected answer is found in entered answer
                          isEnteredAnswerCorrect = true;     // if yes then answer is correct
                          break;
                        }
                      }
                      else if (shouldAnswerAll === true) {
                        if (enteredAnswers.includes(expectedAnswer)) {  // checks each expected answer is found in entered answer
                          isEnteredAnswerCorrect = true;
                        }
                        else {
                          isEnteredAnswerCorrect = false;   // else if any one is not found then it stops remaining verification and regards as incorrect
                          break;
                        }
                      }
                    }
                    break;
                }
                // check correct flag
                if (isEnteredAnswerCorrect) {
                  return true;
                } else {
                  return false;
                }
              }
            default:
              {
                const { accuracyRange } = rest;
                // const correctAnswer = MathParserUtil.computeAnswer(text, this.state.currentVariableMap);

                let correctAnswer = 0;
                if (this.state.currentQuestionType === 3 && this.state.answerType === 3 || (this.state.currentQuestionType === 0 && this.state.answerType === 90)) {
                  correctAnswer = MathParserUtil.computeAnswer(text, this.state.currentVectorVariable)
                } else {
                  correctAnswer = MathParserUtil.computeAnswer(text, this.state.currentVariableMap)
                }

                const acceptedDeviationValue = Math.abs(correctAnswer * (accuracyRange / 100));
                const lowerRange = correctAnswer - acceptedDeviationValue;
                const upperRange = correctAnswer + acceptedDeviationValue;
                const selectedAnswerInput = selectedAnswer[textWithoutBrackets];

                if (answerDisplayStyle === 5) {
                  //decimal only Evaluation
                  if (!checkIsDecimalOnly(selectedAnswerInput)) {
                    return false
                  }
                }

                if (answerDisplayStyle === 6) {
                  //E Notation only Evaluation
                  if (!checkIsENotationOnly(selectedAnswerInput)) {
                    return false
                  }
                }
                // SigFig option Enable answer type ( Dcimal,Enotaion and scifi Notation)
                if ([1, 2, 5, 6].includes(Number(answerDisplayStyle)) && answer_formula?.formulaSigFigOption === 1) {
                  //SigFigOption Enabled
                  let inputAnswerstr = selectedAnswer[textWithoutBrackets];
                  //Evaluate Sig fig Evaluation
                  let sigFigValue;
                  if (Number(answerDisplayStyle) === 2) {// scifi Notation
                    const formulaTextArray = MathParserUtil.splitAnswerTextFormulaToArray(answer_formula.formula);
                    formulaTextArray.map((ansSegment, index) => {
                      if (this.state.selectedAnswerDetails[ansSegment]) {
                        sigFigValue = countSignificantFiguresForScifi(this.state.selectedAnswerDetails[ansSegment])
                      }
                    })
                  } else {
                    sigFigValue = countSignificantFigures(inputAnswerstr)
                  }
                  if (sigFigValue !== answer_formula?.formulaSigFigOptionValue) {
                    return false
                  }
                }
                const inputAnswer = parseFloat(selectedAnswer[textWithoutBrackets]);
                if (lowerRange <= inputAnswer && inputAnswer <= upperRange) {
                  console.log("correct answer");
                } else {
                  return false;
                }
              }
          }
        }
      }
    }

    return true;
  }

  CheckAnswerRadio = function (selectedAnswer, currentQuestion) {
    let correctAnswerID = [];
    /*if (parseInt(selectedAnswer,10)  === currentQuestion.answers[1].answer_id)
      return true*/
    for (let index = 0; index < currentQuestion.answers.length; index++) {
      const answer = currentQuestion.answers[index];
      if (answer.is_answer) {
        correctAnswerID.push(answer.answer_id);
      }
    }

    if (correctAnswerID.includes(parseInt(selectedAnswer, 10))) {
      return true;
    }
    return false;
  }

  CheckAnswerCheckBox = function (selectedAnswer, currentQuestion) {
    var choiceSelected = false;
    if (selectedAnswer === undefined || selectedAnswer.length === 0)
      return false;
    let answers = currentQuestion.answers;
    let AllQuestionMustBeCorrect = (currentQuestion.for_checkbox_question == 1 ? true : false);
    var correctAnswerCount = 0;
    var selectedAnswerCount = 0;
    /*if(answers[1].answer_id  === parseInt(selectedAnswer[1],10))
      return true*/

    for (let index = 0; index < answers.length; index++) {
      var answer = answers[index];

      if (answer.is_answer) {
        correctAnswerCount++;
        for (let index1 = 0; index1 < selectedAnswer.length; index1++) {
          var choice = parseInt(selectedAnswer[index1], 10);
          if (answer.answer_id === choice) {
            choiceSelected = true;
            selectedAnswerCount++;
            break;
          }
          // else
          // {
          //   return false;
          // }

          // if(!choiceSelected)
          //   return false;
        }

      }
    }
    if (AllQuestionMustBeCorrect) {
      if (correctAnswerCount !== 0 && selectedAnswerCount !== 0 && selectedAnswer.length !== 0
        && correctAnswerCount === selectedAnswerCount && selectedAnswer.length === correctAnswerCount) {
        return true;
      } else {
        return false;
      }
    } else {
      if (correctAnswerCount !== 0 && selectedAnswerCount !== 0 && selectedAnswer.length !== 0
        && selectedAnswerCount > 0 && selectedAnswer.length === selectedAnswerCount) {
        return true;
      } else {
        return false;
      }
    }
    return true;
  }

  checkAnswerIsCorrectForQuestion(mainQA, answersMap) {
    let question = mainQA.question;
    let uniqueID = `${question.subject_id}_${question.topic_id}_${question.category_id}_${question.subcategory_id}_${question.question_id}`;
    if (question.question_nongraded) {
      return true;
    }
    let isCorrectAnswer = false;

    let selectedAnswer = answersMap[uniqueID];

    const {
      vector_answer_formulas,
    } = question;
    const currentVectorVariable = mainQA.tempVectorsVarMap;
    const currentVectorSettings = mainQA.vectorSettingsData;
    if ((question.question_type === 3 && question.answer_type === 2) || (question.question_type === 0 && question.answer_type === 90)) {
      if ((question.question_type === 0 && question.answer_type === 90)) {
        const {
          vector_answer_formulas,
        } = question;
        let tempVectorVariable = vector_answer_formulas.filter(
          (vector) => !vector?.isStaticVector && !vector?.isIncorrectAnswer
        );
        let vectorVariable = VectorParser.buildQuestionVariablesMap(tempVectorVariable)

        let isIncorrectAnswer
        let tempIncorrectVectorVariable = vector_answer_formulas.filter(vector => vector?.isIncorrectAnswer);
        const filteredAnswer = Object.keys(selectedAnswer)
          .filter(key => {
            const vector = selectedAnswer[key];
            return !vector?.isStaticVector && !vector?.isIncorrectAnswer;
          })
          .reduce((result, key, index) => {
            result[index] = selectedAnswer[key];
            return result;
          }, {});


        if (tempIncorrectVectorVariable.length > 0) {
          const selectedAnsKeys = Object.keys(selectedAnswer);
          const selectedAnsSet = new Set(selectedAnsKeys.map(key => selectedAnswer[key]?.name));
          // Check if any incorrect vector's name exists in the selected answers
          for (const vector of tempIncorrectVectorVariable) {
            if (selectedAnsSet.has(vector.name)) {
              isIncorrectAnswer = true;
              break; // Exit if incorrect answer is selected
            }
          }
        }
        if (!isIncorrectAnswer) {

          isCorrectAnswer = VectorParser.isAnswerCorrect(tempVectorVariable, filteredAnswer, vectorVariable, this.state.currentVectorSettings);

        } else {
          isCorrectAnswer = false
        }
      } else {
        isCorrectAnswer = VectorParser.isAnswerCorrect(vector_answer_formulas, selectedAnswer, currentVectorVariable, currentVectorSettings);
      }
      // console.debug("CONDITION = 1", question, isCorrectAnswer)

    } else if (question.question_type === 2) { // Multiple Question Grid
      // console.debug("CONDITION = 2", question)
    } else {
      let answerType = question.answer_type;
      switch (answerType) {
        case 0:
        case 30:
        case 70:
        case 50:
          //Radio Button
          isCorrectAnswer = this.CheckAnswerRadio(selectedAnswer, question);
          break;
        case 1:
        case 40:
        case 80:
        case 60:
          //Check Box
          isCorrectAnswer = this.CheckAnswerCheckBox(selectedAnswer, question);
          break;
        case 2:
          //Text Box
          isCorrectAnswer = this.CheckAnswerTextForQuestion(selectedAnswer, mainQA);
          break;
        case 3:
          //RP Text Box
          isCorrectAnswer = this.CheckAnswerTextForQuestion(selectedAnswer, mainQA);
          break;
        default:
          //Invalid Answer Type
          isCorrectAnswer = false;
          break;
      }
      // console.debug("CONDITION = 3", question, question.answer, isCorrectAnswer, selectedAnswer)
    }
    return isCorrectAnswer;
  }

  checkAnswerIsCorrect() {
    console.debug("checkAnswerIsCorrect():");
    var isCorrectAnswer = false;
    var tempQuestionID = this.state.randomSubCategory + "_" + this.state.randomQuestionID;
    var tempSkillsMasterd = this.state.skillsMasterd;

    var tempCompletedCategoryArray = this.state.completedCategoryArray;
    var tempnumberOfCategories = this.state.numberOfCategories;
    var tempCategoriesMap = this.state.categoriesMap;
    var subCategoryQuestionMap = this.state.subCategoryQuestionMap;
    var categorySubcategoryMap = this.state.categorySubcategoryMap;

    var tempSubcategoriesMap = this.state.subcategoriesMap;
    var isNonGrade = false;
    if (tempSubcategoriesMap[this.state.randomSubCategory] !== undefined &&
      tempSubcategoriesMap[this.state.randomSubCategory] !== null) {

      if (tempSubcategoriesMap && tempSubcategoriesMap[this.state.randomSubCategory] && tempSubcategoriesMap[this.state.randomSubCategory].non_graded === 1) {
        isNonGrade = true;
        isCorrectAnswer = true;
      }
    }

    var correctAnswerArray = null;
    var currentQuestion = null;
    var tempAnswerChoosen = null;
    var tempRandomCategory = null;
    var shouldWaitB4Update = false;
    console.log("checkAnswerIsCorrectsurveyQuestionsRetrieved = ", this.state.surveyQuestionsRetrieved);
    if (this.state.surveyQuestionsRetrieved === false) {
      //Question answer check


      correctAnswerArray = this.state.correctAnswerMap[tempQuestionID];
      currentQuestion = this.state.questionMap[tempQuestionID];
      tempAnswerChoosen = this.state.selectedAnswer;
      tempRandomCategory = this.state.randomCategory;



      if (currentQuestion.question_nongraded !== undefined &&
        currentQuestion.question_nongraded !== null) {

        if (currentQuestion.question_nongraded === 1) {
          isNonGrade = true;
          isCorrectAnswer = true;
        }
      }


      // console.debug("tempRandomCategory = ", tempRandomCategory);

      // console.debug("correctAnswerArray = ", correctAnswerArray);
      // console.debug("this.state.randomQuestionID = ", this.state.randomQuestionID);
      // console.debug("currentQuestion = ", currentQuestion);

      // console.debug("tempAnswerChoosen = ", tempAnswerChoosen);

      //If Question Type is MQT 
      if (this.state.currentQuestionType === 3 && currentQuestion.answer_type === 2 || (this.state.currentQuestionType === 0 && currentQuestion.answer_type === 90)) {
        const {
          vector_answer_formulas,
        } = currentQuestion;
        const { currentVectorVariable, selectedAnswer } = this.state;
        if (isNonGrade === false) {
          if ((this.state.currentQuestionType === 0 && currentQuestion.answer_type === 90)) {
            const {
              vector_answer_formulas,
            } = currentQuestion;
            const { currentVectorVariable, selectedAnswer } = this.state;
            let tempVectorVariable = vector_answer_formulas.filter(
              (vector) => !vector?.isStaticVector && !vector?.isIncorrectAnswer
            );
            let vectorVariable = VectorParser.buildQuestionVariablesMap(tempVectorVariable)

            let isIncorrectAnswer
            let tempIncorrectVectorVariable = vector_answer_formulas.filter(vector => vector?.isIncorrectAnswer);
            const filteredAnswer = Object.keys(this.state.selectedAnswer)
              .filter(key => {
                const vector = this.state.selectedAnswer[key];
                return !vector?.isStaticVector && !vector?.isIncorrectAnswer;
              })
              .reduce((result, key, index) => {
                result[index] = this.state.selectedAnswer[key];
                return result;
              }, {});


            if (tempIncorrectVectorVariable.length > 0) {
              const selectedAnsKeys = Object.keys(this.state.selectedAnswer);
              const selectedAnsSet = new Set(selectedAnsKeys.map(key => this.state.selectedAnswer[key]?.name));
              // Check if any incorrect vector's name exists in the selected answers
              for (const vector of tempIncorrectVectorVariable) {
                if (selectedAnsSet.has(vector.name)) {
                  isIncorrectAnswer = true;
                  break; // Exit if incorrect answer is selected
                }
              }
            }
            if (!isIncorrectAnswer) {

              isCorrectAnswer = VectorParser.isAnswerCorrect(tempVectorVariable, filteredAnswer, vectorVariable, this.state.currentVectorSettings);

            } else {
              isCorrectAnswer = false
            }
          } else {
            isCorrectAnswer = VectorParser.isAnswerCorrect(vector_answer_formulas, selectedAnswer, currentVectorVariable, this.state.currentVectorSettings);
          }
        }

      } else if (this.state.currentQuestionType === 2) {
        if (isNonGrade === false)
          isCorrectAnswer = MQTOptions.isAnswerCorrect(this.state.mqt_options, this.state.selectedAnswer);
      } else {

        let answerType = currentQuestion.answer_type;
        if (isNonGrade === false) {
          switch (answerType) {
            case 0:
            case 30:
            case 70:
            case 50:
              //Radio Button
              isCorrectAnswer = this.CheckAnswerRadio(tempAnswerChoosen, currentQuestion);
              break;
            case 1:
            case 40:
            case 80:
            case 60:
              //Check Box
              isCorrectAnswer = this.CheckAnswerCheckBox(tempAnswerChoosen, currentQuestion);
              break;
            case 2:
              //Text Box
              isCorrectAnswer = this.CheckAnswerText(tempAnswerChoosen, currentQuestion);
              break;
            case 3:
              //RP Text Box
              isCorrectAnswer = this.CheckAnswerText(tempAnswerChoosen, currentQuestion);
              break;
            default:
              //Invalid Answer Type
              isCorrectAnswer = false;
              break;
          }
        }

      }



      if (isCorrectAnswer) {
        tempCategoriesMap[tempRandomCategory].score = tempCategoriesMap[tempRandomCategory].score + 1;
        console.log("this.state.categoriesMap", this.state.categoriesMap);
        console.log("score =", this.state.categoriesMap[tempRandomCategory].score);
        console.log("masteryCount = ", this.state.masteryCount);
        var tempCategorySet = this.state.categorySet;
        var tempCategoryArray = this.state.categoryArray;
        var tempMasteryCount = this.state.masteryCount;

        if (this.state.categoryMasteryCount[tempRandomCategory] !== undefined &&
          this.state.categoryMasteryCount[tempRandomCategory] !== null
          && this.state.categoryMasteryCount[tempRandomCategory] !== 0) {
          tempMasteryCount = this.state.categoryMasteryCount[tempRandomCategory];
        }



        if (tempCategoriesMap[tempRandomCategory].score > tempMasteryCount) {
          console.error("Question was incorrectly shown from mastered category ", tempRandomCategory);
          var index = tempCategorySet.indexOf(tempRandomCategory);
          if (index !== -1) {
            tempCategorySet.splice(index, 1);
          }
          var index = remainingCategorySet.indexOf(tempRandomCategory);
          if (index !== -1) {
            remainingCategorySet.splice(index, 1);
          }


          var index = tempCategoryArray.indexOf(tempRandomCategory);
          if (index !== -1) {
            tempCategoryArray.splice(index, 1);
          }
          console.log("tempRandomCategory = ", tempRandomCategory);
          console.log("After removed categoryset", this.state.categorySet);
          console.log("After removed categoryMap", this.state.categorySubcategoryMap);



          var removeMasterdSubcategory = this.state.categorySubcategoryMap[tempRandomCategory];
          if (removeMasterdSubcategory !== undefined && removeMasterdSubcategory !== null) {
            for (var x = 0; x < removeMasterdSubcategory.length; x++) {

              delete subCategoryQuestionMap[removeMasterdSubcategory[x]];
              //delete subCategoryCategoryMap[removeMasterdSubcategory[x]];

            }
          }
          delete categorySubcategoryMap[tempRandomCategory];
          delete remainingCatSubcatMap[tempRandomCategory];

          this.deleteCategory(tempRandomCategory);

          console.log("this.state.categorySet = ", tempCategorySet);
          console.log("this.state.categoryArray = ", tempCategoryArray);

          tempCompletedCategoryArray.push(tempRandomCategory);
          return;
        }
        let tempCategoryRandomizedKeys = [...this.state.categoryRandomizedKeys]
        if (tempCategoriesMap[tempRandomCategory].score === tempMasteryCount) {
          console.log("completed one category logic :", this.state.numberOfCategories);
          tempnumberOfCategories = tempnumberOfCategories + 1;
          console.log("tempnumberOfCategories =", tempnumberOfCategories);
          console.log("this.state.skillTotal =", this.state.skillTotal);

          tempSkillsMasterd = this.state.skillsMasterd + 1;

          shouldWaitB4Update = true;

          if (tempSkillsMasterd >= this.state.skillTotal) {
            tempSkillsMasterd = this.state.skillTotal;

            console.log("skillTotal completed :");

            this.setState(
              {
                hasMasteredQuiz: true,

              })
            console.log("All Skill mastered hasMasteredQuiz 1= ", this.state.hasMasteredQuiz);
          }
          var index = tempCategorySet.indexOf(tempRandomCategory);
          if (index !== -1) {
            tempCategorySet.splice(index, 1);
          }
          var index = remainingCategorySet.indexOf(tempRandomCategory);
          if (index !== -1) {
            remainingCategorySet.splice(index, 1);
          }


          var index = tempCategoryArray.indexOf(tempRandomCategory);
          if (index !== -1) {
            tempCategoryArray.splice(index, 1);
          }
          console.log("tempRandomCategory = ", tempRandomCategory);
          console.log("After removed categoryset", this.state.categorySet);
          console.log("After removed categoryMap", this.state.categorySubcategoryMap);


          console.log("Before Removing completed cat from categoryRandomizedKeys ", this.state.categoryRandomizedKeys);
          for (var i = currentCategoryCounter + 1; i < tempCategoryRandomizedKeys.length; i++) {
            if (tempCategoryRandomizedKeys[i] === tempRandomCategory) {
              tempCategoryRandomizedKeys.splice(i, 1);
            }
          }
          console.log("After Removing completed cat from categoryRandomizedKeys ", tempCategoryRandomizedKeys);

          var removeMasterdSubcategory = this.state.categorySubcategoryMap[tempRandomCategory];
          if (removeMasterdSubcategory !== undefined && removeMasterdSubcategory !== null) {
            for (var x = 0; x < removeMasterdSubcategory.length; x++) {

              delete subCategoryQuestionMap[removeMasterdSubcategory[x]];
              //delete subCategoryCategoryMap[removeMasterdSubcategory[x]];

            }
          }
          delete categorySubcategoryMap[tempRandomCategory];
          delete remainingCatSubcatMap[tempRandomCategory];

          this.deleteCategory(tempRandomCategory);

          console.log("this.state.categorySet = ", tempCategorySet);
          console.log("this.state.categoryArray = ", tempCategoryArray);

          tempCompletedCategoryArray.push(tempRandomCategory);
          shouldWaitB4Update = true;
        }
        if (this.state.isTest !== 1) {
          //Quiz
          this.setState(
            {
              showAnswerResponse: true,
              answerCorrect: true,
              completedCategoryArray: tempCompletedCategoryArray,
              categoriesMap: tempCategoriesMap,
              categorySet: tempCategorySet,
              categoryArray: tempCategoryArray,
              categoryRandomizedKeys: tempCategoryRandomizedKeys,
              // hideNext:false,
            })
        }
        this.getLiveAnalytics();
      }
      else {
        //Wrong Answer
        var categoriesMap = this.state.categoriesMap;
        categoriesMap[tempRandomCategory].score = 0;

        this.setState({
          categoriesMap: categoriesMap,
          numberOfCategories: tempnumberOfCategories,
          skillsMasterd: tempSkillsMasterd
        }, () => {

          if (this.state.isTest !== 1) {


            //Is test is true doesn't buttons
            if (this.state.maxWrong === this.state.tryAgainCount) {
              this.setState({
                tryAgainButtonDisplay: false,
                displayCorrectAnswer: true
              })
            } else {
              this.setState({
                tryAgainButtonDisplay: true,
                displayCorrectAnswer: false
              })
            }
            this.setState(
              {
                showAnswerResponse: true,
                answerCorrect: false,
                //numberOfCategories:0,
              })
          }
          if (isCorrectAnswer) {

            this.setState({
              tryAgainButtonDisplay: false
            })
          }

          this.saveProgress(isCorrectAnswer);
          return;

        });
        return
      }

      if (shouldWaitB4Update === true) {
        this.setState({
          numberOfCategories: tempnumberOfCategories,
          skillsMasterd: tempSkillsMasterd,
          subCategoryQuestionMap: subCategoryQuestionMap,
          categorySubcategoryMap: categorySubcategoryMap,

        }, () => {
          this.saveProgress(isCorrectAnswer);
          return;
        })
      }
      else {
        this.saveProgress(isCorrectAnswer);
        return;
      }

    }
    this.setState({
      submitClicked: true
    })

  }

  checkIfMQTAnswersSelectedForQuestion = (question, selectedAnswer) => {
    const { mqt_options } = question;

    if (mqt_options && selectedAnswer) {
      const { mqt_questions } = mqt_options;

      const questiondIDs = Object.keys(mqt_questions);
      for (const i in questiondIDs) {
        const qID = questiondIDs[i];
        if (selectedAnswer[qID]) {
          if (selectedAnswer[qID].length) {
            if (selectedAnswer[qID].length < 1) {
              return false;
            }
          } else {
            return false;
          }
        } else {
          return false;
        }
      }

      return true;
    }
    return false;
  }


  isMQTAnswersSelected = () => {
    const { mqt_options, selectedAnswer } = this.state;

    if (mqt_options && selectedAnswer) {
      const { mqt_questions } = mqt_options;

      const questiondIDs = Object.keys(mqt_questions);
      for (const i in questiondIDs) {
        const qID = questiondIDs[i];
        if (selectedAnswer[qID]) {
          if (selectedAnswer[qID].length) {
            if (selectedAnswer[qID].length < 1) {
              return false;
            }
          } else {
            return false;
          }
        } else {
          return false;
        }
      }

      return true;
    }
    return false;
  }

  async showAlert(title, msg, yesLabel, noLabel) {
    return new Promise((resolve, reject) => {
      let buttons = [{
        label: yesLabel,
        onClick: () => {
          resolve(true); // Resolving with true if 'Submit' is clicked
        }
      },
      {
        label: noLabel,
        onClick: () => {
          resolve(false); // Resolving with false if 'Cancel' is clicked
        }
      }];
      if (title === "Paused Categories!") {
        buttons = [
          {
            label: yesLabel,
            onClick: () => {
              resolve(true); // Resolving with true if 'Submit' is clicked
            }
          }
        ];
      }
      confirmAlert({
        title: title,
        closeOnEscape: false,
        closeOnClickOutside: false,
        message: msg,
        buttons: buttons,
      });
    });
  }


  async reasoningChainAnswerValidation() {

    if (this.state.currentQuestionType === 4) {
      let hasConclusionSentence = this.state.selectedAnswer.includes("C")

      if (this.state.isConclusionSentenceRequired && !hasConclusionSentence) { // if concl sent is required and not been selected
        NotificationManager.warning("You need to pick atleast one conclusion sentences.")
        return false;
      }

      if (!this.state.isConclusionSentenceRequired && !hasConclusionSentence) { // if concl sent is NOT required and not been selected
        const result = await this.showAlert("Gentle reminder", "You have not added a conclusion. Do you wish to continue submitting the question without adding a conclusion?", "Submit", "Cancel");
        if (!result) {
          return false;
        }
      }

      return true;
    }

    return true;
  }


  async onSubmitClick() {
    // clear all previous notifications
    NotificationManager.listNotify.forEach(n => NotificationManager.remove({ id: n.id }));

    if (this.state.currentQuestionType === 3 && this.state.answerType === 2 || (this.state.currentQuestionType === 0 && this.state.answerType === 90)) {
      var currentQuestion = null;
      var tempQuestionID = this.state.randomSubCategory + "_" + this.state.randomQuestionID;
      currentQuestion = this.state.questionMap[tempQuestionID];
    }

    // console.debug("this.state.selectedAnswer =", this.state.selectedAnswer);
    // console.debug("this.state.selectedAnswer =", this.state.selectedAnswer.length);
    if (this.state.currentQuestionType === 2) {
      // console.debug("this.isMQTAnswersSelected()", this.isMQTAnswersSelected())
      if (!this.isMQTAnswersSelected()) {
        NotificationManager.warning(`Please choose an answer for each Question`, '', 3000)
        // alert("Please choose an answer for each Question");
        return;
      }
    }

    const answerType = this.state.questionMap[this.state.randomSubCategory + "_" + this.state.randomQuestionID].answer_type

    let questID = this.state.randomSubCategory + "_" + this.state.randomQuestionID;
    let quest = this.state.questionMap[questID];
    // console.log('this.state>>>>>', this.state, quest);
    if (this.state.currentQuestionType !== 4) {
      if (!this.hasValidValue(this.state.selectedAnswer, quest)) {
        // console.debug("answerType ", answerType)
        if (answerType !== undefined && answerType === 3) {
          NotificationManager.warning(`Please enter the answer`, '', 3000)
        } else {
          NotificationManager.warning(`Please choose an answer`, '', 3000)
        }
        return;
      }
    }


    // checking for reasoning chain answer validation
    if (this.state.currentQuestionType === 4) {
      let isValid = await this.reasoningChainAnswerValidation();
      if (!isValid) return;
    }


    if (this.state.currentQuestionType !== 2 && answerType == 3 && !MathParserUtil.isAnswerSelected(this.state.answer_formula.formulaMap, this.state.selectedAnswer)) {
      NotificationManager.warning(`Please enter the answer in all boxes`, '', 3000)
      //alert("Please enter the answer in all boxes");
      return;
    }

    if (submitClickInProgress === false) {
      submitClickInProgress = true;
      this.setState({
        submitButtonDisplay: false,
        showSubmitLoader: true,
        hideNext: false
      }, () => {
        console.debug("On Submit Click");

        if (this.state.isTest === 1) {
          //this.setState({pageLoading:true});
          let isCorrectAnswer = false;
          if (this.state.currentQuestionType === 3 && this.state.answerType === 2) {
            const {
              vector_answer_formulas,
            } = currentQuestion;
            const { currentVectorVariable, selectedAnswer } = this.state;
            isCorrectAnswer = VectorParser.isAnswerCorrect(vector_answer_formulas, selectedAnswer, currentVectorVariable, this.state.currentVectorSettings);
          }
          if ((this.state.currentQuestionType === 0 && this.state.answerType === 90)) {
            const {
              vector_answer_formulas,
            } = currentQuestion;
            const { currentVectorVariable, selectedAnswer } = this.state;
            let tempVectorVariable = vector_answer_formulas.filter((vector) => !vector?.isStaticVector && !vector?.isIncorrectAnswer)
            let vectorVariable = VectorParser.buildQuestionVariablesMap(tempVectorVariable)
            let isIncorrectAnswer
            let tempIncorrectVectorVariable = vector_answer_formulas.filter(vector => vector?.isIncorrectAnswer);
            const filteredAnswer = Object.keys(this.state.selectedAnswer)
              .filter(key => {
                const vector = this.state.selectedAnswer[key];
                return !vector?.isStaticVector && !vector?.isIncorrectAnswer;
              })
              .reduce((result, key, index) => {
                result[index] = this.state.selectedAnswer[key];
                return result;
              }, {});

            if (tempIncorrectVectorVariable.length > 0) {
              const selectedAnsKeys = Object.keys(this.state.selectedAnswer);
              const selectedAnsSet = new Set(selectedAnsKeys.map(key => this.state.selectedAnswer[key]?.name));
              // Check if any incorrect vector's name exists in the selected answers
              for (const vector of tempIncorrectVectorVariable) {
                if (selectedAnsSet.has(vector.name)) {
                  isIncorrectAnswer = true;
                  break; // Exit if incorrect answer is selected
                }
              }
            }
            if (!isIncorrectAnswer) {
              isCorrectAnswer = VectorParser.isAnswerCorrect(tempVectorVariable, filteredAnswer, vectorVariable, this.state.currentVectorSettings);
            } else {
              isCorrectAnswer = false
            }

          }
          this.saveProgress(isCorrectAnswer);
          submitClickInProgress = false;
          this.setState({
            hideNext: true
          });
          /* var tempDate = this.getDateTime();
           const tempQuestionStartTimeStamp = MomentTz(tempDate).tz(timeZone).format("YYYY-MM-DD HH:mm:ss");
           console.debug("tempQuestionStartTimeStamp =",tempQuestionStartTimeStamp);
           this.questionStartTimeStamp =  tempQuestionStartTimeStamp;
           */
          return;
        }
        //Dummy Code, to be changed later
        console.debug("this.state.selectedAnswer = ", this.state.selectedAnswer);

        this.checkAnswerIsCorrect();
        submitClickInProgress = false;

      });
    }

    // const result = await this.showAlert("Paused Categories!", "You've completed all unpaused categories, but some remain paused. Do you want to resume them or submit your assignment?", "Resume", "Submit");

    this.findFeedbackText(this.state.selectedAnswer, false);
    this.onFeedbackClick();

  }

  surveyBtnClick() {
    if (this.state.isTest === 1) {
      this.setState({
        pageLoading: true
      })
    }
    this.saveSurvey();

  }

  getNextSurveyQuestion() {
    var tempsurveyQPointer = this.state.surveyQPointer;
    var tempSurveyQuestionIdArr = this.state.surveyQuestionIdArr;

    var tempSurveyPreviousQuestionId = tempSurveyQuestionIdArr[tempsurveyQPointer];
    var tempRandomQuestion = tempSurveyPreviousQuestionId;
    tempsurveyQPointer++;
    if (tempsurveyQPointer >= tempSurveyQuestionIdArr.length) {
      this.finish();
      return;
    }

    if (tempSurveyQuestionIdArr[tempsurveyQPointer] !== null &&
      tempSurveyQuestionIdArr[tempsurveyQPointer] !== undefined) {
      tempRandomQuestion = tempSurveyQuestionIdArr[tempsurveyQPointer];
    }
    else {
      tempRandomQuestion = tempSurveyQuestionIdArr[tempsurveyQPointer - 1];
    }


    //var tempRandomQuestion = tempSurveyQuestionIdArr[this.state.surveyQPointer];
    console.log("tempRandomQuestionID = ", tempRandomQuestion);

    var tempQuestionDetails = tempRandomQuestion.split("_");
    var tempRandomQuestionID = tempQuestionDetails[4];

    // var tempRandomSubCategory = tempQuestionDetails[0]+"_"+tempQuestionDetails[1]+"_"+tempQuestionDetails[2]+"_"+tempQuestionDetails[3];




    this.setState({
      randomQuestionID: tempRandomQuestionID,
      //randomSubCategory: tempRandomSubCategory,
      surveyQuestionIdArr: tempSurveyQuestionIdArr,
      surveyQPointer: tempsurveyQPointer,
      surveyPreviousQuestionId: tempSurveyPreviousQuestionId,
    }, () => {
      this.displaySurveyQuestion();
    })
  }

  onPrevClick() {
    console.debug("Try Again");
    var tempDisplayAnswerArr = this.state.displayAnswerArr;
    var tempTryAgainCount = this.state.tryAgainCount + 1;
    var tempQuestionAttempt = this.state.question_attempt + 1;
    //this.setState({displayAnswerArr:[],})
    this.setState({
      questionStartTime: new Date(),
      submitButtonDisplay: true,
      tryAgainButtonDisplay: false,
      showAnswerResponse: false,
      answerCorrect: false,
      // displayAnswerArr:tempDisplayAnswerArr,
      tryAgainCount: tempTryAgainCount,
      forceUpdateHandler: true,
      //feedback & liveanalytics
      feedbackPopupVisible: false,
      feedbackOn: true,
      feedbackAnswer: null,
      feedbackButtonVisible: false,
      liveAnalyticsButtonVisible: false,
      liveAnalyticsPopup: false,
      displayCorrectAnswer: false,
      selectedAnswer: [],
      explanationButtonDisplay: false,
      showRPAnswer: false,
      showVectorAnswer: false,
      question_attempt: tempQuestionAttempt,
      showWelcomeBackMsg: false,
    })

    let tempQuestionID = this.state.randomSubCategory + "_" + this.state.randomQuestionID;
    let question = this.state.questionMap[tempQuestionID];

    let payload = {
      unique_id: tempQuestionID,
      subject_id: question.subject_id,
      topic_id: question.topic_id,
      category_id: question.category_id,
      subcategory_id: question.subcategory_id,
      question_id: question.question_id,
      quiz_id: this.state.quizId,
      section_id: parseInt(this.params.get("section_id")),
      student_answer_string: "",
      update_student_answer: true,
      other_state_map_string: JSON.stringify({
        submitButtonDisplay: true,
        tryAgainButtonDisplay: false,
        showAnswerResponse: false,
        answerCorrect: false,
        tryAgainCount: tempTryAgainCount,
        forceUpdateHandler: true,
        feedbackPopupVisible: false,
        feedbackOn: true,
        feedbackAnswer: null,
        feedbackButtonVisible: false,
        liveAnalyticsButtonVisible: false,
        liveAnalyticsPopup: false,
        hideNext: false,
        displayCorrectAnswer: false,
        question_attempt: tempQuestionAttempt,
        explanationButtonDisplay: false,
        showRPAnswer: false,
        showVectorAnswer: false,
      })
    }

    this.updateQuestionState(payload)

  }

  onExplanationClick() {
    console.debug("Explanation Clicked");
    if (this.state.explanationGalleryVisible == false) {

      this.setState({
        explanationGalleryVisible: true
      })
    } else {
      this.setState({
        explanationGalleryVisible: false
      })
    }

  }

  onTutorialsClick = () => {
    this.setState({
      showTutorials: true
    });
  }

  handleCloseTutorials = () => {
    this.setState({
      showTutorials: false
    });
  }

  onFeedbackClick() {
    console.debug("quiz_id ", this.state.quizId);
    console.debug("feedback Clicked", this.state.liveAnalyticsPopup, this.state.feedbackAnswer);
    if (this.state.liveAnalyticsPopup == true) {
      this.setState({
        liveAnalyticsPopup: false,
        liveAnalyticsButtonVisible: true
      })
    }
    //if(this.state.feedbackButtonVisible==true){
    if (this.state.feedbackAnswer !== undefined && this.state.feedbackAnswer !== null) {
      this.setState({
        feedbackPopupVisible: true,
        feedbackButtonVisible: false
      })
      //}else{
      //this.setState({
      //feedbackPopupVisible:false
      //})}
    }
  }
  onFeedbackCloseClick() {
    this.setState({
      feedbackPopupVisible: false,
      feedbackButtonVisible: true
    })
  }

  onliveAnalyticsCloseClick() {
    this.setState({
      liveAnalyticsPopup: false,
      liveAnalyticsButtonVisible: true
    });
  }
  liveAnalyticsClick() {
    if (this.state.liveAnalytics.user_count !== undefined && this.state.liveAnalytics.user_count !== null) {
      if (this.state.liveAnalytics.user_count > 10) {
        this.setState({
          liveAnalyticsPopup: true,
          liveAnalyticsButtonVisible: false
        })
      } else {
        console.debug("usercount :", this.state.liveAnalytics.user_count)
        this.setState({
          liveAnalyticsPopup: false,
          liveAnalyticsButtonVisible: true
        })
        alert("Sorry less than 10 only answered this Question")
      }
    } else {

    }
    if (this.state.feedbackPopupVisible == true) {
      this.setState({
        feedbackButtonVisible: true,
        feedbackPopupVisible: false
      })
    }
  }


  findFeedbackText(selectedAns, avl) {
    var feedbackTxt = ""
    var currFeedbackAns = {}
    console.debug(selectedAns)
    var tempcurrentFeedbackSubCategory, tempfeedbackSubcategoryList, tempfeedbackCurrentQuestion;
    if (this.state.feedbackOn == true || avl == true) {
      tempcurrentFeedbackSubCategory = this.state.currentFeedbackSubCategory;
      tempfeedbackSubcategoryList = this.state.subcategoriesMap;
      tempfeedbackCurrentQuestion = this.state.feedbackCurrentQuestion;
      console.debug("this the question details ", tempfeedbackCurrentQuestion)
      console.debug("this the tempfeedbackSubcategoryList details ", tempfeedbackSubcategoryList)
      console.debug("this the tempcurrentFeedbackSubCategory details ", tempcurrentFeedbackSubCategory)
      if (tempfeedbackCurrentQuestion?.enable_feedback === true &&
        tempfeedbackSubcategoryList[tempcurrentFeedbackSubCategory]?.enable_feedback === true) {
        console.log("feedback enabled")
        if (selectedAns.constructor == Array) {
          for (let i = 0; i <= tempfeedbackCurrentQuestion.answers.length - 1; i++) {
            for (let j = 0; j <= selectedAns.length - 1; j++) {
              console.debug(i, j)
              if (tempfeedbackCurrentQuestion.answers[i].feedback_text !== undefined && tempfeedbackCurrentQuestion.answers[i].feedback_text !== null &&
                tempfeedbackCurrentQuestion.answers[i].feedback_text !== '') {
                if (tempfeedbackCurrentQuestion.answers[i].answer_id == selectedAns[j]) {
                  console.debug(tempfeedbackCurrentQuestion.answers[i].answer_id)
                  console.debug(tempfeedbackCurrentQuestion.answers[i].feedback_text)
                  try {
                    var tempFeed = TextEditor.getHTMLStringFromEditorState(EditorState.createWithContent(
                      convertFromRaw(JSON.parse(tempfeedbackCurrentQuestion.answers[i].feedback_text)))).toString('html', null);
                    console.debug("feedback ", tempFeed)
                    //alt feedback text
                    console.debug(tempfeedbackCurrentQuestion.answers[i].alt_feedback_text)
                    if (tempfeedbackCurrentQuestion.answers[i].alt_feedback_text !== undefined &&
                      tempfeedbackCurrentQuestion.answers[i].alt_feedback_text !== null &&
                      tempfeedbackCurrentQuestion.answers[i].alt_feedback_text !== "") {
                      console.debug("hello")
                      var tempDisplayFeedbackText = tempFeed
                      var altFeedbackText = tempfeedbackCurrentQuestion.answers[i].alt_feedback_text
                      altFeedbackText = altFeedbackText.replace(/\n/ig, ' ')
                      //finding number of time image present
                      var altFeedbackTextCount = altFeedbackText.split(';').length
                      var feedbackImgTagCount = tempDisplayFeedbackText.split('<img').length - 1
                      // console.debug("altFeedbackTextCount ,feedbackImgTagCount ",altFeedbackTextCount,feedbackImgTagCount,randomQuestion.answers.length-1)
                      console.debug((altFeedbackTextCount / 2), "==", feedbackImgTagCount)
                      if ((altFeedbackTextCount / 2) == feedbackImgTagCount) {
                        if (feedbackImgTagCount >= 1) {
                          console.debug("Answer greater than 1")
                          var altFeedbackTextArr = altFeedbackText.split(';');
                          var lastPosOfImg = 0
                          // console.debug("altanswer",altFeedbackTextArr)
                          for (var k = 0; k <= altFeedbackTextArr.length - 1; k = k + 2) {
                            // console.debug(j)
                            lastPosOfImg = tempDisplayFeedbackText.indexOf("<img", lastPosOfImg)
                            lastPosOfImg = lastPosOfImg + 4
                            var b = "  title =\"" + altFeedbackTextArr[k] + "\"  alt =\"" + altFeedbackTextArr[k + 1] + "\" "
                            var output = [tempDisplayFeedbackText.slice(0, lastPosOfImg), b, tempDisplayFeedbackText.slice(lastPosOfImg)].join('');
                            tempDisplayFeedbackText = output
                            console.debug("answertest", k, " ", tempDisplayFeedbackText)
                          }
                        }
                      }
                      tempFeed = tempDisplayFeedbackText
                    }
                    //alt feedback text
                  }
                  catch (err) {
                    console.error(err.message);
                  }
                  feedbackTxt = feedbackTxt.concat(tempFeed)
                  console.debug(feedbackTxt)
                }
              }
            }
          }
        } else {
          for (let i = 0; i <= tempfeedbackCurrentQuestion?.answers?.length - 1; i++) {
            if (tempfeedbackCurrentQuestion.answers[i].feedback_text !== undefined && tempfeedbackCurrentQuestion.answers[i].feedback_text !== null &&
              tempfeedbackCurrentQuestion.answers[i].feedback_text !== '') {
              console.debug(i)
              if (tempfeedbackCurrentQuestion.answers[i].answer_id == selectedAns) {
                console.debug(tempfeedbackCurrentQuestion.answers[i].answer_id)
                console.debug(tempfeedbackCurrentQuestion.answers[i].feedback_text)
                try {
                  var tempFeed = TextEditor.getHTMLStringFromEditorState(EditorState.createWithContent(
                    convertFromRaw(JSON.parse(tempfeedbackCurrentQuestion.answers[i].feedback_text)))).toString('html', null);
                  console.debug("feedback ", tempFeed)
                  //alt feedback text
                  console.debug(tempfeedbackCurrentQuestion.answers[i].alt_feedback_text)
                  if (tempfeedbackCurrentQuestion.answers[i].alt_feedback_text !== undefined &&
                    tempfeedbackCurrentQuestion.answers[i].alt_feedback_text !== null &&
                    tempfeedbackCurrentQuestion.answers[i].alt_feedback_text !== "") {
                    console.debug("hello")
                    var tempDisplayFeedbackText = tempFeed
                    var altFeedbackText = tempfeedbackCurrentQuestion.answers[i].alt_feedback_text
                    altFeedbackText = altFeedbackText.replace(/\n/ig, ' ')
                    //finding number of time image present
                    var altFeedbackTextCount = altFeedbackText.split(';').length
                    var feedbackImgTagCount = tempDisplayFeedbackText.split('<img').length - 1
                    // console.debug("altFeedbackTextCount ,feedbackImgTagCount ",altFeedbackTextCount,feedbackImgTagCount,randomQuestion.answers.length-1)
                    console.debug((altFeedbackTextCount / 2), "==", feedbackImgTagCount)
                    if ((altFeedbackTextCount / 2) == feedbackImgTagCount) {
                      if (feedbackImgTagCount >= 1) {
                        console.debug("Answer greater than 1")
                        var altFeedbackTextArr = altFeedbackText.split(';');
                        var lastPosOfImg = 0
                        // console.debug("altanswer",altFeedbackTextArr)
                        for (var j = 0; j <= altFeedbackTextArr.length - 1; j = j + 2) {
                          // console.debug(j)
                          lastPosOfImg = tempDisplayFeedbackText.indexOf("<img", lastPosOfImg)
                          lastPosOfImg = lastPosOfImg + 4
                          var b = "  title =\"" + altFeedbackTextArr[j] + "\"  alt =\"" + altFeedbackTextArr[j + 1] + "\" "
                          var output = [tempDisplayFeedbackText.slice(0, lastPosOfImg), b, tempDisplayFeedbackText.slice(lastPosOfImg)].join('');
                          tempDisplayFeedbackText = output
                          console.debug("answertest", j, " ", tempDisplayFeedbackText)
                        }
                      }
                    }
                    tempFeed = tempDisplayFeedbackText
                  }
                  //alt feedback text
                }
                catch (err) {
                  console.error(err.message);
                }
                feedbackTxt = feedbackTxt.concat(tempFeed)
                console.debug(feedbackTxt)

              }
            }
          }
        }
        console.debug("on findffeback ", feedbackTxt)
        if (feedbackTxt !== undefined && feedbackTxt !== null && feedbackTxt !== "") {

          console.debug("on findffeback ", feedbackTxt)

          if (feedbackTxt !== undefined && feedbackTxt !== null && feedbackTxt !== "") {
            this.setState({
              feedbackOn: false,
              feedbackPopupVisible: true,
              feedbackButtonVisible: false,
              feedbackAnswer: feedbackTxt
            });

          }
        }

      } else {
        console.log("feedback disables")
      }
    } else {
      console.log("feedback is false")
    }
    console.debug(this.state.feedbackAnswer)
  }

  getLiveAnalytics() {
    var tempcurrentSubCategory = this.state.currentFeedbackSubCategory;
    var tempSubcategoryList = this.state.subcategoriesMap;
    var tempCurrentQuestion = this.state.feedbackCurrentQuestion;
    console.debug("get live analytics is ", tempCurrentQuestion.enable_analytics, tempSubcategoryList, tempcurrentSubCategory, tempSubcategoryList[tempcurrentSubCategory])
    if (tempCurrentQuestion.enable_analytics === true && tempcurrentSubCategory && tempSubcategoryList[tempcurrentSubCategory] &&
      tempSubcategoryList[tempcurrentSubCategory].enable_analytics === true) {
      const payload = {
        quiz_id: this.state.quizId,
        question_id: tempCurrentQuestion.question_id,
        user_id: "",
        topic_id: tempCurrentQuestion.topic_id,
        subject_id: tempCurrentQuestion.subject_id,
        category_id: tempCurrentQuestion.category_id,
        subcategory_id: tempCurrentQuestion.subcategory_id,
        parent_quiz_id: tempCurrentQuestion.parentQuizID,
      }
      console.debug("the live data payload is ", payload)
      this.props.apiService({
        method: 'post',
        url: '/getLiveAnalytics',
        data: payload,

      })
        .then(res => {

          if (res !== undefined && res.data !== undefined && res.data.data !== undefined &&
            res !== null && res.data !== null && res.data.data !== null) {
            if (res.data.data.answers_count !== undefined && res.data.data.answers_count !== null) {

              console.debug("live data ", res.data.data)
              this.setState({
                liveAnalytics: res.data.data,
                liveAnalyticsButtonVisible: true,
              });

            } else {
              console.debug("no data in live analytics")
              this.setState({
                liveAnalyticsButtonVisible: false,
                liveAnalyticsPopup: false
              });
            }
          }

        });
    } else {
      console.debug("enable analytics is false")
      this.setState({
        liveAnalyticsButtonVisible: false,
        liveAnalyticsPopup: false
      });
    }
  }


  appendExplanations(expArr, elem) {
    if (elem !== undefined &&
      elem !== null) {
      expArr = expArr.concat(elem);
      return { expArr: expArr, isAdded: true };
    }
    return { expArr: expArr, isAdded: false };
  }

  saveElapsedTimeForExplanations(startTimeMap, endTimeMap) {
    console.log("StartTime ", startTimeMap, " endTime ", endTimeMap);
    var explanationElapsedTimeArr = [];
    var elapsedTime = 0;
    for (let i = 0; i < this.state.explanations.length; i++) {
      var tempEndTimeArr = endTimeMap[i];
      var tempStartTimeArr = startTimeMap[i];
      if (tempEndTimeArr !== undefined && tempEndTimeArr !== null &&
        tempStartTimeArr !== undefined && tempStartTimeArr !== null) {
        for (let j = 0; j < tempEndTimeArr.length; j++) {
          elapsedTime += Math.round((Math.abs(tempEndTimeArr[j].getTime() - tempStartTimeArr[j].getTime())) / 1000);

        }
        explanationElapsedTimeArr.push({
          subject_id: this.state.explanations[i].subject_id,
          topic_id: this.state.explanations[i].topic_id,
          category_id: this.state.explanations[i].category_id,
          subcategory_id: this.state.explanations[i].subcategory_id,
          explanation_id: this.state.explanations[i].explanation_id,
          elapsed_time: elapsedTime
        });
        elapsedTime = 0;

      }
    }
    var idArr = this.state.randomSubCategory.split('_');

    var payload = {
      user_id: this.state.userId,
      quiz_id: this.state.quizId,
      parent_quiz_id: this.state.parentQuizID,
      question: {
        subject_id: parseInt(idArr[0]),
        topic_id: parseInt(idArr[1]),
        category_id: parseInt(idArr[2]),
        subcategory_id: parseInt(idArr[3]),
        question_id: this.state.randomQuestionID
      },
      elapsed_time: explanationElapsedTimeArr
    };

    console.log("the PAyload for elapsedTime is  ", payload);
    this.props.apiService({
      method: 'post',
      url: '/addElapsedTime',
      data: payload
    }).then(res => { });

  }

  sortExplanations = (explanations) => {
    const getLevel = (e) => {
      if (e.category_id === 0 && e.subcategory_id === 0) return 0; // topic
      if (e.subcategory_id === 0) return 1;                        // category
      return 2;                                                    // subcategory
    };

    // Sort: topic → category → subcategory
    const sortedExplanations = [...explanations].sort((a, b) => {
      return getLevel(a) - getLevel(b);
    });

    return sortedExplanations
  }

  getTutorialsData = async () => {
    let subCatUniqueID = this.state.randomSubCategory;
    if (this.state.randomCategory !== undefined && this.state.randomCategory !== null
      && this.state.randomSubCategory !== undefined && this.state.randomSubCategory !== null) {
      // Return cached tutorials if already fetched for this subcategory
      if (this.state.subcategoryTutorialMap[subCatUniqueID] !== undefined) {
        return;
      }
      let idArr = this.state.randomSubCategory.split('_');
      if (idArr && idArr.length === 4) {
        this.props.apiService({
          method: 'post',
          url: '/getTutorialsForQuestion',
          data: {
            subject_id: parseInt(idArr[0], 10),
            topic_id: parseInt(idArr[1], 10),
            category_id: parseInt(idArr[2], 10),
            subcategory_id: parseInt(idArr[3], 10),
          }
        }).then(res => {
          let tutorials = res?.data?.data || [];
          let subcategoryTutorialMap = { ...this.state.subcategoryTutorialMap };
          subcategoryTutorialMap[subCatUniqueID] = tutorials;
          this.setState({ subcategoryTutorialMap });
        });
      }
    }
  }

  getExplanationData = async () => {
    var is_topic_exp_needed = 0;
    var is_cat_exp_needed = 0;
    console.debug("Getting explantion information");
    var subCatUniqueID = this.state.randomSubCategory;
    if (this.state.randomCategory !== undefined && this.state.randomCategory !== null
      && this.state.randomSubCategory !== undefined && this.state.randomSubCategory !== null) {
      var idArr = this.state.randomSubCategory.split('_');
      var topic_id = idArr[0] + "_" + idArr[1];
      var category_id = topic_id + "_" + idArr[2];

      var expArr = [];

      var expAppendResp = this.appendExplanations(expArr, this.state.topicExplanationMap[topic_id]);
      if (expAppendResp.isAdded == false) {
        is_topic_exp_needed = 1;
      }
      else {
        expArr = expAppendResp.expArr;
      }

      var expAppendResp = this.appendExplanations(expArr, this.state.categoryExplanationMap[category_id]);
      if (expAppendResp.isAdded == false) {
        is_cat_exp_needed = 1;
      }
      else {
        expArr = expAppendResp.expArr;
      }

      var expAppendResp = this.appendExplanations(expArr, this.state.subcategoryExplanationMap[subCatUniqueID]);

      expArr = expAppendResp.expArr;

      if (this.state.subcategoryExplanationMap[subCatUniqueID] !== undefined &&
        this.state.subcategoryExplanationMap[subCatUniqueID] != null &&
        this.state.subcategoryExplanationMap[subCatUniqueID].length > 0) {

        this.setState({
          explanations: this.sortExplanations(expArr),
          explanationButtonDisplay: true
        });
        return
      }

      var exp_payload = {
        explanation: {
          subject_id: parseInt(idArr[0]),
          topic_id: parseInt(idArr[1]),
          category_id: parseInt(idArr[2]),
          subcategory_id: parseInt(idArr[3])
        },
        is_topic_exp_needed: is_topic_exp_needed,
        is_cat_exp_needed: is_cat_exp_needed,

      };
      this.props.apiService({
        method: 'post',
        url: '/getAllExplanations',
        data: exp_payload
      }).then(res => {
        if (res.data.data != null) {
          var topicExplanationMap = this.state.topicExplanationMap;
          var categoryExplanationMap = this.state.categoryExplanationMap;
          var subcategoryExplanationMap = this.state.subcategoryExplanationMap;

          var finalExpArr = [];
          if (res.data.data.subcat_explanations != null) {
            subcategoryExplanationMap[subCatUniqueID] = res.data.data.subcat_explanations;
            finalExpArr = finalExpArr.concat(subcategoryExplanationMap[subCatUniqueID]);
          }

          if (is_cat_exp_needed == 0) {
            if (categoryExplanationMap[category_id] !== undefined &&
              categoryExplanationMap[category_id] !== null)
              finalExpArr = finalExpArr.concat(categoryExplanationMap[category_id]);
          } else {
            if (res.data.data.cat_explanations != null) {
              categoryExplanationMap[category_id] = res.data.data.cat_explanations;
              finalExpArr = finalExpArr.concat(categoryExplanationMap[category_id]);
            }
          }

          if (is_topic_exp_needed == 0) {
            if (topicExplanationMap[topic_id] !== undefined &&
              topicExplanationMap[topic_id] !== null)
              finalExpArr = finalExpArr.concat(topicExplanationMap[topic_id]);
          } else {
            if (res.data.data.topic_explanations != null) {
              topicExplanationMap[topic_id] = res.data.data.topic_explanations;
              finalExpArr = finalExpArr.concat(topicExplanationMap[topic_id]);
            }
          }



          if (finalExpArr.length > 0) {
            this.setState({
              topicExplanationMap: topicExplanationMap,
              categoryExplanationMap: categoryExplanationMap,
              subcategoryExplanationMap: subcategoryExplanationMap,
              explanations: this.sortExplanations(finalExpArr),
              explanationButtonDisplay: true
            });
          }
        }

        console.debug('explantion =', this.state.explanations, finalExpArr)
      });

    }
  }

  onNextClick() {
    // clear all notifications
    NotificationManager.listNotify.forEach(n => NotificationManager.remove({ id: n.id }));
    this.shouldFocusEmbeddedTutorialQuestion = this.isEmbeddedTutorial();
    /*
    this.setState({
      feedbackPopupVisible:false,
      feedbackOn:true,
      feedbackAnswer:null,
      liveAnalytics:null,
      liveAnalyticsButtonVisible:false,
      liveAnalyticsPopup:false,
      showMQTAnswers:false //Disable Show Correct Answer for MQT
    })
    console.debug("On Next Click");
    this.setState({feedbackButtonVisible:false});
    var tempDate = this.getDateTime();
    const tempQuestionStartTimeStamp = MomentTz(tempDate).tz(timeZone).format("YYYY-MM-DD HH:mm:ss");
    console.debug("tempQuestionStartTimeStamp =",tempQuestionStartTimeStamp);


    //var start_date = MomentTz.tz(mm+"-"+dd+"-"+yyyy+" "+currentItem.start_time,'DD/MM/YYYY hh:mm:ss',timeZone);


    this.questionStartTimeStamp =  tempQuestionStartTimeStamp;
    this.setState({showSkip : false,
      hideNext:true});
    this.getRandomQuestion();
    //this.setState({hideNext:true});

    this.setState({
      displayCorrectAnswer:false,
      submitButtonDisplay:true,
      tryAgainButtonDisplay:false,
      tryAgainCount:1,
      selectedAnswer:[],
      explanationButtonDisplay: false,
      showRPAnswer:false
     //displayAnswerArr:[],
    })
    */
    this.setState({
      count: this.state.count + 1,
      hideQuestion: false,
      isCheckAnswerPressed: false,
      showAnswerResponse: false,
    })

    this.setState({
      questionAnswerStates: null,
      selectedAnswer: [],
      selectedAnswers: [],
      alreadyPickedAnswer: false,
      showWelcomeBackMsg: false,
    }, () => {
      this.getRandomQuestion();
      this.resetUI();
    })

  }

  onResetToPreviousGNB() {
    console.log("this.state.temp---Resetting GNB to Previous!")
    let gnbsArr = JSON.parse(window.localStorage.getItem("gnbArr"))
    if (gnbsArr === null || gnbsArr === undefined) {
      alert("GNB Arr is null!");
    } else if (gnbsArr.length === 0) {
      alert("GNB Arr is empty!");
    } else if (gnbsArr[this.state.gnbCount] !== null && gnbsArr[this.state.gnbCount] !== undefined) {
      this.handleGetNextBatch(gnbsArr[this.state.gnbCount])
    } else {
      alert("Err in get previous GNB")
    }
  }

  loadStateFromLocalStorage() {
    let data = window.localStorage.getItem("appStates");
    if (data) {
      let appStates = JSON.parse(data)
      if (appStates.length) {
        let lastAppState = appStates[appStates.length - 1]
        this.setState({
          ...lastAppState,
        })
      }

    }
  }

  handleCloseAssignment = () => {
    this.props.handleRoute("/");
  }

  onSaveAndExit() {
    this.setState({
      showSaveAndExit: true,
    })
    // alert("Your Progress is saved. You may resume anytime!");
    /* let tabIndex = 3;
    if (this.state.practiceCount > 0) {
      tabIndex = 4;
    }
    if (this.state.courseID === -1) {
      tabIndex = 5;
    }
    let dashboardURL = `/?quizID=${this.state.quizId}&tab=${tabIndex}&courseID=${this.state.courseID}`
    this.props.handleRoute(dashboardURL); */

    /* if (this.appProperties.isLTIStudent && this.state.courseID !== -1) {
      let performanceURL = `/PerfGraphsV2?tabName=byassignments`
      this.props.handleRoute(performanceURL);
      return
    }

    let sectionID = parseInt(this.params.get("section_id"));

    if (this.state.courseID === -1 && sectionID === -1) {  // Practice set - redirect to mysets
      let performanceURL = `/PerfGraphsV2?tabName=sets&quizID=${this.state.quizId}`
      this.props.handleRoute(performanceURL);
      return;
    }

    if (this.state.practiceCount > 0) { // Practice assignment - redirect to byassignments
      let performanceURL = `/PerfGraphsV2?tabName=byassignments&quizID=${this.state.quizId}`
      this.props.handleRoute(performanceURL);
      return
    }

    // Graded
    let dashboardURL = `/`
    this.props.handleRoute(dashboardURL); */


    /*
    //Masking upload upon Save And Exit
    if(appProperties.enableLTI === true){
      this.setState({pageLoading:true});
      const ltiUserID  = new URLSearchParams(this.props.location.search).get("ltiUserID");
      this.props.apiService({
        method: 'post',
        url: '/lti/uploadScore',
        data: {
          quizID : this.state.quizId,
          courseID: parseInt(this.params.get("course_id")),
          SectionID: parseInt(this.params.get("section_id")),
          userName:ltiUserID
        }
      }).then(res=>{
        this.props.handleRoute('/PerfGraphs');
      }).catch(err=>console.debug(err));
    }else{
      this.props.handleRoute('/PerfGraphs');
    }*/
  }

  onAnswerEntered(value) {
    console.debug("value>>>?? onAnswerEntered", value)

    this.setState({ selectedAnswer: value, showWelcomeBackMsg: false });

    var tempQuestionID = this.state.randomSubCategory + "_" + this.state.randomQuestionID;
    let currentQuestion = this.state.questionMap[tempQuestionID];
    if ((currentQuestion.question_type === 0 && currentQuestion.answer_type === 2) // Standard + Text box
      || (currentQuestion.is_automation && currentQuestion.automation_type === 6) // Exclude AO
    ) {
      this.updateAnswerState({
        unique_id: tempQuestionID,
        subject_id: currentQuestion.subject_id,
        topic_id: currentQuestion.topic_id,
        category_id: currentQuestion.category_id,
        subcategory_id: currentQuestion.subcategory_id,
        question_id: currentQuestion.question_id,
        quiz_id: this.state.quizId,
        section_id: parseInt(this.params.get("section_id")),
        student_answer_string: JSON.stringify(value),
      })
    }
  }

  onAnswerChoiceDetails = (value) => {
    console.debug("value>>>?? onAnswerChoiceDetails", value)
    this.setState({ selectedAnswerDetails: { ...value }, showWelcomeBackMsg: false });

    var tempQuestionID = this.state.randomSubCategory + "_" + this.state.randomQuestionID;
    let currentQuestion = this.state.questionMap[tempQuestionID];

    this.updateAnswerState({
      unique_id: tempQuestionID,
      subject_id: currentQuestion.subject_id,
      topic_id: currentQuestion.topic_id,
      category_id: currentQuestion.category_id,
      subcategory_id: currentQuestion.subcategory_id,
      question_id: currentQuestion.question_id,
      quiz_id: this.state.quizId,
      section_id: parseInt(this.params.get("section_id")),
      student_answer_string: JSON.stringify(value),
    })
  }

  onScientificAnswerEvalMapChange = (question, uniqueID, value) => {
    let newscientificAnswerEvalMap = { ...this.state.scientificAnswerEvalMap };
    newscientificAnswerEvalMap[uniqueID] = value;
    this.setState({
      scientificAnswerEvalMap: newscientificAnswerEvalMap,
    })
  }

  onCompactAnswerClick = (question, questionIndex, value) => {

    let currentQuestion = question;
    let answer_type = currentQuestion.answer_type;

    let newAnswersMap = { ...this.state.answersMap };

    if (currentQuestion && currentQuestion.question_type === 2) {
      answer_type = 0;
    }
    console.debug("questionIndex, value", questionIndex, value, answer_type)
    switch (answer_type) {
      case 0:
      case 2:
      case 30:
      case 50:
      case 70:
      case 90:
      case 3:
        newAnswersMap[questionIndex] = value
        break;
      case 1:
      case 40:
      case 60:
      case 80:
        var tempSelectedAnswerArr = this.state.answersMap[questionIndex];
        if (tempSelectedAnswerArr !== undefined &&
          (tempSelectedAnswerArr.includes(value)) === true) {
          tempSelectedAnswerArr = this.removeElementFromArray(tempSelectedAnswerArr, value);
        }
        else {
          if (tempSelectedAnswerArr === undefined) {
            tempSelectedAnswerArr = [];
          }
          tempSelectedAnswerArr.push(value);
        }

        newAnswersMap[questionIndex] = tempSelectedAnswerArr

        console.log("tempSelectedAnswerArr>>>", tempSelectedAnswerArr, value);

        break;
      default:
        break;
    }
    console.debug("newAnswersMap>>>", newAnswersMap)
    this.setState({ answersMap: newAnswersMap });

    this.saveOnePageTest(question, newAnswersMap);

  }

  onAnswerClick(value, index) {
    let studentAnswer = "";
    // this.setState({
    // feedbackButtonVisible:false});
    //console.log("onAnswerClick ", value)
    //console.log("onAnswerClick ",index)
    var tempQuestionID = this.state.randomSubCategory + "_" + this.state.randomQuestionID;

    let currentQuestion = null;
    let answer_type = null;

    if (this.state.surveyQuestionsRetrieved === true) {
      console.log("surveyQuestionsRetrieved is true");
      console.log("tempQuestionID", tempQuestionID);
      console.log("surveyQuestionMap = ", this.state.surveyQuestionMap[tempQuestionID]);

      currentQuestion = this.state.surveyQuestionMap[tempQuestionID];
      answer_type = currentQuestion.answer_type;
    } else {
      console.log("surveyQuestionsRetrieved is false");
      console.log("tempQuestionID", tempQuestionID);
      currentQuestion = this.state.questionMap[tempQuestionID];
      answer_type = currentQuestion.answer_type;

    }
    console.debug("currentQuestion>>>", currentQuestion)
    if (currentQuestion && currentQuestion.question_type === 2) {
      answer_type = 0;
    }
    switch (answer_type) {
      case 0:
      case 2:
      case 30:
      case 70:
      case 50:
      case 90:
        this.setState({ selectedAnswer: value });
        studentAnswer = value;
        break;
      case 1:
      case 40:
      case 60:
      case 80:
        //checkbox
        var tempSelectedAnswerArr = this.state.selectedAnswer;

        if (tempSelectedAnswerArr !== undefined &&
          (tempSelectedAnswerArr.includes(value)) === true) {
          //Unchecked
          //Remove from selctedAnswer
          tempSelectedAnswerArr = this.removeElementFromArray(tempSelectedAnswerArr, value);

        }
        else {
          //Checked
          //Add to selectedAnswer
          if (tempSelectedAnswerArr === undefined) {
            tempSelectedAnswerArr = [];

          }
          tempSelectedAnswerArr.push(value);
        }

        console.log("tempSelectedAnswerArr", tempSelectedAnswerArr);


        this.setState({ selectedAnswer: tempSelectedAnswerArr });
        studentAnswer = tempSelectedAnswerArr;
        break;
      default:
        break;
    }

    this.setState({
      showWelcomeBackMsg: false,
    })

    if (currentQuestion.question_type === 2) { // MQG
      studentAnswer = Object.fromEntries(Object.entries(studentAnswer))
    }
    console.debug("studentAnswer.>>", studentAnswer)

    this.updateAnswerState({
      unique_id: tempQuestionID,
      subject_id: currentQuestion.subject_id,
      topic_id: currentQuestion.topic_id,
      category_id: currentQuestion.category_id,
      subcategory_id: currentQuestion.subcategory_id,
      question_id: currentQuestion.question_id,
      quiz_id: this.state.quizId,
      section_id: parseInt(this.params.get("section_id")),
      student_answer_string: JSON.stringify(studentAnswer),
    })
  }

  showCorrectAnswer() {
    this.setState({
      feedbackPopupVisible: false,
      //feedbackOn:true,
      feedbackAnswer: null,
      feedbackButtonVisible: false,
      isCheckAnswerPressed: true,
    })
    console.debug("showCorrectAnswer");
    if (this.state.currentQuestionType === 2) {
      this.setState({
        showMQTAnswers: true,
        tryAgainButtonDisplay: false,
        showAnswerResponse: true,
        answerCorrect: true,
        displayCorrectAnswer: false,
        selectedAnswer: []
      });
    } else {



      var tempDisplayAnswerArr = this.state.displayAnswerArr;
      var tempCorrectAnswerMap = this.state.correctAnswerMap[this.state.randomQuestionID];
      var tempRandomSubCategory = this.state.randomSubCategory;
      console.log("tempCorrectAnswerMap = ", tempCorrectAnswerMap);
      console.log("tempDisplayAnswerArr = ", tempDisplayAnswerArr);
      console.log("randomCategory = ", this.state.randomCategory);
      console.log("randomSubCategory = ", this.state.randomSubCategory);
      console.log("this.state.randomQuestionID = ", this.state.randomQuestionID);
      var tempRandomId = tempRandomSubCategory + "_" + this.state.randomQuestionID;
      console.log("this.state.correctAnswerMap = ", this.state.correctAnswerMap[tempRandomId]);

      var correctAnswerArr = this.state.correctAnswerMap[tempRandomSubCategory + "_" + this.state.randomQuestionID];
      var selectedAns = 0
      console.debug("correctAnswerArr ", correctAnswerArr)
      selectedAns = correctAnswerArr
      for (var i = 0; i < tempDisplayAnswerArr?.length; i++) {
        console.log("tempDisplayAnswerArr[i].subject_id", tempDisplayAnswerArr[i].subject_id);
        var tempOID = tempDisplayAnswerArr[i].subject_id + "_" + tempDisplayAnswerArr[i].topic_id + "_" + tempDisplayAnswerArr[i].category_id + "_" + tempDisplayAnswerArr[i].subcategory_id + "_" + this.state.randomQuestionID;
        console.log("tempOID", tempOID);

        if (tempRandomId === tempOID) {
          if (correctAnswerArr !== undefined) {
            for (var j = 0; j < correctAnswerArr.length; j++) {

              if (correctAnswerArr[j] === tempDisplayAnswerArr[i].answer_id) {
                console.log(tempDisplayAnswerArr[i], " ", correctAnswerArr[j], " ", tempDisplayAnswerArr[i].answer_id)

                tempDisplayAnswerArr[i].isChecked = true
              }
            }
          }
          else {

          }


        }
      }
      console.log("tempDisplayAnswerArr", tempDisplayAnswerArr);
      console.log("index in i ", selectedAns);
      this.setState({
        displayAnswerArr: tempDisplayAnswerArr,
        //hideNext:false,
        tryAgainButtonDisplay: false,
        showAnswerResponse: true,
        answerCorrect: true,
        selectedAnswer: [],
      });

      if (this.state.answerType === 3) {
        this.setState({ showRPAnswer: true });
      }
      const { currentQuestionType, answerType, currentVectorVariable, randomSubCategory, randomQuestionID, questionMap } = this.state;
      if (currentQuestionType === 3 && answerType === 2 || (currentQuestionType === 0 && answerType === 90)) {
        const tempQuestionID = randomSubCategory + "_" + randomQuestionID;
        const currentQuestion = questionMap[tempQuestionID];
        const {
          vector_answer_formulas,
          vector_settings_data
        } = currentQuestion;
        let correctAnswerVectors = {};
        if (currentQuestionType === 0 && answerType === 90) {
          let tempVectorVariable = vector_answer_formulas.filter(
            (vector) => !vector?.isStaticVector && !vector?.isIncorrectAnswer
          );
          let vectorVariable = VectorParser.buildQuestionVariablesMap(tempVectorVariable)

          for (let index = 0; index < tempVectorVariable.length; index++) {
            correctAnswerVectors[index] = VectorParser.generateAnswerVector(tempVectorVariable[index], vectorVariable, vector_settings_data);
          };
          const orderVectorArr = VectorParser.getMagnitudeAndSort([...Object.values(correctAnswerVectors)])
          for (let index = 0; index < orderVectorArr.length; index++) {
            correctAnswerVectors[index] = orderVectorArr[index];
          };
          this.setState({ showVectorAnswer: true, correctAnswerVectors: correctAnswerVectors });

        } else {

          for (let index = 0; index < vector_answer_formulas.length; index++) {
            correctAnswerVectors[index] = VectorParser.generateAnswerVector(vector_answer_formulas[index], currentVectorVariable, vector_settings_data);
          };
          const orderVectorArr = VectorParser.getMagnitudeAndSort([...Object.values(correctAnswerVectors)])
          for (let index = 0; index < orderVectorArr.length; index++) {
            correctAnswerVectors[index] = orderVectorArr[index];
          };
          this.setState({ showVectorAnswer: true, correctAnswerVectors: correctAnswerVectors });
        }
      }
    }
    this.findFeedbackText(selectedAns, true);
    this.onFeedbackClick();
    this.getLiveAnalytics();

    this.deleteAllQuestionAnswerState();

  }

  dummyClientLogApiCall() {
    if (this.props.apiService === null || this.props.apiService === undefined) return;
    this.props.apiService({
      method: 'get',
      url: '/whitelist-testapi',
    }).then(res => {
      
    }).catch(err => console.log("errr", err));
  }

  addActivityLog = (logText, payloadData) => {
    if (this.props.apiService === null || this.props.apiService === undefined) return;

    let ids = this.state.randomSubCategory.split("_")

    let payload = {
      quizID: this.state.quizId,
      parent_quiz_id: this.state.parentQuizID,
      subjectID: parseInt(ids[0]),
      topicID: parseInt(ids[1]),
      categoryID: parseInt(ids[2]),
      subcategoryID: parseInt(ids[3]),
      questionID: this.state.randomQuestionID,
      log: logText,
      activityTypeID: 18 // Question Answer
    }
    if (payloadData) {
      payload = {
        ...payloadData,
      };
    }

    console.debug("addActivityLog", payload,);

    let response = this.props.apiService({
      method: "POST",
      url: "/addStudentActivityLog",
      data: payload
    });
    response.then(res => {
      console.debug("res", res)
    }).catch(err => {
      console.debug("err", err)
    })
  }

  getCurrentCategoryName() {
    let categoryName = "";
    if (this.state.categoriesMap && this.state.randomCategory) {
      let category = this.state.categoriesMap[this.state.randomCategory];
      if (category) {
        categoryName = category.categoryLabel != "" ? category.categoryLabel : category.categoryName;
      }
    }

    return categoryName;
  }

  setCategoryGoals() {
    if (this.state.categoriesData) {
      let cat = this.state.categoriesData?.find(cat => {
        let key = `${cat.subject_id}_${cat.topic_id}_${cat.category_id}`;
        if (key === this.state.randomCategory) return cat
      })

      if (cat) {
        
        this.setState({
          categoryAccuracyGoal: cat.accuracyGoal,
          categoryTimeGoal: cat.timeGoal,
          currentAccuracyGoal: cat.currentAccuracyGoal ? cat.currentAccuracyGoal : 0,
          currentTimeGoal: cat.currentTimeGoal ? cat.currentTimeGoal : 0,
        })
      }

      // console.debug("this.state.categoriesData", this.state.categoriesData, this.state.randomCategory, cat);
    }
  }

  handleHideNavAndCat = () => {
    this.setState({
      hideNavAndCat: !this.state.hideNavAndCat
    })
  }

  handleHideQuestion = () => {
    this.setState({
      hideQuestion: !this.state.hideQuestion
    })
  }

  hasValidValue = (data, question) => {
    if (data === null || data === undefined) {
      return false;
    }

    let { question_type, answer_type } = question;
    if (question_type === 2) {
      return this.checkIfMQTAnswersSelectedForQuestion(question, data);
    }

    const jsonString = JSON.stringify(data);

    return jsonString !== '""' && jsonString !== '{}' && jsonString !== '[]';
  };

  handleBookmarkClick = (uniqueID, question) => {
    let newBookmarkQuestionIDMap = this.state.bookmarkQuestionIDMap;
    if (uniqueID in newBookmarkQuestionIDMap) {
      delete newBookmarkQuestionIDMap[uniqueID]
    } else {
      newBookmarkQuestionIDMap[uniqueID] = "";
    }
    
    this.setState({
      bookmarkQuestionIDMap: newBookmarkQuestionIDMap,
    })

    // update the db
    this.updateAnswerState({
      unique_id: uniqueID,
      subject_id: question.subject_id,
      topic_id: question.topic_id,
      category_id: question.category_id,
      subcategory_id: question.subcategory_id,
      question_id: question.question_id,
      quiz_id: this.state.quizId,
      update_bookmark: true,
      bookmarked: uniqueID in newBookmarkQuestionIDMap,
    })

  }

  fetchRemainingOnePageTestQuestions = () => {
    /* const ltiUserID = this.params.get("ltiUserID");
    const payload = {
      quiz_id: this.state.quizId,
      user_id: this.state.userId,//"test123",
      quiz_name: this.state.quizName, //"test 123"
      quiz_attempt: this.state.quizAttempt,
      course_id: parseInt(this.params.get("course_id")),
      section_id: parseInt(this.params.get("section_id")),
      ltiUserID: ltiUserID ? ltiUserID : ""
    } */
    this.onStartClick(false);
  }

  getButton = () => {
    const totalQuestions = this.state.totalQuestions || 0;
    const fetchedQuestionsCount = this.state.mainQAArray ? this.state.mainQAArray.length : 0;
    const remainingQuestionsCount = totalQuestions - fetchedQuestionsCount;

    if (remainingQuestionsCount && this.state.mainQAArray.length) {
      let text = `Fetch Remaining ${remainingQuestionsCount} Question${remainingQuestionsCount > 1 ? 's' : ''}`;
      if (remainingQuestionsCount > 20) {
        text = `Fetch Next 20 Questions`;
      }
      return (
        <Button variant='contained' onClick={this.fetchRemainingOnePageTestQuestions}>
          {text}
        </Button>
      );
    }

    return null;
  }

  getOnePageTestCompletedQuestionCount = () => {
    let count = 0;
    this.state.mainQAArray?.map((mainQA, index) => {
      let question = mainQA.question;
      let answered = this.state.answersMap && this.hasValidValue(this.state.answersMap[mainQA.uniqueID], question);
      if (answered) {
        count += 1;
      }
    });
    return count;
  }

  getMinutesLeftWithSecondsStr = (totalTime, elapsedTime) => {
    let totalTimeSeconds = (totalTime * 60);
    let timeLeft = totalTimeSeconds - elapsedTime;
    let minutesLeft = Math.trunc(timeLeft / 60);
    let secondsLeft = (timeLeft % 60);
    let formattedSeconds = secondsLeft < 10 ? "0" + secondsLeft : secondsLeft;

    return `${minutesLeft}:${formattedSeconds}`
  }

  getCompletedCategoryCount = () => {
    let count = 0;
    this.state.categoryForWheel.forEach((categorySetId, catIdIndex) => {
      const score = Math.round(this.state.categoriesMap[categorySetId].score / ((this.state.categoryMasteryCount[categorySetId] !== undefined &&
        this.state.categoryMasteryCount[categorySetId] !== null && this.state.categoryMasteryCount[categorySetId] !== 0) ?
        this.state.categoryMasteryCount[categorySetId]
        : this.state.masteryCount) * 100)

      if (score >= 100) {
        count += 1;
      }
    })

    return count;
  }

  handlePauseCategory = (categoryKey) => {

    let pausedCategoriesMap = { ...this.state.pausedCategoriesMap };
    let totalCategoryCount = this.state.categoryForWheel.length;

    let ids;
    if (categoryKey) {
      pausedCategoriesMap[categoryKey] = {};
      ids = categoryKey.split("_");
    } else {
      pausedCategoriesMap[this.state.randomCategory] = {};
      ids = this.state.randomCategory.split("_");
    }

    let pausedCategorCount = Object.keys(pausedCategoriesMap).length;
    let completedCategoryCount = this.getCompletedCategoryCount();

    if (pausedCategorCount >= (totalCategoryCount - completedCategoryCount)) {
      NotificationManager.warning("Atleast one category needs to be shown", "", 3000);
      return;
    }

    let jsonString = JSON.stringify(pausedCategoriesMap);
    this.addPausedCategories(jsonString);

    let payload = {
      quizID: this.state.quizId,
      subjectID: parseInt(ids[0]),
      topicID: parseInt(ids[1]),
      categoryID: parseInt(ids[2]),
      questionID: this.state.randomQuestionID,
      log: "",
      toNomenclatureID: 10, // Pause category
      activityTypeID: 27 // Assignment
    }
    this.addActivityLog("", payload)

    NotificationManager.success("Category has been paused", "", 1000);

    this.setState({
      pausedCategoriesMap,
      questionAnswerStates: null,
      selectedAnswer: [],
      selectedAnswers: [],
      alreadyPickedAnswer: false,
      showWelcomeBackMsg: false,
      showSubmitLoader: false,
    }, () => {
      if (categoryKey === null || categoryKey === this.state.randomCategory) {
        this.getRandomQuestion();
      }
    })

  }

  handleResumeCategory = (categoryKey) => {
    let pausedCategoriesMap = { ...this.state.pausedCategoriesMap };
    delete pausedCategoriesMap[categoryKey]
    this.setState({
      pausedCategoriesMap,
    })

    let jsonString = JSON.stringify(pausedCategoriesMap);
    this.addPausedCategories(jsonString)
    let ids = categoryKey.split("_");
    let payload = {
      quizID: this.state.quizId,
      subjectID: parseInt(ids[0]),
      topicID: parseInt(ids[1]),
      categoryID: parseInt(ids[2]),
      questionID: this.state.randomQuestionID,
      log: "",
      toNomenclatureID: 11, // Pause category
      activityTypeID: 27 // Assignment
    }
    this.addActivityLog("", payload)

    NotificationManager.success("Category has been resumed.", "", 5000);
  }

  showPauseBtn = (catKey) => {
    const { allowPauseCategory, categoryPositionMap } = this.state;

    if (!allowPauseCategory) return false;
    if (!categoryPositionMap || !catKey) return false;

    const category = categoryPositionMap[catKey];
    if (!category) return false;

    return category.category_at_begining === 0 && category.category_at_last === 0;
  };

  render() {
    
    //Show Splash Screen

    console.debug("this.state.currentQuestionObj>>??", this.state.currentQuestionObj)
    const embeddedTutorial = this.isEmbeddedTutorial();

    if (this.state.pageLoading || this.state.onePageTestLoading) {
      // if (true) {
      return (
        <div className="d-flex flex-column justify-content-center align-items-center w-100 h-100">
          <BeatLoader color={'#bb0000'} loading={true} size={15} />
          {this.state.gnbLoading ?
            <Typography fontSize={14} color={"#333"} className='mt-2'>
              Fetching Questions
            </Typography>
            : null}
        </div>
      );
    }
    if (this.state.showSplashScreen) {
      var splashScreenData = "";
      if (this.state.splashScreen !== "") {
        splashScreenData = this.state.splashScreen;
      } else {
        splashScreenData = this.state.quizBundle.splashScreen;
      }
      return <SFSplashScreen
        onShowCategorySelection={this.onShowCategorySelection}
        title={this.state.quizName}
        splashText={splashScreenData}
        quizWindowEnded={this.state.quizWindowEnded}
        invalidQuiz={this.state.invalidQuiz}
        quizNotPublished={this.state.quizNotPublished}
        carmenAssignmentLink={this.state.carmenAssignmentLink}
        testWindowEnded={this.state.testWindowEnded}
        isTimerExpired={this.state.timerExpired}
        hasCompleted={this.state.hasCompleted}
        isTest={this.state.isTest}
        isLockedOut={this.state.isLockedOut}
        history={this.props.history}
        allowPractice={this.state.allowPractice}
        isMobile={isMobile}
        quizID={this.state.quizId}
        courseName={this.state.courseName}
        {...this.props}
        startDate={this.state.startDate}
        dueDate={this.state.dueDate}
        timeZone={this.state.timeZone}
        practiceCount={this.state.practiceCount}
        ltiUserID={this.params.get("ltiUserID")}
        ltiPracticeMessage={this.state.ltiPracticeMessage}
        isTutorial={this.state.isTutorial}
        parentQuizID={this.state.parentQuizID}
        tutorialReadOnly={this.state.tutorialReadOnly}
      >
      </SFSplashScreen>
    }

    if (this.state.showCategorySelectionPage && this.state.showFreeChoice) {
      return <FreeChoiceCategorySelectionPage
        quizName={this.state.quizName}
        practiceCount={this.state.practiceCount}
        onStartClick={this.onStartClick}
        // title = {this.state.quizName} 
        quizWindowEnded={this.state.quizWindowEnded}
        isTimerExpired={this.state.timerExpired}
        hasCompleted={this.state.hasCompleted}
        isTest={this.state.isTest}
        history={this.props.history}
        categoryIsRequired={this.state.categoryIsRequired}
        onStartQuiz={this.onStartQuiz}
        //showCategorySelectionPage= {this.state.showCategorySelectionPage}
        freeChoiceCount={this.state.freeChoiceCount}
        onSaveAndExit={this.onSaveAndExit}
        courseID={this.state.courseID}
        isMobile={isMobile}
        quizID={this.state.quizId}
        isTutorial={this.state.isTutorial}
        parentQuizID={this.state.parentQuizID}
      //categoriesMap = {this.state.categoriesMap}
      >
      </FreeChoiceCategorySelectionPage>
    }


    return (

      <div
        className='sf-takequiz-container position-relative'
        style={{
          top: this.state.hideNavAndCat ? '10px' : "78px",
          bottom: this.state.hideNavAndCat ? '10px' : "60px",
          // height: this.state.hideNavAndCat ? '100%' : 'calc(100% - 130px)'
          height: this.state.isTest && this.state.onePageMode ? 'fit-content' : (this.state.hideNavAndCat ? '100%' : 'calc(100% - 130px)'),
          backgroundColor: "#fff !important"
        }}
      >
        <Dialog open={this.state.showSaveAndExit}>
          <DialogTitle>
            <center>
              Are you sure you want to exit?
            </center>
          </DialogTitle>
          <div className='my-2 mb-4 d-flex justify-content-center align-items-center' style={{
            gap: '12px'
          }}>
            <Button color='primary' variant='contained' onClick={this.handleCloseAssignment}>Yes</Button>
            <Button color='primary' variant='outlined'
              onClick={() => {
                this.setState({
                  showSaveAndExit: false,
                }, () => {
                  const exitBtn = document.getElementById("save-and-exit-button") || document.getElementById("save-and-exit-button-mobile");
                  if (exitBtn) {
                    exitBtn.focus();
                  }
                })
              }}
            >No</Button>
          </div>
        </Dialog>
        <span style={{
          display: this.state.hideNavAndCat ? 'none' : 'block',
        }}>
          <SFTakequizNavbar
            isAnonymous={this.state.isAnonymous}
            onShowCategorySelection={this.onShowCategorySelection}
            courseName={this.state.courseName}
            {...this.props}
            showFreeChoice={this.state.showFreeChoice}
            currentQuestionType={this.state.currentQuestionType}
            onSaveAndExit={this.onSaveAndExit}
            practiceCount={this.state.practiceCount}
            onePageMode={this.state.onePageMode}
            onePageTestSaving={this.state.onePageTestSaving}
            lastSavedAt={this.state.lastSavedAt}
            showCalculator={this.state.showCalculator}
            isTutorial={this.state.isTutorial}
          />
        </span>

        <span style={{
          display: this.state.hideNavAndCat ? 'none' : 'inline',
        }}>

          {this.state.isTest ? (this.state.onePageMode ? null : <TestProgress
            totalTime={this.state.totalTime}
            elapsedTime={this.state.elapsedTime}
            totalQuestions={this.state.totalQuestions}
            completedQuestions={this.state.questionsAttended}
            showTimer={this.state.isTimerEnabled}
          />) :
            <div className='justify-content-start  sf-category-progress-container' style={{ gap: '1rem' }}>
              {this.state.categoryForWheel.map((categorySetId, catIdIndex) => {
                // console.log("this.state.categoriesMap.score =", this.state.categoriesMap[categorySetId])
                let score = Math.round(this.state.categoriesMap[categorySetId].score / ((this.state.categoryMasteryCount[categorySetId] !== undefined &&
                  this.state.categoryMasteryCount[categorySetId] !== null && this.state.categoryMasteryCount[categorySetId] !== 0) ?
                  this.state.categoryMasteryCount[categorySetId]
                  : this.state.masteryCount) * 100)

                const title = this.state.categoriesMap[categorySetId].categoryLabel != "" ? this.state.categoriesMap[categorySetId].categoryLabel : this.state.categoriesMap[categorySetId].categoryName;

                if (score > 100) {
                  score = 100;
                }
                

                let isPaused = false;
                if (categorySetId in this.state.pausedCategoriesMap) {
                  isPaused = true;
                }

                return <SFCategoryProgressCard
                  allowPauseCategory={this.showPauseBtn(categorySetId)}
                  isPaused={isPaused}
                  categoryKey={categorySetId}
                  handleResumeCategory={this.handleResumeCategory}
                  handlePauseCategory={this.handlePauseCategory}
                  isCurrent={this.state.randomCategory === categorySetId} score={score} title={title} isMobile={isMobile} />
              })}
            </div>}
        </span>

        <div className='sf-main-container'
          style={{
            height: this.state.isTest && this.state.onePageMode ? '100%' : (this.state.hideNavAndCat ? 'calc(100% - 80px)' : isMobile ? "fit-content" : 'calc(100% - 78px - 40px)'),
          }}>
          <div className='sf-qa-container h-100'
            style={{
              width: this.state.isTest || this.state.isTutorial ? '100%' : 'calc(100% - 220px)'
            }}

          >
            {this.state.isTest && this.state.onePageMode ?
              <div className='w-100 d-flex px-2 sticky-question-container-parent'>
                <nav className='mob-sticky-question-container' aria-label='Question list'>
                  <div className='mob-sticky-question-list'>
                    {this.state.mainQAArray?.map((mainQA, index) => {
                      let bookmarked = mainQA.uniqueID in this.state.bookmarkQuestionIDMap;
                      let question = mainQA.question;
                      let answered = this.state.answersMap && this.hasValidValue(this.state.answersMap[mainQA.uniqueID], question)
                      return (
                        <button
                          type='button'
                          className={`mob-sticky-question ${answered ? 'mob-sticky-question-answered' : ''}`}
                          key={index}
                          aria-label={`Question ${index + 1}, ${answered ? 'answered' : 'not answered'}${bookmarked ? ', bookmarked' : ''}. Go to question.`}
                          onClick={() => this.navigateToOnePageQuestion(mainQA.uniqueID)}
                        >
                          <div className='mob-sticky-question-left'>
                            <div className='mob-sticky-question-bookmark'>
                              {bookmarked ? <FaBookmark aria-hidden='true' fontSize={16} className='mr-2' color='#ebc351' /> :
                                <FaBookmark aria-hidden='true' opacity={0} fontSize={16} className='mr-2' color='#ebc351' />}
                            </div>
                            <div>Q{index + 1}</div>
                          </div>
                        </button>
                      )
                    })}
                    {/* Fetch remaining questions */}
                    {/* {this.getButton()} */}
                  </div>
                </nav>
                <nav className='sticky-question-container' aria-labelledby='one-page-question-list-heading'>
                  <div className='sticky-question-header ml-2'>
                    <Typography component='h2' id='one-page-question-list-heading' fontSize={16} fontWeight={'bold'}>
                      Questions List (#{this.state.totalQuestions})
                    </Typography>
                    {this.state.isTimerEnabled ?
                      <Typography fontSize={14} color='primary'>Test closes in <strong>{this.getMinutesLeftWithSecondsStr(this.state.totalTime, this.state.elapsedTime)}</strong> minutes</Typography>
                      : null}
                  </div>

                  <div className='sticky-question-list'>
                    {this.state.mainQAArray?.map((mainQA, index) => {
                      let bookmarked = mainQA.uniqueID in this.state.bookmarkQuestionIDMap;
                      let question = mainQA.question;
                      let answered = this.state.answersMap && this.hasValidValue(this.state.answersMap[mainQA.uniqueID], question)
                      return (
                        <button
                          type='button'
                          className='sticky-question'
                          style={{
                          fontWeight: answered || bookmarked ? 'bold' : 'normal',
                          color: answered ? '#bb0000' : ""
                          }}
                          key={index}
                          aria-label={`Question ${index + 1}, ${answered ? 'answered' : 'not answered'}${bookmarked ? ', bookmarked' : ''}. Go to question.`}
                          onClick={() => this.navigateToOnePageQuestion(mainQA.uniqueID)}
                        >
                          <div className='sticky-question-left'>
                            {bookmarked ? <FaBookmark aria-hidden='true' fontSize={16} className='mr-2' color='#ebc351' /> :
                              <FaBookmark aria-hidden='true' opacity={0} fontSize={16} className='mr-2' color='#ebc351' />}
                            <div>Question {index + 1}</div>
                          </div>
                          <div className='sticky-question-middle'></div>
                          <div className='sticky-question-right'>
                            {answered ?
                              <FaRegCircleCheck aria-hidden='true' fontSize={18} color='#4CB332' />
                              :
                              <AiOutlineQuestionCircle aria-hidden='true' fontSize={18} color='#929292' />
                            }
                          </div>
                        </button>
                      )
                    })}
                    {/* Fetch remaining questions */}
                    {/* {this.getButton()} */}
                  </div>
                </nav>
                <div className='one-page-question-container'>
                  <section className='one-page-mode-splash-text mt-4' aria-labelledby='one-page-test-instructions-heading'>
                    <Typography component='h2' id='one-page-test-instructions-heading' variant='h6'>
                      Instructions
                    </Typography>
                    <div className='' dangerouslySetInnerHTML={{ __html: this.state.splashScreen }} />
                    <div className='one-page-mode-splash-text-border'></div>
                  </section>
                  {/* {this.state.mainQAArray.map((mainQA, mainQAIndex) => {
                    console.debug("mainQA>>>>")
                    return (
                      <div className='position-relative single-qa-container' key={mainQA.uniqueID}>
                          <Bookmark 
                            handleBookmarkClick={() => {
                              this.handleBookmarkClick(mainQA.uniqueID);
                            }}
                          />
                          <SFQuestionAndAnswer
                        questionNo={mainQAIndex + 1}
                        compact={true}
                        uniqueID={mainQA.uniqueID}
                        questionText={mainQA.questionText}
                        currentQuestionType={mainQA.questionType}
                        answerType={mainQA.answerType}
                        count={mainQA.uniqueID}
                        isCurrentQuestionNonGraded={mainQA.isCurrentQuestionNonGraded}
                        handleHideNavAndCat={() => {}}
                        hideNavAndCat={false}
                        hideQuestion={false}
                        handleHideQuestion={() => {}}
                        showSubmitLoader={false}
                        addActivityLog={() => {}}
                        forceUpdateHandler={false} // since there's no "Try Again" button, we make it false always
                        isMobile={isMobile}
                        reasoningElements={mainQA.reasoningElements}
                        connectingWords={mainQA.connectingWords}
                        conclusionSentences={mainQA.conclusionSentences}
                        showReasoningElementCategoryInfo={mainQA.showReasoningElementCategoryInfo}
                        answerDisplayStyle={mainQA.answerDisplayStyle}
                        onAnswerClick={(val, index) => {
                          console.debug("val, index>>", val, index)
                          //this.onAnswerClick
                          this.onCompactAnswerClick(mainQA.question, mainQA.uniqueID, val);
                        }}
                        displayAnswerArr={mainQA.answerDataArr}
                        showRPAnswer={false}
                        showAnswerResponse={false}
                        answerCorrect={false}
                        displayCorrectAnswer={false}
                        currentVariableMap={mainQA.currentVariableMap}
                        questionID={mainQA.questionID}
                        showVectorAnswer={false}
                        answer_formula={mainQA.answerFormula}
                        showMQTAnswers={false}
                        onAnswerEntered={(val) => {
                          console.debug("val>>>", val)
                          this.onCompactAnswerClick(mainQA.question, mainQA.uniqueID, val);
                        }}
                        mqt_options={mainQA.mqtOptions}
                        currentVectorVariable={mainQA.tempVectorsVarMap}
                        currentVectorSettings={mainQA.vectorSettingsData}
                        vectorAnswerFormulas={mainQA.vectorAnswerFormulas}
                        selectedAnswers={
                          //this.state.answersMap && this.state.answersMap[mainQA.uniqueID] ? this.state.answersMap[mainQA.uniqueID] : []
                          []
                        }
                        handleBookmarkClick={() => {
                          this.handleBookmarkClick(mainQA.uniqueID);
                        }}
                        correctAnswerVectors={null}
                        onSubmit={() => {}}

                        onAnswerChoiceDetails={(val) => {
                          console.debug("val>>>", val)

                          this.onCompactAnswerClick(mainQA.question, mainQA.questionIndex, val);
                        }}
                        freeFormVectorOptions={this.state.freeFormVectorOptions}
                        vectorBelowQuestionText={this.state.vectorBelowQuestionText}
                      />
                      </div>
                    )
                  })} */}
                  <SFOnePageTest
                    mainQAArray={this.state.mainQAArray}
                    onCompactAnswerClick={this.onCompactAnswerClick}
                    onScientificAnswerEvalMapChange={this.onScientificAnswerEvalMapChange}
                    handleBookmarkClick={this.handleBookmarkClick}
                    questionAnswerStates={this.state.questionAnswerStates}
                  />
                </div>
              </div>
              : 
              <React.Fragment>
                {this.state.currentQuestionObj && this.state.currentQuestionObj?.sub_questions && this.state.currentQuestionObj?.sub_questions.length ? 
                  <SFSingleQuestionAnswerView
                    quizID={this.state.quizId}
                    sectionID={parseInt(this.params.get("section_id"))}
                    courseID={this.state.courseID}
                    currentQuestion={this.state.currentQuestionObj}
                    overAllQuestionCount={this.state.totalQuestions}
                    questionFocusId={embeddedTutorial ? "embedded-tutorial-question" : undefined}
                    onSaveSubQuestionsComplete={(parentQuestionResult) => {

                      if (parentQuestionResult.ques_att !== undefined && parentQuestionResult.ques_att !== null) {
                        if (parentQuestionResult.ques_att === this.state.totalQuestions) {
                          this.finish();
                        } else {
                          this.setState({
                            questionAnswerStates: [],
                          }, () => {
                            this.setState({
                              submitButtonDisplay: true,
                              questionsAttended: parentQuestionResult.ques_att
                            })
                            this.getRandomQuestion();
                          })
                        }

                      }

                    }}
                  />
                : 
              <SFQuestionAndAnswer
                compact={false}
                questionText={this.state.displayQuestionText}
                questionContentId={embeddedTutorial ? "embedded-tutorial-question-content" : undefined}
                imageCaption=""
                onStartClick={this.onStartClick}
                title="questiontext"
                splashText={this.state.quizBundle.splashScreen}
                questionImage={questionImage}
                onAnswerEntered={this.onAnswerEntered}
                answerCorrect={this.state.answerCorrect}
                showAnswerResponse={this.state.showAnswerResponse}
                displayAnswerArr={this.state.displayAnswerArr}
                answerType={this.state.answerType}
                onAnswerClick={this.onAnswerClick}
                forceUpdateHandler={this.state.forceUpdateHandler}
                selectedAnswers={this.state.selectedAnswer}
                answerDisplayStyle={this.state.answerDisplayStyle}
                displayCorrectAnswer={this.state.displayCorrectAnswer}
                currentQuestionType={this.state.currentQuestionType}
                currentVariableMap={this.state.currentVariableMap}
                mqt_options={this.state.mqt_options}
                questionID={this.state.randomSubCategory + "_" + this.state.randomQuestionID}
                showMQTAnswers={this.state.showMQTAnswers}
                answer_formula={this.state.answer_formula}
                showRPAnswer={this.state.showRPAnswer}
                showVectorAnswer={this.state.showVectorAnswer}
                correctAnswerVectors={this.state.correctAnswerVectors}
                onSubmit={this.onSubmitClick}
                onAnswerChoiceDetails={this.onAnswerChoiceDetails}
                currentVectorVariable={this.state.currentVectorVariable}
                currentVectorSettings={this.state.currentVectorSettings}
                vectorAnswerFormulas={this.state.vectorAnswerFormulas}
                isMobile={isMobile}
                freeFormVectorOptions={this.state.freeFormVectorOptions}
                vectorBelowQuestionText={this.state.vectorBelowQuestionText}
                isCurrentQuestionNonGraded={this.state.isCurrentQuestionNonGraded}
                reasoningElements={this.state.reasoningElements}
                connectingWords={this.state.connectingWords}
                conclusionSentences={this.state.conclusionSentences}
                count={this.state.count}
                showReasoningElementCategoryInfo={this.state.showReasoningElementCategoryInfo}
                addActivityLog={this.addActivityLog}
                handleHideNavAndCat={this.handleHideNavAndCat}
                hideNavAndCat={this.state.hideNavAndCat}
                hideQuestion={this.state.hideQuestion}
                handleHideQuestion={this.handleHideQuestion}
                showSubmitLoader={this.state.showSubmitLoader}
                question_attempt={this.state.question_attempt}
                addSingleQuestionAnswerState={(payload) => {
                  // console.debug("this.state.randomQuestion>>>", this.state.currentQuestionObj, payload)
                  if (this.state.currentQuestionObj) {
                    this.addSingleQuestionAnswerState(payload, this.state.currentQuestionObj)
                  }
                }}
                alreadyPickedAnswer={this.state.alreadyPickedAnswer}
                showWelcomeBackMsg={this.state.showWelcomeBackMsg}
                currentQuestionObj={this.state.currentQuestionObj}
              />
              }
              </React.Fragment>
              }
          </div>

          <div 
            tabIndex={0}
            aria-label={`Right panel stats for ${this.getCurrentCategoryName()}`}
            style={{ width: '200px', display: this.state.isTest === 1 || this.state.isTutorial ? 'none' : 'block' }} 
            className='sf-assign-progress'
          >
            <div style={{ width: 'fit-content' }}>
              <div className='d-flex'>
                <Typography fontWeight={'bold'} fontSize={16}>{this.getCurrentCategoryName()}</Typography>
                <SFInfoIcon helpText={`Each row is a category mastery attempt.\nEach dot is a question attempt.\nTo complete a category, a row must be all green dots.\n\nIf you get one red dot (incorrect), you move to the next row and you start again.`} />
              </div>
              <SFDotsProgress
                randomQuestionID={this.state.randomQuestionID}
                questionArr={this.state.questionArr}
                defaultMasteryCount={this.state.masteryCount}
                dotProgressMap={this.state.dotProgressMap}
                randomCategory={this.state.randomCategory}
                categoryMasteryCount={this.state.categoryMasteryCount}
              />
              {this.showPauseBtn(this.state.randomCategory) ? (
                <SFPauseCategory
                  pausedCategoriesMap={this.state.pausedCategoriesMap}
                  currentCategoryKey={this.state.randomCategory}
                  handlePauseCategory={this.handlePauseCategory}
                  handleResumeCategory={this.handleResumeCategory}
                  completedCategoryArray={this.state.completedCategoryArray}
                  categoryPositionMap={this.state.categoryPositionMap}
                />
              ) : null}
              {/* <div className='d-flex justify-content-center flex-column my-3'>
                <div className='d-flex justify-content-start w-100 mb-2' style={{ gap: '6px' }}>
                  <div className='sf-circle'></div>
                  <div className='sf-circle'></div>
                  <div className='sf-circle'></div>
                  <div className='sf-circle bg-danger'></div>
                  <div className='sf-circle bg-secondary'></div>
                  <div className='sf-circle bg-secondary'></div>
                </div>
                <div className='d-flex justify-content-start w-100 mb-2' style={{ gap: '6px' }}>
                  <div className='sf-circle bg-secondary'></div>
                  <div className='sf-circle bg-secondary'></div>
                  <div className='sf-circle bg-secondary'></div>
                  <div className='sf-circle bg-secondary'></div>
                  <div className='sf-circle bg-secondary'></div>
                  <div className='sf-circle bg-secondary'></div>
                </div>
              </div> */}

              {/* Some nice message */}
              {/* <div className='mb-2'>One step closer, keep it up!</div> */}

              {/* End category button */}
              {/* <Button variant='outlined' size='small'>End Category</Button> */}

              {/* Accuracy and Time Bar graph/slider */}
              {/* {this.state.categoryTimeGoal}: {this.state.currentTimeGoal} */}
              <div style={{
                borderRadius: '6px', border: '1.5px solid #9F9F9F', width: '100%',
                display: this.state.practiceCount > 0 && this.state.isTest === 0 ? 'block' : 'none'
              }} className='mt-3 '>
                <div style={{ width: 'fit-content', float: 'right' }}><SFInfoIcon helpText={`Progress on accuracy and time.\nTo change the goals, exit the assignment then click on "Resume Practice" for this assignment and then click "Set Goals" before starting assignment again.`} /></div>
                <div className='d-flex justify-content-center p-4' style={{ gap: '4rem' }}>
                  <div className='d-flex justify-content-center flex-column align-items-center' style={{ gap: '4px' }}>
                    {this.state.currentAccuracyGoal >= this.state.categoryAccuracyGoal ?
                      <Tooltip placement="top" arrow title="Accuracy goal acheived">
                        <div>
                          <FaCheckCircle color='#80c75b' fontSize={24} />
                        </div>
                      </Tooltip>

                      :
                      <FaCheckCircle opacity={0} color='#80c75b' fontSize={24} />
                    }
                    <VerticalProgress type="accuracy" goal={this.state.categoryAccuracyGoal} currentGoal={this.state.currentAccuracyGoal} />

                    <Tooltip placement="top" arrow title="Accuracy tooltip">
                      <div>
                        <TbTargetArrow fontSize={24} />
                      </div>
                    </Tooltip>

                  </div>
                  <div className='d-flex justify-content-center flex-column align-items-center' style={{ gap: '4px' }}>
                    {(this.state.currentTimeGoal !== 0 && this.state.currentTimeGoal / 60 <= (this.state.categoryTimeGoal)) ?
                      <Tooltip placement="top" arrow title="Time goal acheived">
                        <div>
                          <FaCheckCircle color='#80c75b' fontSize={24} />
                        </div>
                      </Tooltip>
                      :
                      <FaCheckCircle opacity={0} color='#80c75b' fontSize={24} />
                    }
                    <VerticalProgress type="time" goal={this.state.categoryTimeGoal * 10} currentGoal={+parseFloat(this.state.currentTimeGoal / 60).toFixed(1)} />
                    <Tooltip placement="top" arrow title="Time tooltip">
                      <div>
                        <TbClockHour5 fontSize={24} />
                      </div>
                    </Tooltip>

                  </div>
                </div>

                <div className='d-flex flex-column justify-content-start align-items-start px-2 pb-2' style={{ gap: '8px' }}>
                  {/* <div className='d-flex justify-content-start' style={{ gap: '8px' }}>
                    <FiTarget fontSize={16} />
                    <Typography fontSize={12}>Accuracy %</Typography>
                  </div>
                  <div className='d-flex justify-content-start' style={{ gap: '8px' }}>
                    <FaRegClock fontSize={16} style={{ width: '16px' }} />
                    <Typography fontSize={12}>Time Taken (min)</Typography>
                  </div> */}
                  <div className='d-flex justify-content-start' style={{ gap: '8px' }}>
                    <div><span className='sf-rect-box' style={{ width: '16px' }}></span></div>
                    <Typography fontSize={12}>Current Progress</Typography>
                  </div>
                  <div className='d-flex justify-content-start' style={{ gap: '8px' }}>
                    <div><span className='sf-rect-rounded-box' style={{ width: '16px' }}></span></div>
                    <Typography fontSize={12}>Goal for this category</Typography>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* {this.state.explanationGalleryVisible === true ?

          <ExplanationGallery
            closeClick={this.onExplanationClick}
            elapsedTime={this.saveElapsedTimeForExplanations}
            apiService={this.props.apiService}
            visibility={this.state.explanationGalleryVisible}
            explanations={this.state.explanations}
            tutorialKey={this.state.randomCategory}
          />
          : ''
        } */}

        {this.state.explanationGalleryVisible ? 
          <ExplanationAndTutorials
              quizID={this.state.quizId}
              subcategoryKey={this.state.randomSubCategory}
              explanations={this.state.explanations}
              tutorials={this.state.subcategoryTutorialMap[this.state.randomSubCategory] || []}
              handleClose={() => this.setState({
                explanationGalleryVisible: false,
              })}
          />
        : null}

       {/*  {this.state.showTutorials ? 
          <SFTakeTutorials 
            tutorialKey={this.state.randomCategory}
            explanations={this.state.explanations}
            handleClose={this.handleCloseTutorials}
          />
        : null} */}


        <SFFeedbackPopup
          closeClick={this.onFeedbackCloseClick}
          visibility={this.state.feedbackPopupVisible}
          feedback={this.state.feedbackAnswer}
        />

        <SFAssignmentCompletion isCompleted={false} {...this.props} />

        {/* One Page Test Mode Footer */}
        {this.state.isTest && this.state.onePageMode ?
          <div className='one-page-mode-footer'>
            <Button variant='contained'
              onClick={() => {
                this.onSubmitOnePageTest()
              }}
            >Submit Assignment</Button>
          </div>
          : null}


        {/* Fixed Footer Actions */}
        {this.state.currentQuestionObj && this.state.currentQuestionObj?.sub_questions && this.state.currentQuestionObj?.sub_questions.length ? null : 
        <Card style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          // height: '56px',
          padding: '8px 25px',
          width: '100%',
          zIndex: 4,
          overflowX: 'auto',
          display: this.state.isTest && this.state.onePageMode ? 'none' : 'block'
        }}
          // hidden={this.state.showSubmitLoader}
          sx={{ boxShadow: 10 }}
        >

          <div className='d-flex justify-content-center h-100 align-items-center w-100 px-4' style={{ gap: '1rem', flexWrap: 'nowrap', minWidth: 'fit-content', paddingRight: "5px" }}>
            {this.state.isCheckAnswerPressed || this.state.showSubmitLoader ? "" :
              <div style={{ flex: '0 0 auto' }}>
                {!this.state.isCurrentQuestionNonGraded && this.state.showAnswerResponse ?
                  <div className='answer-feedback' style={{ marginLeft: isMobile ? '20px' : '0px' }} >
                    {this.state.answerCorrect ?
                      <div className='d-flex justify-content-start align-items-center' style={{ gap: "4px", color: '#80c75b' }}>
                        <FaRegCircleCheck fontSize={24} />
                        <div style={{ fontWeight: 'bolder', fontSize: '22px', letterSpacing: '0.5px' }}>Correct</div>
                      </div>
                      :
                      <div className='d-flex justify-content-start align-items-center' style={{ gap: "4px", color: '#BA0C2F' }}>
                        <CgCloseO fontSize={24} />
                        <div style={{ fontWeight: 'bolder', fontSize: '22px', letterSpacing: '0.5px' }}>Incorrect</div>
                      </div>
                    }
                  </div>
                  : null}
              </div>
            }

            {this.state.showSubmitLoader ? "" :
              <Button variant='outlined' size={isMobile ? 'small' : 'medium'} style={{ flex: '0 0 auto' }} hidden={!this.state.hideQuestion} onClick={this.handleHideQuestion}>Show Question</Button>
            }

            {this.state.showSubmitLoader ? "" :
              <Button size={isMobile ? 'small' : 'medium'} style={{ flex: '0 0 auto' }} variant='outlined' hidden={!this.state.tryAgainButtonDisplay} onClick={this.onPrevClick}>Try Again</Button>
            }

            {this.state.showSubmitLoader ? "" :
              <Button size={isMobile ? 'small' : 'medium'} style={{ flex: '0 0 auto' }} variant='outlined' hidden={!this.state.displayCorrectAnswer} onClick={this.showCorrectAnswer}>Check Answer</Button>
            }

            <Button size={isMobile ? 'small' : 'medium'} style={{ flex: '0 0 auto' }} variant='outlined' hidden={true}>See the Answer</Button>


            <Button size={isMobile ? 'small' : 'medium'}
              style={{
                flex: '0 0 auto',
                pointerEvents: this.state.showSubmitLoader ? 'none' : 'auto'
              }}
              variant='contained'
              hidden={!this.state.submitButtonDisplay && !this.state.showSubmitLoader}
              disabled={this.state.randomCategory in this.state.pausedCategoriesMap}
              onClick={this.state.showSubmitLoader ? undefined : this.onSubmitClick}
              aria-label={this.state.showSubmitLoader ? "Submitting answer" : "Submit Answer"}
            >
              {this.state.showSubmitLoader ? (
                <>
                  <CircularProgress className='text-white' size={24} aria-hidden="true" />
                  <span className="sr-only">Submitting answer</span>
                </>
              ) : 'Submit Answer'}
            </Button>
            {this.state.showSubmitLoader || this.state.explanationGalleryVisible || this.state.isTutorial ? null :
              <Button size={isMobile ? 'small' : 'medium'} style={{ flex: '0 0 auto' }} variant='outlined' hidden={(!this.state.explanationButtonDisplay || this.state.explanations === null) && !(this.state.subcategoryTutorialMap[this.state.randomSubCategory]?.length > 0)} onClick={this.onExplanationClick}>
                <FaBookOpen className='mr-2' />
                {this.state.explanationGalleryVisible ? "Close Explanations" : "Explanations & Tutorials"}
              </Button>
            }
            {/* {this.state.showSubmitLoader || this.state.isTutorial ? "" :
              <Button size={isMobile ? 'small' : 'medium'} style={{ flex: '0 0 auto' }} variant='outlined' onClick={this.onTutorialsClick}>Tutorials</Button>
            } */}

            {this.state.showSubmitLoader ? "" :
              <Button size={isMobile ? 'small' : 'medium'} style={{ flex: '0 0 auto' }} variant='outlined' hidden={!this.state.feedbackButtonVisible} onClick={this.onFeedbackClick}>Feedback</Button>
            }
            {this.state.showSubmitLoader ? "" :
              <Button size={isMobile ? 'small' : 'medium'} style={{ flex: '0 0 auto' }} variant='contained'
                hidden={this.state.hideNext && !(this.state.randomCategory in this.state.pausedCategoriesMap)}
                onClick={this.onNextClick}>Next Question</Button>
            }
          </div>

        </Card>
        }
      </div >

    )
  }
}

const TestProgress = (props) => {

  let totalTimeSeconds = (props.totalTime * 60);
  let timeLeft = totalTimeSeconds - props.elapsedTime;
  let minutesLeft = Math.trunc(timeLeft / 60);
  let secondsLeft = (timeLeft % 60);
  let formattedSeconds = secondsLeft < 10 ? "0" + secondsLeft : secondsLeft;
  let progressBarVal = (props.completedQuestions / props.totalQuestions) * 100;

  let timerStyle = { 'display': 'none' }
  if (props.showTimer) {
    timerStyle = { 'display': 'block' }
  }

  return (
    <div className='pt-3 mb-4'>
      <div className='mb-2' style={timerStyle}>
        <Typography fontSize={14} color='primary'>Test closes in <strong>{minutesLeft}:{formattedSeconds}</strong> minutes</Typography>
      </div>
      <div className='d-flex justify-content-between mb-2'>
        <div>
          <Typography fontSize={14} fontWeight='bold' color='primary'>Progress</Typography>
        </div>
        <div className='d-flex' style={{ gap: '4px' }}>
          <Typography fontSize={14} fontWeight='bold' color='primary'>Completed</Typography>
          <Typography fontSize={14} fontWeight='regular' color='primary'>
            {props.completedQuestions}/{props.totalQuestions}
          </Typography>
        </div>
      </div>
      <LinearProgress variant="determinate" style={{ height: '8px' }} value={progressBarVal} />
    </div>
  );
}

